var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _g, _path81, _g2, _path82, _path83, _path84, _path85, _g3, _path86, _path87, _path88, _path89, _g4, _path90, _path91, _path92, _path93, _path94, _g5, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _g6, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _g7, _g8, _path138, _path139, _g9, _path140, _path141, _path142, _path143, _path144, _g10, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _g11, _path167, _path168, _g12, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _g13, _path176, _path177, _g14, _path178, _path179, _path180, _g15, _path181, _path182, _g16, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _g17, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _g18, _path429, _g19, _path430, _g20, _path431, _g21, _path432, _g22, _path433, _g23, _path434, _g24, _circle, _path435, _path436, _g25, _path437, _path438, _g26, _path439, _path440, _g27, _path441, _path442, _g28, _path443, _path444, _g29, _ellipse, _path445, _path446, _g30, _path447, _path448, _g31, _path449, _path450, _g32, _path451, _path452, _g33, _path453, _path454, _g34, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeroWebDevelopment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 530,
    viewBox: "0 0 800 530",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_39_780)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M770 0H30C13.4315 0 0 13.4315 0 30V500C0 516.569 13.4315 530 30 530H770C786.569 530 800 516.569 800 500V30C800 13.4315 786.569 0 770 0Z",
    fill: "#F9FDFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M289.934 558.28C469.413 621.447 666.116 527.157 729.283 347.678C792.45 168.199 698.161 -28.5038 518.682 -91.6708C339.203 -154.838 142.5 -60.5483 79.3327 118.931C16.1657 298.409 110.455 495.113 289.934 558.28ZM269.38 616.681C481.113 691.2 713.166 579.965 787.684 368.232C862.203 156.499 750.969 -75.5534 539.236 -150.072C327.503 -224.591 95.4501 -113.357 20.9314 98.3764C-53.5873 310.109 57.6469 542.162 269.38 616.681Z",
    fill: "#EFFAFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M275.385 136.723C275.465 136.501 275.56 136.282 275.671 136.067C277.023 133.451 280.241 132.426 282.858 133.779C285.474 135.132 286.499 138.349 285.146 140.966C283.793 143.582 280.576 144.607 277.959 143.254C276.185 142.337 275.143 140.563 275.077 138.699C246.114 135.216 190.556 144.435 164.346 207.318L162.5 206.549C189.177 142.545 245.819 133.151 275.385 136.723Z",
    fill: "#0A72A2",
    fillOpacity: 0.22
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M191.997 63.3346C189.052 63.3346 186.664 60.9468 186.664 58.0013C186.664 55.0558 189.052 52.668 191.997 52.668C194.289 52.668 196.242 54.1128 196.997 56.1412C211.657 53.923 232.377 52.8696 252.444 56.1015C274.983 59.7317 296.931 68.8107 308.356 87.9895L306.638 89.0131C295.664 70.5919 274.445 61.6709 252.126 58.0761C232.315 54.8852 211.821 55.9241 197.33 58.1136C197.27 61.0073 194.905 63.3346 191.997 63.3346Z",
    fill: "#0A72A2",
    fillOpacity: 0.22
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M392.714 106.604C399.887 86.5716 413.842 74.7925 424.599 70.082L425.401 71.9141C415.126 76.4136 401.577 87.7865 394.597 107.278C387.929 125.897 387.223 152.024 401.26 186.779C401.616 186.704 401.984 186.665 402.362 186.665C405.307 186.665 407.695 189.053 407.695 191.998C407.695 194.944 405.307 197.331 402.362 197.331C399.416 197.331 397.028 194.944 397.028 191.998C397.028 190.142 397.977 188.507 399.415 187.552C385.227 152.432 385.845 125.784 392.714 106.604Z",
    fill: "#0A72A2",
    fillOpacity: 0.22
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M519.797 132.732C521.424 122.357 519.92 112.591 518.046 106.808L519.949 106.191C521.909 112.241 523.454 122.325 521.773 133.042C520.307 142.386 516.38 152.249 508.105 160.313C508.566 161.102 508.831 162.02 508.831 163C508.831 165.945 506.443 168.333 503.497 168.333C500.552 168.333 498.164 165.945 498.164 163C498.164 160.054 500.552 157.666 503.497 157.666C504.739 157.666 505.882 158.091 506.789 158.803C514.642 151.111 518.389 141.712 519.797 132.732Z",
    fill: "#0A72A2",
    fillOpacity: 0.22
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M579.497 108.335C576.552 108.335 574.164 105.947 574.164 103.001C574.164 100.056 576.552 97.668 579.497 97.668C582.335 97.668 584.655 99.8841 584.821 102.68C596.218 104.429 611.8 108.513 626.752 115.879C644.136 124.444 660.787 137.504 668.918 156.61L667.077 157.393C659.207 138.898 643.025 126.126 625.868 117.673C611.138 110.417 595.777 106.389 584.566 104.664C583.868 106.795 581.862 108.335 579.497 108.335Z",
    fill: "#0A72A2",
    fillOpacity: 0.22
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M702.397 227.169C702.514 208.37 699.676 191.51 697.032 181.762L698.963 181.238C701.652 191.157 704.515 208.197 704.397 227.181C704.29 244.499 701.704 263.509 694.184 280.223C695.487 281.196 696.331 282.749 696.331 284.5C696.331 287.446 693.943 289.833 690.997 289.833C688.052 289.833 685.664 287.446 685.664 284.5C685.664 281.554 688.052 279.167 690.997 279.167C691.477 279.167 691.942 279.23 692.385 279.349C699.73 262.994 702.292 244.312 702.397 227.169Z",
    fill: "#0A72A2",
    fillOpacity: 0.22
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M650.053 458.124H681.762C685.397 458.124 688.914 456.845 691.696 454.512C694.477 452.179 696.344 448.942 696.967 445.371L705.362 397.285C706.305 391.886 709.127 386.99 713.334 383.462C717.54 379.935 722.86 378 728.356 378H760.224C762.379 378 764.508 378.471 766.462 379.378C768.415 380.285 770.146 381.607 771.533 383.252C772.92 384.897 773.929 386.824 774.491 388.899C775.052 390.975 775.15 393.147 774.781 395.264L765.99 445.611C765.048 451.007 762.227 455.898 758.024 459.422C753.821 462.946 748.505 464.878 743.013 464.877H642C642.33 462.986 643.319 461.272 644.791 460.036C646.265 458.801 648.127 458.124 650.053 458.124Z",
    fill: "#00C99C"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M738.016 464.871H741.668L748.27 530.827H744.618L738.016 464.871Z",
    fill: "#00C99C"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M708.789 464.871H712.44L719.043 530.827H715.391L708.789 464.871Z",
    fill: "#00C99C"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M739.923 464.871H711.344V468.278H739.923V464.871Z",
    fill: "#00C99C"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M684.262 464.871H680.61L674.008 530.827H677.659L684.262 464.871Z",
    fill: "#00C99C"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M681.727 464.871H653.148V468.278H681.727V464.871Z",
    fill: "#00C99C"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M524.511 199.629H290.695V311.964H524.511V199.629Z",
    fill: "#ABAEB0"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M395.978 260.842C395.978 269.015 393.547 277.004 388.995 283.799C384.442 290.594 377.971 295.891 370.4 299.018C362.829 302.146 354.498 302.965 346.46 301.37C338.423 299.776 331.04 295.84 325.245 290.061C319.45 284.282 315.504 276.919 313.906 268.904C312.307 260.887 313.127 252.579 316.264 245.029C319.399 237.478 324.711 231.024 331.524 226.484C338.338 221.943 346.349 219.52 354.544 219.52C365.532 219.52 376.072 223.873 383.842 231.623C391.612 239.372 395.978 249.883 395.978 260.842Z",
    fill: "#C5CFD6"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M526.005 309.086H289.195V316.659H526.005V309.086Z",
    fill: "#FFCB83"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M454.808 205.676H372.826C372.466 205.676 372.12 205.818 371.866 206.073C371.611 206.326 371.469 206.67 371.469 207.03C371.469 207.389 371.611 207.733 371.866 207.988C372.12 208.241 372.466 208.383 372.826 208.383H454.808C455.168 208.383 455.514 208.241 455.768 207.988C456.023 207.733 456.166 207.389 456.166 207.03C456.166 206.67 456.023 206.326 455.768 206.073C455.514 205.818 455.168 205.676 454.808 205.676Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M316.343 227.101C316.343 227.101 315.663 237.144 314.375 240.132C319.147 241.474 327.334 242.252 327.334 242.252C327.334 242.252 330.872 231.815 330.237 227.977C327.511 227.385 316.343 227.098 316.343 227.098",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M342.635 248.285C342.635 248.285 342.206 266.767 340.594 271.358C347.853 272.866 362.962 271.81 362.962 271.81C362.962 271.81 366 253.769 364.653 248.112C360.521 247.51 342.635 248.285 342.635 248.285Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M419.659 280.7C419.659 280.7 421.101 290.662 420.47 293.853C425.416 294.173 434.547 293.016 434.547 293.016C434.547 293.016 434.856 282.276 433.425 278.656C430.634 278.647 419.656 280.7 419.656 280.7",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M464.422 243.093C464.422 243.093 469.801 260.785 469.712 265.647C477.081 264.818 491.102 259.11 491.102 259.11C491.102 259.11 488.338 241.026 485.286 236.07C481.173 236.79 464.424 243.093 464.424 243.093",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M485.516 240.73C485.516 241.044 485.424 241.349 485.249 241.609C485.075 241.87 484.827 242.072 484.537 242.192C484.248 242.311 483.928 242.343 483.621 242.282C483.313 242.221 483.03 242.071 482.808 241.849C482.586 241.628 482.435 241.347 482.375 241.039C482.313 240.733 482.344 240.415 482.465 240.126C482.584 239.837 482.788 239.589 483.048 239.416C483.309 239.241 483.615 239.148 483.929 239.148C484.35 239.148 484.753 239.315 485.051 239.612C485.348 239.908 485.516 240.311 485.516 240.73Z",
    fill: "#E6E6E6"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M369.984 241.19C369.898 241.19 369.814 241.168 369.739 241.126C369.664 241.085 369.602 241.024 369.557 240.951C369.512 240.878 369.487 240.795 369.485 240.71C369.481 240.624 369.501 240.539 369.541 240.463C370.722 238.191 372.999 236.803 375.071 235.747C385.881 230.226 398.524 229.135 408.328 228.803C415.346 228.446 422.381 228.796 429.329 229.849C436.333 230.915 443.032 233.446 448.986 237.274C449.09 237.35 449.16 237.463 449.182 237.59C449.204 237.716 449.177 237.846 449.105 237.953C449.033 238.059 448.923 238.134 448.798 238.161C448.673 238.189 448.541 238.167 448.431 238.101C442.593 234.35 436.027 231.871 429.161 230.827C422.28 229.787 415.311 229.441 408.359 229.794C398.66 230.124 386.156 231.198 375.524 236.63C373.593 237.618 371.477 238.898 370.424 240.92C370.383 241.001 370.319 241.069 370.241 241.116C370.162 241.163 370.073 241.188 369.981 241.188",
    fill: "#E6E6E6"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M451.753 279.011C451.625 279.012 451.501 278.964 451.407 278.877C451.313 278.789 451.258 278.669 451.251 278.541C451.243 278.413 451.287 278.287 451.37 278.19C451.454 278.092 451.572 278.031 451.7 278.019C454.444 277.694 457.079 276.757 459.411 275.277C461.742 273.797 463.709 271.813 465.166 269.471C465.235 269.357 465.346 269.276 465.474 269.244C465.603 269.214 465.739 269.234 465.852 269.303C465.966 269.371 466.047 269.482 466.079 269.61C466.11 269.739 466.089 269.874 466.02 269.988C464.482 272.458 462.406 274.552 459.946 276.114C457.486 277.676 454.705 278.665 451.809 279.008C451.79 279.009 451.772 279.009 451.752 279.008",
    fill: "#E6E6E6"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M456.288 283.31H456.245C452.16 282.972 448.164 281.927 444.438 280.221C444.363 280.186 444.298 280.134 444.248 280.068C444.198 280.001 444.166 279.924 444.154 279.842C444.142 279.76 444.15 279.677 444.178 279.599C444.206 279.521 444.253 279.452 444.315 279.397C445.937 277.958 447.54 276.463 449.084 274.965C449.179 274.873 449.307 274.822 449.439 274.824C449.571 274.826 449.698 274.88 449.791 274.975C449.882 275.069 449.933 275.197 449.932 275.329C449.93 275.461 449.876 275.587 449.781 275.679C448.41 277.011 446.991 278.336 445.553 279.626C448.975 281.102 452.614 282.012 456.329 282.319C456.458 282.329 456.577 282.389 456.663 282.485C456.748 282.581 456.793 282.706 456.787 282.835C456.782 282.963 456.727 283.084 456.635 283.173C456.541 283.262 456.418 283.312 456.288 283.312",
    fill: "#E6E6E6"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M400.074 291.515C387.146 291.515 374.476 285.766 368.536 279.975C368.447 279.881 368.398 279.757 368.398 279.627C368.399 279.499 368.45 279.375 368.541 279.282C368.631 279.191 368.754 279.136 368.884 279.133C369.013 279.13 369.139 279.176 369.235 279.263C376.706 286.551 396.272 294.07 412.099 288.596C412.222 288.559 412.354 288.571 412.469 288.63C412.584 288.688 412.671 288.789 412.713 288.91C412.756 289.031 412.749 289.164 412.696 289.28C412.642 289.397 412.545 289.488 412.426 289.535C408.448 290.877 404.273 291.546 400.073 291.515",
    fill: "#E6E6E6"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M370.578 287.878C370.496 287.878 370.416 287.858 370.344 287.821C370.272 287.782 370.21 287.727 370.165 287.66C367.861 284.279 366.165 280.522 365.156 276.559C365.136 276.479 365.136 276.395 365.156 276.315C365.176 276.234 365.216 276.16 365.273 276.099C365.328 276.038 365.398 275.991 365.477 275.964C365.556 275.937 365.64 275.931 365.722 275.945C367.859 276.296 370.031 276.604 372.174 276.86C372.238 276.868 372.302 276.889 372.358 276.92C372.416 276.953 372.466 276.996 372.506 277.047C372.547 277.098 372.577 277.157 372.594 277.22C372.612 277.283 372.617 277.349 372.609 277.414C372.602 277.478 372.581 277.541 372.549 277.599C372.517 277.655 372.474 277.706 372.423 277.746C372.371 277.786 372.312 277.816 372.249 277.833C372.186 277.851 372.12 277.857 372.055 277.848C370.152 277.62 368.225 277.353 366.32 277.049C367.318 280.631 368.895 284.026 370.991 287.101C371.041 287.176 371.071 287.263 371.076 287.353C371.08 287.443 371.061 287.532 371.018 287.613C370.976 287.692 370.912 287.759 370.835 287.806C370.758 287.852 370.669 287.878 370.578 287.878Z",
    fill: "#E6E6E6"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M486.143 501.254H477.469V501.503H486.143V501.254Z",
    fill: "#EBEBEB"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M251.099 490.988H208V491.237H251.099V490.988Z",
    fill: "#BFBABA"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M266.303 490.988H259.984V491.237H266.303V490.988Z",
    fill: "#BFBABA"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M380.305 495.192H286.836V495.439H380.305V495.192Z",
    fill: "#BFBABA"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M435.061 360.051H219.047V474.265H435.061V360.051Z",
    fill: "#AEB1B4"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M429.821 365.27H224.281V469.037H429.821V365.27Z",
    fill: "#C5CFD6"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M247.268 365.27H224.281V469.037H247.268V365.27Z",
    fill: "#C5CFD6"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M448.098 360.051H435.062V474.265H448.098V360.051Z",
    fill: "#E6E6E6"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M429.821 414.363H224.281V419.935H429.821V414.363Z",
    fill: "#F0F0F0"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M233.203 482.541H228.695L226.469 474.266H233.202L233.203 482.541Z",
    fill: "#BBB9B9"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M420.906 482.541H425.416L427.642 474.266H420.909L420.906 482.541Z",
    fill: "#BBB9B9"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M250.784 482.541H246.273L244.047 474.266H250.78L250.784 482.541Z",
    fill: "#BCB5B5"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M438.484 482.541H442.993L445.219 474.266H438.486L438.484 482.541Z",
    fill: "#E6E6E6"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M253.815 369.063H242.875V414.364H253.815V369.063Z",
    fill: "#F0F0F0"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M283.059 369.063H253.812V414.364H283.059V369.063Z",
    fill: "#E0E0E0"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M263.523 374.25H257.359V414.369H263.523V374.25Z",
    fill: "#70CCF5"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M279.999 374.25H263.523V414.369H279.999V374.25Z",
    fill: "#EBEBEB"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M282.283 414.371H273.154L267.891 376.567H277.021L282.283 414.371Z",
    fill: "#70CCF5"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M282.278 414.371H306.686L301.422 376.567H277.016L282.278 414.371Z",
    fill: "#EBEBEB"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M324.408 435.949H313.469V469.041H324.408V435.949Z",
    fill: "#F0F0F0"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M340.642 435.949H324.406V469.041H340.642V435.949Z",
    fill: "#E0E0E0"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M336.421 428.918H330.258V469.037H336.421V428.918Z",
    fill: "#70CCF5"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M352.89 428.918H336.414V469.037H352.89V428.918Z",
    fill: "#EBEBEB"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M245.583 469.033H236.45L231.188 431.227H240.318L245.583 469.033Z",
    fill: "#FF6E53"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M245.575 469.033H269.983L264.72 431.227H240.312L245.575 469.033Z",
    fill: "#FAA595"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M336.111 403.461H290.688V414.371H336.111V403.461Z",
    fill: "#E6E6E6"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M352.892 403.461H336.117V414.371H352.892V403.461Z",
    fill: "#E0E0E0"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M352.891 404.703H337.586V413.129H352.891V404.703Z",
    fill: "#F0F0F0"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M338.909 394.953H293.484V403.461H338.909V394.953Z",
    fill: "#F0F0F0"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M355.682 394.953H338.906V403.461H355.682V394.953Z",
    fill: "#E6E6E6"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M355.68 395.918H340.375V402.487H355.68V395.918Z",
    fill: "#F0F0F0"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M397.745 457.289H348.82V469.04H397.745V457.289Z",
    fill: "#DBD6D6"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M415.81 457.289H397.742V469.04H415.81V457.289Z",
    fill: "#E0E0E0"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M415.811 458.629H399.328V467.703H415.811V458.629Z",
    fill: "#F0F0F0"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M395.175 438.621H355.617V448.122H395.175V438.621Z",
    fill: "#70CCF5"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M409.781 438.621H395.172V448.122H409.781V438.621Z",
    fill: "#E0E0E0"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M409.781 439.711H396.453V447.048H409.781V439.711Z",
    fill: "#DBD6D6"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M292.48 459.492H252.922V468.993H292.48V459.492Z",
    fill: "#70CCF5"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M307.077 459.492H292.469V468.993H307.077V459.492Z",
    fill: "#1D93CA"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M307.093 460.578H293.766V467.915H307.093V460.578Z",
    fill: "#70CCF5"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M400.753 448.129H351.828V457.291H400.753V448.129Z",
    fill: "#F0F0F0"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M418.818 448.129H400.75V457.291H418.818V448.129Z",
    fill: "#E6E6E6"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M418.827 449.168H402.344V456.243H418.827V449.168Z",
    fill: "#F0F0F0"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M366.879 379.426H358.016V416.13H366.879V379.426Z",
    fill: "#F0F0F0"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M390.571 379.426H366.875V416.13H390.571V379.426Z",
    fill: "#E0E0E0"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M386.479 383.625H377.969V416.13H386.479V383.625Z",
    fill: "#E6AF65"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M401.019 383.625H386.469V416.13H401.019V383.625Z",
    fill: "#FFCB83"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M269.625 343.973C269.625 348.237 271.323 352.326 274.347 355.341C277.37 358.356 281.471 360.05 285.746 360.05C290.022 360.05 294.122 358.356 297.146 355.341C300.169 352.326 301.867 348.237 301.867 343.973H269.625Z",
    fill: "#E0E0E0"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M294.578 347.66C294.578 350.947 295.887 354.099 298.218 356.423C300.548 358.747 303.708 360.053 307.004 360.053C310.3 360.053 313.461 358.747 315.792 356.423C318.121 354.099 319.431 350.947 319.431 347.66H294.578Z",
    fill: "#EBEBEB"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M598.579 516.213C598.579 522.436 511.963 527.484 405.117 527.484C298.272 527.484 211.656 522.441 211.656 516.213C211.656 509.985 298.272 504.942 405.117 504.942C511.963 504.942 598.579 509.986 598.579 516.213Z",
    fill: "#DBD6D6"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M494.894 505.033L502.365 502.615L497.72 485.044L490.25 487.462L494.894 505.033Z",
    fill: "#FFB573"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M502.474 501.629L494.081 504.346C493.938 504.385 493.817 504.48 493.745 504.61C493.671 504.739 493.653 504.891 493.692 505.033L495.441 511.788C495.552 512.137 495.799 512.428 496.124 512.596C496.45 512.765 496.829 512.798 497.18 512.69C500.085 511.693 501.426 511.071 505.117 509.876C507.388 509.142 512.877 507.48 516.012 506.463C519.076 505.471 518.055 502.389 516.632 502.536C510.263 503.209 506.557 502.639 503.91 501.669C503.449 501.497 502.944 501.482 502.473 501.627",
    fill: "#263238"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M490.25 487.477L497.724 485.058L500.114 494.115L492.64 496.535L490.25 487.477Z",
    fill: "black"
  }))), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M472.037 309.606C472.037 309.606 482.649 373.374 485.793 395.618C489.234 419.98 502.76 491.217 502.76 491.217L488.891 495.037C488.891 495.037 469.083 426 463.47 402.321C457.378 376.623 443.969 309.606 443.969 309.606H472.037Z",
    fill: "#043561"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M455.014 335.76C460.438 349.275 461.058 372.247 458.85 381.662C455.523 366.205 451.708 347.712 448.773 333.33C449.823 329.642 451.72 327.539 455.014 335.76Z",
    fill: "black"
  }))), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M488.539 495.316L503.393 491.235L503.106 485.202L486.383 490.968L488.539 495.316Z",
    fill: "#FF6E53"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M505.541 502.074C504.865 502.274 504.169 502.401 503.464 502.452C503.429 502.455 503.394 502.448 503.362 502.431C503.331 502.415 503.306 502.389 503.289 502.358C503.271 502.327 503.264 502.293 503.266 502.257C503.269 502.222 503.282 502.188 503.303 502.161C503.488 501.918 505.134 499.791 506.162 499.854C506.28 499.861 506.394 499.897 506.493 499.96C506.592 500.023 506.673 500.111 506.729 500.214C506.832 500.359 506.895 500.531 506.909 500.709C506.924 500.887 506.892 501.065 506.814 501.227C506.51 501.659 506.054 501.962 505.537 502.075L505.541 502.074ZM503.857 502.046C505.28 501.877 506.25 501.519 506.487 501.061C506.535 500.954 506.552 500.836 506.538 500.72C506.525 500.604 506.48 500.493 506.409 500.4C506.384 500.349 506.346 500.305 506.298 500.273C506.25 500.241 506.194 500.223 506.138 500.219C505.583 500.186 504.544 501.216 503.857 502.047",
    fill: "#407BFF"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M503.508 502.445C503.465 502.459 503.418 502.456 503.376 502.436C503.334 502.418 503.302 502.383 503.284 502.341C503.247 502.256 502.381 500.165 502.899 499.2C502.964 499.075 503.057 498.966 503.171 498.883C503.286 498.798 503.418 498.743 503.558 498.719C503.708 498.675 503.87 498.683 504.015 498.741C504.16 498.799 504.282 498.904 504.361 499.04C504.798 499.795 504.191 501.713 503.59 502.396C503.567 502.42 503.54 502.438 503.508 502.448V502.445ZM503.547 499.098C503.477 499.119 503.412 499.154 503.357 499.201C503.301 499.248 503.255 499.306 503.223 499.371C502.913 499.95 503.251 501.197 503.503 501.896C503.974 501.139 504.33 499.717 504.044 499.221C503.99 499.127 503.893 499.024 503.629 499.076C503.6 499.081 503.572 499.088 503.544 499.097",
    fill: "#407BFF"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M470.393 245.36C470.642 245.885 471.007 246.622 471.337 247.262L472.358 249.266C473.055 250.601 473.786 251.925 474.541 253.229C476.041 255.842 477.627 258.394 479.299 260.824C480.928 263.203 482.715 265.472 484.647 267.615C486.408 269.578 488.405 271.317 490.592 272.793L488.975 272.161C489.463 272.342 489.991 272.387 490.502 272.29C491.413 272.141 492.294 271.851 493.113 271.428C495.312 270.283 497.356 268.863 499.195 267.202C501.276 265.385 503.252 263.452 505.111 261.41C507.021 259.36 508.915 257.116 510.665 254.993L510.768 254.868C511.294 254.23 512.034 253.803 512.851 253.666C513.668 253.529 514.507 253.692 515.212 254.124C515.919 254.556 516.445 255.228 516.693 256.015C516.941 256.804 516.895 257.654 516.564 258.412C515.297 261.27 513.833 264.039 512.184 266.697C510.523 269.411 508.657 271.994 506.606 274.428C504.393 277.093 501.808 279.428 498.931 281.363C497.216 282.486 495.343 283.352 493.376 283.935C491.01 284.625 488.51 284.725 486.096 284.227C485.633 284.128 485.186 283.968 484.767 283.748L484.479 283.594C481.109 281.779 478.015 279.499 475.286 276.819C472.717 274.343 470.359 271.657 468.236 268.792C466.158 266.026 464.247 263.141 462.511 260.151C461.655 258.665 460.832 257.163 460.043 255.644C459.649 254.879 459.255 254.116 458.884 253.335C458.506 252.528 458.174 251.812 457.767 250.868C457.015 249.208 456.955 247.317 457.6 245.612C458.245 243.908 459.542 242.529 461.207 241.778C462.872 241.028 464.767 240.968 466.477 241.611C468.186 242.254 469.569 243.549 470.321 245.209L470.393 245.36Z",
    fill: "#FF6E53"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M475.089 265.207C471.761 256.394 464.694 256.246 461.633 258.585C461.854 258.997 462.087 259.409 462.321 259.822C463.984 262.706 465.805 265.496 467.778 268.179C469.794 270.939 472.014 273.545 474.417 275.978C475.183 276.728 475.963 277.467 476.78 278.184C477.066 273.791 476.49 269.383 475.084 265.209",
    fill: "black"
  }))), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M516.668 259.754L523.471 260.833L522.657 253.345C522.657 253.345 512.984 252.56 512.453 255.189L513.579 257.48C513.873 258.079 514.308 258.598 514.845 258.994C515.383 259.39 516.008 259.651 516.668 259.755",
    fill: "#FFB573"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M529.102 256.454L527.811 251.078L522.656 253.343L523.47 260.832L529.102 256.454Z",
    fill: "#FFB573"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M436.078 508.461H443.934L444.955 490.32H437.101L436.078 508.461Z",
    fill: "#FFB573"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M444.341 507.559H435.517C435.369 507.553 435.225 507.607 435.115 507.707C435.006 507.807 434.941 507.946 434.934 508.094L434.508 515.055C434.507 515.421 434.65 515.772 434.907 516.034C435.165 516.294 435.516 516.443 435.883 516.447C438.956 516.395 440.423 516.215 444.304 516.215C446.688 516.215 454.673 516.462 457.971 516.462C461.195 516.462 461.174 513.211 459.776 512.915C453.51 511.595 447.914 509.774 445.697 508.038C445.312 507.732 444.836 507.561 444.343 507.555",
    fill: "#263238"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M437.091 490.334H444.951L444.421 499.686H436.562L437.091 490.334Z",
    fill: "black"
  }))), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M456.697 309.206C456.697 309.206 456.021 377.668 454.747 400.097C453.353 424.657 447.789 497.428 447.789 497.428H433.405C433.405 497.428 432.41 426.641 431.543 402.324C430.608 375.93 429.586 309.204 429.586 309.204L456.697 309.206Z",
    fill: "#04457E"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M432.821 497.417H448.367L449.229 491.971L432.07 492.82L432.821 497.417Z",
    fill: "#FF6E53"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M447.126 508.919C446.42 508.901 445.717 508.807 445.032 508.639C444.998 508.631 444.966 508.613 444.942 508.587C444.917 508.562 444.901 508.53 444.894 508.495C444.887 508.461 444.891 508.425 444.904 508.392C444.917 508.36 444.939 508.332 444.968 508.312C445.224 508.137 447.443 506.622 448.401 506.996C448.511 507.039 448.608 507.109 448.682 507.199C448.757 507.291 448.807 507.399 448.827 507.514C448.881 507.685 448.889 507.866 448.848 508.04C448.808 508.214 448.722 508.375 448.598 508.504C448.176 508.821 447.65 508.968 447.124 508.918L447.126 508.919ZM445.534 508.373C446.939 508.652 447.974 508.609 448.343 508.245C448.421 508.158 448.475 508.052 448.497 507.936C448.52 507.822 448.511 507.703 448.472 507.593C448.464 507.537 448.441 507.483 448.407 507.439C448.371 507.394 448.324 507.359 448.271 507.339C447.754 507.136 446.448 507.796 445.537 508.375",
    fill: "#407BFF"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M445.073 508.651C445.044 508.651 445.014 508.644 444.988 508.63C444.96 508.616 444.937 508.595 444.92 508.569C444.903 508.543 444.892 508.514 444.889 508.483C444.881 508.387 444.704 506.135 445.498 505.372C445.598 505.273 445.721 505.198 445.856 505.154C445.991 505.109 446.134 505.097 446.274 505.117C446.43 505.123 446.581 505.18 446.701 505.28C446.821 505.38 446.904 505.517 446.937 505.67C447.119 506.525 445.947 508.159 445.164 508.625C445.136 508.642 445.104 508.651 445.07 508.651H445.073ZM446.144 505.475C446.071 505.474 445.999 505.487 445.931 505.515C445.863 505.543 445.802 505.584 445.751 505.635C445.278 506.089 445.214 507.38 445.235 508.124C445.916 507.548 446.698 506.307 446.578 505.747C446.556 505.641 446.493 505.514 446.229 505.483C446.201 505.479 446.172 505.478 446.144 505.478",
    fill: "#407BFF"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M426.085 246.429C425.968 245.772 425.984 245.098 426.133 244.447C426.282 243.796 426.56 243.183 426.952 242.641C427.343 242.099 427.839 241.641 428.412 241.295C428.984 240.948 429.62 240.721 430.283 240.625L430.374 240.611C432.906 240.241 436.085 239.861 439.2 239.713C445.146 239.375 451.106 239.375 457.052 239.713C459.797 239.968 462.478 240.422 464.618 240.834L464.703 240.85C466.041 241.121 467.281 241.75 468.287 242.671C469.295 243.59 470.031 244.766 470.419 246.073C472.98 254.687 476.037 272.269 472.036 309.602H430.024C429.728 305.861 430.564 293.69 429.95 278.188C429.482 266.375 427.374 253.646 426.085 246.429Z",
    fill: "#FF6E53"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M426.492 248.741C427.364 253.751 428.438 260.561 429.179 267.728C429.179 267.728 433.009 260.228 433.71 253.811C434.41 247.394 428.927 246.943 426.492 248.742",
    fill: "black"
  }))), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M438.516 239.752C438.516 239.752 441.856 245.613 450.62 248.108C458.346 243.891 456.21 239.646 456.21 239.646",
    fill: "#DBD6D6"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M456.209 239.653C451.017 238.427 450.107 235.225 450.456 231.707C450.539 230.825 450.677 229.95 450.869 229.086L444.364 223.697L439.585 219.744C440.91 225.482 442.404 235.933 438.516 239.758C438.516 239.758 441.735 245.05 450.62 244.571C458.125 244.166 456.21 239.652 456.21 239.652",
    fill: "#FFB573"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M450.219 244.6L448.733 242.712L445.297 245.419L450.219 244.6Z",
    fill: "#DBD6D6"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M447.223 248.746C447.223 248.746 447.356 245.097 448.739 242.716C446.117 241.981 439.438 238.132 439.438 238.132L436.953 239.651C437.933 241.798 439.353 243.717 441.121 245.284C442.89 246.851 444.968 248.031 447.223 248.746Z",
    fill: "white"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M450.219 244.6L451.94 242.712L455.142 245.419L450.219 244.6Z",
    fill: "#DBD6D6"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M454.329 248.116C453.694 246.25 452.896 244.442 451.945 242.715C454.565 241.981 453.689 238.29 453.689 238.29L456.481 239.46C456.481 239.46 460.892 246.003 454.33 248.118",
    fill: "white"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M450.915 246.348C451.028 246.8 450.907 247.219 450.647 247.282C450.386 247.345 450.082 247.036 449.965 246.582C449.849 246.128 449.974 245.712 450.236 245.648C450.497 245.584 450.799 245.903 450.915 246.348Z",
    fill: "#FF6E53"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M450.874 229.084C450.681 229.949 450.543 230.823 450.461 231.705C448.034 231.219 444.792 228.641 444.454 226.168C444.334 225.35 444.306 224.52 444.368 223.695L450.874 229.084Z",
    fill: "black"
  }))), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M457.219 214.909C460.454 215.674 461.024 208.013 459.029 204.213C457.424 201.158 452.999 202.272 451.841 203.549C450.685 204.825 454.377 213.456 454.377 213.456L457.219 214.909Z",
    fill: "#263238"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M437.612 211.497C439.273 219.114 439.856 223.643 444.367 227.115C445.821 228.261 447.561 228.988 449.4 229.219C451.238 229.449 453.105 229.174 454.798 228.423C456.491 227.671 457.946 226.473 459.005 224.957C460.064 223.441 460.687 221.665 460.808 219.821C461.403 212.729 458.585 201.463 450.549 199.306C448.821 198.793 446.989 198.743 445.234 199.159C443.481 199.576 441.868 200.445 440.558 201.68C439.246 202.914 438.285 204.471 437.768 206.193C437.251 207.915 437.197 209.743 437.612 211.493",
    fill: "#FFB573"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M440.195 218.148C442.597 217.946 445.516 212.921 442.005 207.452C440.14 204.549 435.985 205.521 434.818 206.788C431.649 210.229 437.354 216.694 437.354 216.694L440.195 218.148Z",
    fill: "#1B1B43"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M439.365 208.805C444.124 208.567 454.064 205.143 455.497 200.528C458.278 191.572 448.357 191.311 442.93 196.137C439.355 199.317 436.026 203.886 429.539 205.05C430.408 206.674 434.082 209.071 439.365 208.806",
    fill: "#1B1B43"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M437.62 210.069C440.967 209.501 444.703 206.384 445.326 202.998C446.535 196.428 442.024 198.058 438.06 201.882C435.607 204.248 434.841 206.872 430.352 208.24C431.104 209.315 433.906 210.701 437.62 210.069Z",
    fill: "#1B1B43"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M451.037 201.077C454.045 204.272 458.825 207.249 460.273 205.269C461.722 203.29 458.924 196.213 455.232 195.909C451.583 195.61 448.853 198.758 451.037 201.077Z",
    fill: "#1B1B43"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M435.854 219.44C437.09 220.928 438.804 221.944 440.706 222.314C443.116 222.725 443.657 220.499 442.432 218.349C441.33 216.414 438.75 213.869 436.599 214.437C434.479 214.997 434.301 217.568 435.858 219.44",
    fill: "#FFB573"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M449.669 212.248C449.764 212.874 450.18 213.34 450.587 213.292C450.995 213.243 451.253 212.698 451.158 212.072C451.061 211.447 450.646 210.98 450.237 211.029C449.828 211.078 449.572 211.623 449.669 212.248Z",
    fill: "#263238"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M456.77 211.406C456.866 212.031 457.281 212.498 457.69 212.449C458.099 212.401 458.356 211.855 458.261 211.23C458.164 210.605 457.749 210.138 457.34 210.187C456.931 210.235 456.674 210.781 456.77 211.406Z",
    fill: "#263238"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M454.57 211.984C455.619 213.809 456.907 215.487 458.401 216.971C457.447 218.136 455.482 217.888 455.482 217.888L454.57 211.984Z",
    fill: "#ED893E"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M453.157 219.876C452.422 219.885 451.693 219.746 451.014 219.466C450.334 219.188 449.718 218.775 449.203 218.252C449.17 218.216 449.153 218.167 449.157 218.118C449.16 218.069 449.182 218.023 449.22 217.991C449.238 217.975 449.259 217.962 449.283 217.954C449.306 217.946 449.329 217.943 449.354 217.945C449.378 217.946 449.402 217.953 449.423 217.964C449.446 217.975 449.465 217.99 449.481 218.008C450.049 218.568 450.738 218.99 451.495 219.242C452.253 219.494 453.058 219.57 453.849 219.463C453.874 219.458 453.9 219.459 453.925 219.465C453.949 219.47 453.973 219.482 453.994 219.497C454.014 219.512 454.032 219.53 454.044 219.553C454.057 219.575 454.065 219.599 454.068 219.624C454.072 219.649 454.069 219.675 454.062 219.7C454.055 219.724 454.042 219.747 454.026 219.766C454.009 219.786 453.988 219.802 453.966 219.812C453.943 219.824 453.918 219.83 453.893 219.832C453.648 219.861 453.403 219.875 453.156 219.875",
    fill: "#263238"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M447.122 210.23C447.059 210.23 446.997 210.214 446.941 210.183C446.855 210.136 446.791 210.056 446.765 209.962C446.737 209.867 446.749 209.766 446.796 209.679C447.069 209.163 447.466 208.72 447.952 208.393C448.438 208.065 448.996 207.861 449.579 207.799C449.678 207.794 449.774 207.828 449.847 207.894C449.921 207.96 449.964 208.052 449.97 208.151C449.974 208.249 449.94 208.345 449.874 208.419C449.807 208.491 449.715 208.535 449.617 208.54C449.161 208.596 448.725 208.761 448.347 209.022C447.969 209.283 447.66 209.632 447.448 210.038C447.416 210.096 447.368 210.144 447.31 210.178C447.254 210.212 447.188 210.23 447.122 210.23Z",
    fill: "#263238"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M459.726 208.615C459.665 208.616 459.606 208.601 459.552 208.573C459.499 208.545 459.453 208.504 459.418 208.454C459.161 208.054 458.816 207.718 458.408 207.472C458.001 207.225 457.542 207.076 457.067 207.034C456.969 207.034 456.874 206.995 456.804 206.926C456.735 206.856 456.695 206.762 456.695 206.663C456.695 206.565 456.735 206.471 456.804 206.401C456.874 206.331 456.969 206.292 457.067 206.292C457.664 206.333 458.242 206.512 458.757 206.815C459.272 207.118 459.709 207.537 460.033 208.038C460.071 208.093 460.092 208.158 460.096 208.226C460.1 208.292 460.085 208.36 460.053 208.419C460.022 208.479 459.975 208.528 459.917 208.564C459.859 208.598 459.793 208.617 459.726 208.617",
    fill: "#263238"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M435.352 253.007C435.422 252.955 435.39 252.982 435.39 252.982L435.355 253.014L435.249 253.11L434.993 253.342L434.44 253.883C434.063 254.265 433.673 254.667 433.297 255.086C432.544 255.935 431.796 256.821 431.097 257.758C429.673 259.654 428.405 261.662 427.302 263.762C425.049 268.095 423.432 272.73 422.502 277.522C422.271 278.521 422.126 279.537 422.068 280.561C422.019 281.601 422.07 282.644 422.222 283.675C422.575 286.026 423.17 288.336 423.996 290.566C425.832 295.437 428.098 300.136 430.767 304.607L430.867 304.784C431.277 305.493 431.419 306.326 431.267 307.131C431.113 307.935 430.677 308.659 430.036 309.169C429.394 309.68 428.59 309.945 427.769 309.916C426.949 309.887 426.166 309.565 425.563 309.01C423.377 306.982 421.357 304.786 419.519 302.44C417.647 300.077 415.962 297.572 414.479 294.948C412.907 292.158 411.678 289.19 410.819 286.107C410.353 284.426 410.048 282.702 409.911 280.962C409.805 279.206 409.862 277.445 410.081 275.7C410.39 272.61 410.963 269.552 411.791 266.559C412.609 263.518 413.698 260.558 415.046 257.711C416.406 254.82 418.045 252.068 419.941 249.494C420.905 248.183 421.943 246.926 423.048 245.73C423.615 245.127 424.191 244.525 424.817 243.943C425.133 243.65 425.454 243.358 425.795 243.065L426.33 242.613L427.036 242.055C428.494 240.997 430.311 240.552 432.095 240.815C433.879 241.079 435.489 242.03 436.578 243.464C437.666 244.898 438.148 246.701 437.917 248.485C437.688 250.269 436.766 251.892 435.35 253.005",
    fill: "#FF6E53"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M431.895 302.653L436.21 301.903L432.195 310.93C432.195 310.93 425.057 310.888 425.386 307.218L426.243 306.091C427.623 304.272 429.644 303.043 431.898 302.652",
    fill: "#FFB573"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M442.044 306.439L438.37 313.732L432.195 310.932L436.208 301.903L442.044 306.439Z",
    fill: "#FFB573"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M476 160.913L490.817 230.678L520.284 236.002L547.341 223.203L543.412 152L476 160.913Z",
    fill: "#21AAE9"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M480.227 164.848L493.285 226.334L519.256 231.025L543.103 219.745L539.645 156.99L480.227 164.848Z",
    fill: "white"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M520.845 175.007L505.331 175.534C498.83 175.756 493.761 181.211 494.009 187.72L494.591 203.007C494.839 209.516 500.31 214.612 506.812 214.392L522.325 213.863C528.826 213.643 533.896 208.187 533.648 201.678L533.065 186.391C532.817 179.882 527.346 174.786 520.845 175.007Z",
    fill: "#D4F2FF"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M506.92 204.715L501.793 195.902C501.596 195.564 501.492 195.179 501.492 194.788C501.492 194.397 501.596 194.013 501.793 193.674L506.92 184.862C507.117 184.523 507.4 184.241 507.742 184.046C508.083 183.85 508.47 183.747 508.864 183.747H519.114C519.508 183.747 519.895 183.85 520.237 184.046C520.578 184.241 520.862 184.523 521.059 184.862L526.184 193.674C526.381 194.013 526.484 194.397 526.484 194.788C526.484 195.179 526.381 195.564 526.184 195.902L521.059 204.715C520.862 205.053 520.578 205.335 520.237 205.53C519.896 205.726 519.508 205.829 519.114 205.829H508.864C508.47 205.829 508.083 205.726 507.742 205.53C507.401 205.335 507.117 205.053 506.92 204.715Z",
    fill: "url(#paint0_linear_39_780)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M517.363 206.009L520.565 206.038L525.16 198.262L521.268 194.397L521.132 194.356L514.318 187.592L512.92 189.622L514.092 190.785L511.11 191.863L509.945 194.805L508.802 193.67L506.742 195.466L517.363 206.009Z",
    fill: "black"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M513.984 190.322C511.499 190.322 509.484 192.321 509.484 194.789C509.484 197.256 511.499 199.255 513.984 199.255C516.469 199.255 518.483 197.255 518.483 194.789C518.483 192.322 516.468 190.322 513.984 190.322ZM513.984 198.177C512.098 198.177 510.57 196.66 510.57 194.789C510.57 192.917 512.098 191.399 513.984 191.399C515.87 191.399 517.398 192.917 517.398 194.789C517.398 196.66 515.87 198.177 513.984 198.177Z",
    fill: "white"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M521.048 194.263L519.172 193.681C519.252 194.047 519.292 194.421 519.292 194.795C519.292 195.059 519.272 195.321 519.233 195.582H521.047C521.215 195.533 521.327 195.43 521.327 195.276V194.572C521.327 194.419 521.215 194.312 521.047 194.267",
    fill: "white"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M513.992 189.526C514.361 189.526 514.729 189.564 515.091 189.64L514.418 187.785C514.369 187.618 514.265 187.507 514.111 187.507H513.829C513.675 187.507 513.568 187.618 513.522 187.785L512.938 189.631C513.285 189.561 513.638 189.526 513.992 189.526Z",
    fill: "white"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M508.692 194.788C508.692 194.406 508.734 194.033 508.812 193.674L506.936 194.255C506.768 194.301 506.656 194.407 506.656 194.561V195.265C506.656 195.418 506.768 195.522 506.936 195.571H508.751C508.712 195.315 508.692 195.051 508.692 194.784",
    fill: "white"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M515.593 193.331L515.163 193.757V193.756C515.013 193.607 514.835 193.488 514.638 193.407C514.441 193.326 514.231 193.285 514.018 193.286C513.588 193.286 513.178 193.453 512.872 193.757C512.569 194.059 512.398 194.468 512.398 194.895C512.398 195.321 512.569 195.73 512.872 196.032L512.442 196.459C512.648 196.664 512.893 196.827 513.163 196.938C513.432 197.049 513.722 197.106 514.013 197.106C515.24 197.106 516.237 196.116 516.237 194.898C516.237 194.29 515.987 193.738 515.585 193.339M514.714 195.511C514.514 195.711 514.246 195.811 513.986 195.811C513.851 195.811 513.717 195.784 513.592 195.733C513.467 195.682 513.353 195.606 513.258 195.511C513.065 195.319 512.956 195.059 512.956 194.788C512.956 194.516 513.065 194.256 513.258 194.064C513.459 193.864 513.726 193.765 513.986 193.765C514.122 193.765 514.256 193.791 514.381 193.842C514.506 193.894 514.619 193.969 514.714 194.064C514.907 194.256 515.016 194.516 515.016 194.788C515.016 195.059 514.907 195.319 514.714 195.511Z",
    fill: "white"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M381.533 259.727C381.533 262.095 380.829 264.41 379.51 266.378C378.191 268.347 376.316 269.882 374.123 270.788C371.928 271.694 369.515 271.931 367.187 271.469C364.858 271.007 362.719 269.867 361.04 268.193C359.361 266.518 358.217 264.385 357.754 262.063C357.291 259.741 357.529 257.333 358.437 255.145C359.346 252.957 360.885 251.088 362.859 249.772C364.833 248.457 367.154 247.755 369.528 247.755C372.712 247.755 375.766 249.016 378.017 251.261C380.269 253.507 381.533 256.552 381.533 259.727Z",
    fill: "#1B1B43"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M370.784 261.208C367.572 264.135 362.958 264.314 360.478 261.608C357.997 258.903 358.591 254.334 361.803 251.407C365.014 248.481 369.628 248.302 372.109 251.007C374.59 253.713 373.995 258.276 370.784 261.208Z",
    fill: "#21AAE9"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M361.93 257.037C361.93 259.238 361.275 261.39 360.049 263.22C358.823 265.051 357.08 266.477 355.04 267.32C353.001 268.162 350.757 268.383 348.592 267.953C346.428 267.523 344.439 266.464 342.877 264.906C341.317 263.35 340.254 261.366 339.824 259.208C339.393 257.048 339.614 254.811 340.459 252.777C341.304 250.743 342.735 249.005 344.57 247.782C346.405 246.559 348.563 245.906 350.77 245.906C353.73 245.906 356.569 247.08 358.662 249.167C360.755 251.254 361.931 254.084 361.931 257.037",
    fill: "#1B1B43"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M344.584 286.815C343.329 289.31 339.611 293.633 336.701 296.82C334.593 299.117 332.928 300.822 332.928 300.822L331.632 299.718L320.914 290.546C323.991 284.054 327.849 277.139 336.294 276.002C341.604 275.286 346.82 282.356 344.583 286.812",
    fill: "#FFCB83"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M294.86 288.093L296.199 280.753L287.219 281.095C287.219 281.095 288.973 287.007 291.299 289.647L294.86 288.093Z",
    fill: "#FF8B7B"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M293.74 277.396L287.086 278.891L287.22 281.099L296.201 280.757L293.74 277.396Z",
    fill: "#FF8B7B"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M350.474 512.411L341.812 513.219L341.962 493.522L350.623 492.713L350.474 512.411Z",
    fill: "#FF8B7B"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M396.304 508.298L387.776 509.599L382.562 490.409L391.091 489.107L396.304 508.298Z",
    fill: "#FF8B7B"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M386.354 506.449L395.862 504.513C396.023 504.476 396.191 504.5 396.335 504.58C396.479 504.661 396.587 504.792 396.639 504.948L399.048 512.187C399.101 512.375 399.114 512.571 399.086 512.764C399.06 512.957 398.993 513.143 398.89 513.309C398.788 513.476 398.653 513.619 398.492 513.73C398.331 513.841 398.149 513.919 397.958 513.956C394.632 514.575 393 514.708 388.819 515.558C386.247 516.082 380.623 517.616 377.072 518.339C373.598 519.046 372.711 515.617 374.134 515.003C380.515 512.238 383.128 509.571 385.032 507.254C385.368 506.843 385.835 506.56 386.355 506.45",
    fill: "#263238"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M340.875 510.655H351.069C351.25 510.655 351.427 510.717 351.569 510.828C351.712 510.94 351.814 511.096 351.857 511.272L353.846 519.311C353.894 519.504 353.895 519.705 353.853 519.899C353.809 520.093 353.722 520.274 353.598 520.429C353.474 520.584 353.316 520.709 353.136 520.794C352.956 520.879 352.759 520.922 352.56 520.919C348.968 520.952 347.266 520.668 342.785 520.668C340.028 520.668 332.895 520.936 329.087 520.936C325.363 520.936 324.69 517.182 326.239 516.841C333.191 515.316 337.232 513.214 339.421 511.208C339.82 510.847 340.34 510.648 340.879 510.651",
    fill: "#263238"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M341.961 493.522L341.883 503.675H350.543L350.629 492.712L341.961 493.522Z",
    fill: "black"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M391.086 489.11L382.555 490.414L385.246 500.304L393.777 499.003L391.086 489.11Z",
    fill: "black"
  }))), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M373.16 327.015C366.421 327.203 352.105 327.594 338.26 327.98C330.062 277.966 333.925 276.551 333.925 276.551C333.925 276.551 339.912 275.097 345.95 274.19C346.862 274.051 347.781 273.926 348.684 273.82C353.95 273.295 359.246 273.146 364.532 273.372C365.314 273.385 366.091 273.419 366.866 273.453C371.055 273.689 375.226 274.174 379.356 274.908C377.925 281.093 376.784 286.348 375.903 290.946C374.743 296.938 374.002 301.787 373.545 306.035C372.857 313.007 372.728 320.022 373.16 327.015Z",
    fill: "#FFCB83"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M362.095 262.614C361.869 266.889 362.313 271.314 364.545 273.372C364.545 273.372 362.305 283.927 349.584 290.126C341.422 280.012 348.696 273.813 348.696 273.813C354.383 272.302 354.494 268.541 352.959 262.315L357.486 260.459C357.887 260.087 358.39 259.843 358.93 259.759C359.471 259.674 360.025 259.754 360.52 259.985C361.016 260.216 361.43 260.591 361.71 261.059C361.991 261.528 362.125 262.069 362.095 262.614Z",
    fill: "#FF8B7B"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M357.479 260.458C357.856 260.11 358.322 259.875 358.826 259.779C359.33 259.682 359.851 259.729 360.329 259.913C360.808 260.097 361.225 260.41 361.534 260.82C361.843 261.228 362.031 261.715 362.076 262.224C360.055 265.308 357.129 267.695 353.698 269.06C353.975 267.264 353.62 265.021 352.953 262.313L357.479 260.458Z",
    fill: "black"
  }))), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M370.383 249.965C367.227 257.949 366.06 261.391 360.609 264.341C352.41 268.778 343.372 263.441 344.095 254.744C344.748 246.916 349.801 235.175 358.775 234.311C367.618 233.46 373.539 241.981 370.382 249.965",
    fill: "#FF8B7B"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M365.876 242.839C357.644 244.17 345.699 238.777 348 232.643C349.599 228.385 355.126 231.408 355.126 231.408C355.126 231.408 363.975 228.951 370.241 233.796C376.551 238.675 378.151 249.742 366.498 257.039C362.852 252.925 362.495 245.938 365.875 242.842",
    fill: "#1B1B43"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M369.747 258.083C368.869 259.498 367.479 260.521 365.865 260.94C363.73 261.47 362.779 259.565 363.476 257.604C364.101 255.836 365.962 253.43 368.056 253.773C370.12 254.111 370.807 256.339 369.747 258.088",
    fill: "#FF8B7B"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M338.273 327.984C338.273 327.984 334.492 379.844 334.5 413.358C334.5 440.002 340.282 499.698 340.282 499.698L352.782 498.464C352.782 498.464 354.841 434.396 352.417 415.39C360.135 377.894 374.243 342.232 366.344 327.02L338.273 327.984Z",
    fill: "#043561"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M354.809 495.417L338.328 495.917L339.23 501.53L354.644 501.297L354.809 495.417Z",
    fill: "#FFCB83"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M358.007 347.19L353.908 351.747C349.994 363.371 352.593 379.51 357.263 394.487C362.032 375.612 367.07 358.197 368.341 344.888C368.362 344.109 368.375 343.706 368.375 343.706L358.007 347.19Z",
    fill: "black"
  }))), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M345.883 327.879C345.883 327.879 358.535 385.062 363.703 418.046C372.009 444.665 382.4 495.977 382.4 495.977L393.942 493.22C393.942 493.22 388.621 432.365 382.104 413.358C381.735 375.864 384.341 342.232 373.164 327.02L345.883 327.879Z",
    fill: "#04457E"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M381.41 498.683L396.052 495.759L395.862 489.828L379.516 493.59L381.41 498.683Z",
    fill: "#FFCB83"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M357.72 248.709C357.503 249.371 356.979 249.804 356.549 249.674C356.119 249.545 355.949 248.905 356.162 248.241C356.374 247.578 356.903 247.146 357.333 247.276C357.763 247.405 357.933 248.045 357.72 248.709Z",
    fill: "#263238"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M350.284 246.472C350.067 247.135 349.543 247.567 349.111 247.437C348.68 247.309 348.512 246.668 348.725 246.004C348.938 245.34 349.466 244.91 349.896 245.039C350.326 245.168 350.496 245.809 350.284 246.472Z",
    fill: "#263238"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M350.072 245.142L348.641 244.209C348.641 244.209 349.046 245.696 350.072 245.142Z",
    fill: "#263238"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M350.775 247.687C349.695 249.022 348.441 250.205 347.047 251.209C347.305 251.552 347.637 251.832 348.017 252.031C348.398 252.229 348.819 252.341 349.248 252.357L350.775 247.687Z",
    fill: "#FF5652"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M351.398 255.993C351.368 255.967 351.346 255.933 351.336 255.894C351.325 255.857 351.326 255.816 351.338 255.778C351.354 255.727 351.391 255.684 351.439 255.658C351.486 255.633 351.543 255.626 351.595 255.641C352.42 255.901 353.294 255.965 354.148 255.831C355.003 255.696 355.814 255.366 356.519 254.865C356.56 254.831 356.613 254.815 356.666 254.82C356.72 254.825 356.768 254.851 356.803 254.892C356.837 254.933 356.853 254.986 356.849 255.039C356.843 255.092 356.817 255.141 356.776 255.175C356.023 255.726 355.149 256.091 354.227 256.239C353.305 256.389 352.36 256.316 351.471 256.03C351.445 256.022 351.421 256.009 351.401 255.992",
    fill: "#263238"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M359.282 246.39C359.229 246.344 359.188 246.285 359.166 246.219C359.014 245.739 358.749 245.302 358.391 244.946C358.034 244.591 357.595 244.326 357.113 244.177C357.061 244.165 357.013 244.143 356.969 244.113C356.926 244.081 356.89 244.042 356.862 243.997C356.835 243.952 356.817 243.902 356.809 243.85C356.801 243.797 356.804 243.743 356.817 243.693C356.843 243.587 356.91 243.496 357.002 243.439C357.095 243.382 357.207 243.362 357.313 243.385C357.926 243.562 358.487 243.887 358.945 244.331C359.402 244.776 359.743 245.327 359.936 245.934C359.97 246.037 359.962 246.15 359.914 246.247C359.866 246.344 359.781 246.419 359.678 246.456C359.612 246.481 359.54 246.488 359.47 246.477C359.399 246.465 359.333 246.435 359.279 246.389",
    fill: "#263238"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M346.797 241.729C346.789 241.705 346.782 241.681 346.778 241.656C346.762 241.549 346.787 241.44 346.85 241.351C346.913 241.263 347.008 241.202 347.115 241.182C347.741 241.041 348.394 241.056 349.013 241.225C349.634 241.393 350.203 241.71 350.673 242.148C350.748 242.227 350.788 242.333 350.785 242.442C350.782 242.551 350.735 242.654 350.656 242.729C350.576 242.803 350.47 242.844 350.36 242.841C350.251 242.837 350.148 242.791 350.073 242.711C349.695 242.371 349.241 242.127 348.748 241.999C348.256 241.871 347.739 241.864 347.243 241.978C347.15 241.997 347.055 241.982 346.973 241.937C346.89 241.891 346.827 241.817 346.794 241.729",
    fill: "#263238"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M382.147 508.453C382.105 508.433 382.064 508.412 382.025 508.388C381.86 508.283 381.725 508.136 381.635 507.962C381.545 507.789 381.502 507.595 381.51 507.399C381.5 507.276 381.523 507.153 381.574 507.04C381.627 506.928 381.708 506.831 381.81 506.76C382.716 506.118 385.582 507.239 385.903 507.369C385.939 507.383 385.971 507.409 385.992 507.441C386.014 507.474 386.025 507.513 386.025 507.552C386.025 507.591 386.014 507.631 385.991 507.665C385.97 507.699 385.939 507.725 385.903 507.742C384.897 508.202 383.111 508.885 382.153 508.453H382.147ZM385.284 507.575C384.125 507.158 382.516 506.752 382.039 507.09C381.995 507.122 381.96 507.165 381.938 507.215C381.916 507.266 381.909 507.322 381.918 507.376C381.909 507.506 381.935 507.636 381.993 507.753C382.051 507.869 382.139 507.969 382.248 508.041C382.746 508.342 383.863 508.167 385.284 507.575Z",
    fill: "#407BFF"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M385.531 507.67C384.589 507.242 382.995 505.893 383.016 504.979C383.021 504.816 383.081 504.66 383.185 504.535C383.29 504.41 383.433 504.323 383.592 504.288C383.739 504.236 383.896 504.218 384.051 504.234C384.207 504.25 384.356 504.3 384.489 504.38C385.553 505.001 385.993 507.414 386.011 507.516C386.017 507.552 386.014 507.588 386.002 507.622C385.99 507.656 385.97 507.685 385.943 507.709C385.915 507.732 385.883 507.749 385.847 507.756C385.813 507.764 385.776 507.762 385.742 507.75C385.677 507.73 385.606 507.702 385.531 507.665V507.67ZM384.201 504.69C384.047 504.62 383.871 504.612 383.711 504.669C383.462 504.755 383.426 504.876 383.424 504.974C383.41 505.573 384.611 506.738 385.53 507.212C385.34 506.416 384.91 505.098 384.276 504.732C384.252 504.718 384.227 504.705 384.202 504.694",
    fill: "#407BFF"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M336.304 512.339C335.611 512.391 334.92 512.225 334.328 511.865C334.175 511.751 334.052 511.604 333.967 511.434C333.882 511.264 333.838 511.078 333.838 510.888C333.83 510.78 333.85 510.672 333.898 510.575C333.946 510.478 334.019 510.395 334.11 510.336C335.053 509.712 338.477 511.284 339.154 511.605C339.193 511.624 339.223 511.653 339.244 511.691C339.263 511.728 339.27 511.77 339.264 511.812C339.258 511.854 339.239 511.893 339.21 511.925C339.181 511.956 339.143 511.977 339.101 511.987C338.184 512.2 337.247 512.318 336.305 512.339H336.304ZM334.73 510.586C334.591 510.576 334.452 510.606 334.329 510.672C334.296 510.693 334.271 510.721 334.256 510.755C334.241 510.79 334.237 510.827 334.243 510.864C334.241 510.995 334.271 511.125 334.329 511.242C334.388 511.359 334.473 511.462 334.579 511.54C335.163 511.992 336.571 512.053 338.404 511.711C337.245 511.145 336.004 510.764 334.727 510.581",
    fill: "#407BFF"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M339.059 511.985C339.033 511.985 339.006 511.98 338.982 511.97C337.844 511.499 335.576 509.644 335.734 508.687C335.769 508.478 335.921 508.213 336.445 508.151C338.48 507.911 339.232 511.581 339.263 511.738C339.27 511.775 339.268 511.812 339.254 511.848C339.242 511.883 339.219 511.914 339.19 511.937C339.153 511.968 339.107 511.985 339.059 511.985ZM336.62 508.546C336.574 508.546 336.528 508.549 336.482 508.554C336.269 508.58 336.151 508.64 336.139 508.742C336.049 509.298 337.61 510.763 338.764 511.406C338.52 510.519 337.844 508.546 336.62 508.546Z",
    fill: "#407BFF"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M357.517 247.371L356.086 246.438C356.086 246.438 356.49 247.925 357.517 247.371Z",
    fill: "#263238"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M380.665 280.459C381.579 281.842 382.315 283.085 383.066 284.423C383.803 285.743 384.512 287.076 385.195 288.42C386.531 291.128 387.75 293.894 388.828 296.738C389.928 299.595 390.843 302.52 391.567 305.495C391.769 306.235 391.904 307.007 392.073 307.76C392.243 308.514 392.396 309.274 392.509 310.052C392.621 310.829 392.766 311.549 392.872 312.407L393.001 313.781L393.019 315.129C392.881 318.504 392.177 321.831 390.935 324.974C389.791 327.917 388.397 330.757 386.771 333.465C385.177 336.133 383.443 338.673 381.619 341.13C379.766 343.577 377.785 345.925 375.685 348.165L372.375 345.442C373.97 343.102 375.581 340.624 377.019 338.133C378.493 335.677 379.844 333.15 381.065 330.56C382.263 328.06 383.273 325.477 384.088 322.828C384.461 321.574 384.76 320.298 384.982 319.008C385.166 317.811 385.246 316.601 385.221 315.391L385.169 314.547L385.052 313.745C384.95 313.16 384.773 312.445 384.64 311.801C384.51 311.139 384.335 310.48 384.15 309.824C383.966 309.167 383.815 308.507 383.597 307.857C382.816 305.237 381.795 302.671 380.777 300.105C379.734 297.546 378.534 295.037 377.261 292.57C376.637 291.33 375.984 290.104 375.312 288.892C374.64 287.71 373.917 286.45 373.27 285.396L380.665 280.459Z",
    fill: "#FF8B7B"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M379.362 274.904C383.543 275.903 388.439 288.416 388.439 288.416L376.255 297.965C376.255 297.965 369.182 287.691 370.116 282.189C370.91 277.519 374.033 273.637 379.361 274.904",
    fill: "#FFCB83"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M288.586 281.089L287 378.086L324.455 394.068L364.229 385.287L380.692 289.679L288.586 281.089Z",
    fill: "#21AAE9"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M362.734 351.876L368.124 355.828L373.115 352.083L367.098 345.607L362.734 351.876Z",
    fill: "#FF8B7B"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M374.468 343.28L367.094 345.606L373.11 352.081C373.11 352.081 376.765 348.88 377.257 345.341L374.468 343.28Z",
    fill: "#FF8B7B"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M295.907 290.227L294.578 371.533L325.974 384.929L359.313 377.568L373.119 297.425L295.907 290.227Z",
    fill: "white"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M344.435 311.393L318.732 310.02C311.161 309.615 304.71 315.393 304.321 322.926L303.018 348.173C302.63 355.706 308.452 362.141 316.022 362.545L341.726 363.918C349.295 364.323 355.747 358.545 356.136 351.012L357.438 325.765C357.826 318.232 352.005 311.798 344.435 311.393Z",
    fill: "#D4F2FF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_39_780",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 313,
    y: 320,
    width: 34,
    height: 34
  }, _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M347 320H313V354H347V320Z",
    fill: "#D9D9D9"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_39_780)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M327.04 330.685C327.095 330.628 327.125 330.552 327.125 330.472C327.125 330.393 327.095 330.317 327.04 330.26L324.131 327.312C324.075 327.257 324 327.226 323.922 327.226C323.844 327.226 323.768 327.257 323.712 327.312L314.359 336.786C314.304 336.843 314.273 336.919 314.273 336.998C314.273 337.077 314.304 337.153 314.359 337.21L323.712 346.689C323.768 346.744 323.843 346.775 323.921 346.775C324 346.775 324.075 346.744 324.131 346.689L327.04 343.741C327.094 343.684 327.125 343.608 327.125 343.528C327.125 343.449 327.094 343.373 327.04 343.316L321.021 337.214C320.966 337.157 320.935 337.081 320.935 337.002C320.935 336.923 320.966 336.847 321.021 336.79L327.04 330.685ZM336.289 327.311C336.233 327.256 336.158 327.225 336.08 327.225C336.002 327.225 335.927 327.256 335.871 327.311L326.53 336.773C326.475 336.83 326.445 336.906 326.445 336.985C326.445 337.064 326.475 337.14 326.53 337.197L329.439 340.15C329.495 340.206 329.57 340.237 329.649 340.237C329.727 340.237 329.802 340.206 329.858 340.15L335.871 334.058C335.927 334.003 336.002 333.972 336.08 333.972C336.158 333.972 336.233 334.003 336.289 334.058L338.981 336.786C339.036 336.843 339.066 336.919 339.066 336.998C339.066 337.077 339.036 337.153 338.981 337.21L332.962 343.31C332.907 343.367 332.876 343.443 332.876 343.522C332.876 343.602 332.907 343.678 332.962 343.735L335.871 346.683C335.927 346.738 336.002 346.769 336.08 346.769C336.158 346.769 336.233 346.738 336.289 346.683L345.638 337.209C345.693 337.152 345.723 337.076 345.723 336.997C345.723 336.918 345.693 336.842 345.638 336.785L336.289 327.311Z",
    fill: "#F93535"
  }))), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M324.265 85.6332H285.269C276.561 85.6332 269.5 92.6748 269.5 101.359V139.907C269.5 148.593 276.561 155.633 285.269 155.633H324.265C332.973 155.633 340.033 148.593 340.033 139.907V101.359C340.033 92.6748 332.973 85.6332 324.265 85.6332Z",
    fill: "#D5F2FF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_39_780",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 284,
    y: 100,
    width: 41,
    height: 41
  }, _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M324.5 100.633H284.5V140.633H324.5V100.633Z",
    fill: "#D9D9D9"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_39_780)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M322.942 128.94L322.98 128.426C322.991 128.221 311.332 116.543 311.332 116.543H311.055C311.055 116.543 322.872 129.702 322.944 128.94H322.942Z",
    fill: "url(#paint1_linear_39_780)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.068 124.888L298.021 124.996L297.971 125.108C297.599 125.926 303.174 131.679 303.622 130.981L303.684 130.886L303.751 130.779C304.11 130.205 298.227 124.516 298.068 124.89V124.888Z",
    fill: "url(#paint2_linear_39_780)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.949 132.979C305.935 133.016 305.821 133.216 305.719 133.322C305.701 133.358 311.161 139.074 311.161 139.074H311.653C311.653 139.074 306.528 133.221 305.949 132.979Z",
    fill: "url(#paint3_linear_39_780)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.99 128.321C322.734 134.297 318.052 139.074 312.331 139.074H311.558L305.844 133.132C306.314 132.433 306.751 131.708 307.14 130.952H312.331C313.973 130.952 315.309 129.542 315.309 127.808C315.309 126.075 313.973 124.665 312.331 124.665H309.259C309.494 123.359 309.621 122.012 309.621 120.634C309.621 119.235 309.491 117.869 309.249 116.542H311.157L322.955 128.816C322.969 128.651 322.981 128.486 322.99 128.321ZM289.104 102.133H286V110.256H289.104C294.525 110.256 298.936 114.911 298.936 120.634C298.936 122.141 298.625 123.63 298.022 124.996L303.684 130.888C305.609 127.855 306.634 124.286 306.631 120.635C306.631 110.433 298.768 102.133 289.104 102.133Z",
    fill: "url(#paint4_linear_39_780)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.334 102.133H299.766C302.836 104.112 305.377 106.918 307.11 110.256H312.334C313.976 110.256 315.312 111.665 315.312 113.399C315.312 115.133 313.976 116.542 312.334 116.542H311.16L322.958 128.817C322.986 128.484 323.003 128.149 323.003 127.808C323.003 125.07 322.073 122.558 320.527 120.603C322.073 118.649 323.003 116.137 323.003 113.399C323.005 107.187 318.218 102.133 312.334 102.133Z",
    fill: "url(#paint5_linear_39_780)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.558 139.075H299.852C302.209 137.538 304.245 135.51 305.844 133.133L311.558 139.075ZM303.684 130.886L298.022 124.994C296.458 128.543 293.049 131.012 289.104 131.012H286V139.133H289.104C295.176 139.133 300.54 135.853 303.684 130.885V130.886Z",
    fill: "url(#paint6_linear_39_780)"
  }))), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M570.022 73.0226H532.979C524.707 73.0226 518 79.7116 518 87.9613V124.578C518 132.829 524.707 139.517 532.979 139.517H570.022C578.294 139.517 585 132.829 585 124.578V87.9613C585 79.7116 578.294 73.0226 570.022 73.0226Z",
    fill: "#D5F2FF"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M545.405 97.8342C545.482 97.7894 545.568 97.7675 545.655 97.7675C545.742 97.7675 545.827 97.7894 545.905 97.8342L550.067 100.226C550.223 100.316 550.318 100.488 550.318 100.668V105.469C550.318 105.648 550.223 105.812 550.067 105.902L545.905 108.303C545.75 108.392 545.56 108.392 545.405 108.303L541.242 105.902C541.087 105.812 540.992 105.648 540.992 105.469V100.668C540.992 100.489 541.087 100.316 541.242 100.226L545.405 97.8342Z",
    fill: "#83CD29"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M570.499 102.06C570.514 102.052 570.533 102.052 570.549 102.052C570.566 102.052 570.576 102.051 570.591 102.06L571.392 102.526C571.421 102.544 571.442 102.575 571.442 102.61V103.527C571.442 103.561 571.421 103.593 571.392 103.61L570.591 104.068C570.561 104.086 570.529 104.086 570.499 104.068L569.699 103.61C569.668 103.593 569.648 103.561 569.648 103.527V102.61C569.648 102.575 569.668 102.544 569.699 102.526L570.499 102.06Z",
    fill: "#83CD29"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M559.936 91.7102C559.893 91.7107 559.85 91.721 559.811 91.7435C559.734 91.7885 559.686 91.8713 559.686 91.9603V98.3363C559.686 98.399 559.657 98.455 559.603 98.4864C559.548 98.5179 559.482 98.5179 559.427 98.4864L558.385 97.8863C558.23 97.7967 558.04 97.7968 557.884 97.8863L553.722 100.287C553.567 100.376 553.472 100.549 553.472 100.729V105.529C553.472 105.709 553.567 105.873 553.722 105.963L557.884 108.363C558.04 108.453 558.229 108.453 558.385 108.363L562.547 105.963C562.703 105.873 562.797 105.709 562.797 105.529V93.5605C562.797 93.3784 562.698 93.2076 562.539 93.1188L560.061 91.7352C560.023 91.7135 559.979 91.7098 559.936 91.7102ZM533.161 97.7029C533.082 97.7061 533.007 97.7199 532.936 97.7612L528.774 100.162C528.619 100.251 528.523 100.414 528.523 100.595L528.532 107.038C528.532 107.128 528.578 107.211 528.657 107.255C528.734 107.301 528.83 107.301 528.907 107.255L531.376 105.838C531.533 105.745 531.635 105.583 531.635 105.404V102.395C531.635 102.216 531.729 102.051 531.885 101.962L532.936 101.354C533.014 101.308 533.099 101.287 533.186 101.287C533.272 101.287 533.36 101.308 533.436 101.354L534.487 101.962C534.643 102.051 534.738 102.216 534.738 102.395V105.404C534.738 105.583 534.841 105.746 534.996 105.838L537.465 107.255C537.543 107.301 537.639 107.301 537.715 107.255C537.792 107.211 537.841 107.128 537.841 107.038L537.849 100.595C537.849 100.414 537.755 100.251 537.599 100.162L533.436 97.7612C533.366 97.7199 533.291 97.7061 533.211 97.7029H533.161ZM570.563 97.7612C570.476 97.7611 570.391 97.7831 570.313 97.8279L566.15 100.228C565.995 100.318 565.9 100.482 565.9 100.662V105.463C565.9 105.643 566.002 105.807 566.159 105.896L570.288 108.246C570.44 108.333 570.626 108.34 570.78 108.255L573.282 106.863C573.362 106.819 573.415 106.737 573.416 106.646C573.416 106.556 573.369 106.474 573.291 106.429L569.103 104.029C569.025 103.984 568.97 103.894 568.97 103.804V102.304C568.97 102.214 569.026 102.132 569.103 102.087L570.404 101.337C570.482 101.292 570.577 101.292 570.655 101.337L571.956 102.087C572.034 102.132 572.081 102.214 572.081 102.304V103.487C572.081 103.577 572.128 103.659 572.206 103.704C572.284 103.749 572.379 103.749 572.456 103.704L574.95 102.254C575.105 102.164 575.201 101.999 575.201 101.82V100.662C575.201 100.483 575.106 100.318 574.95 100.228L570.813 97.8278C570.735 97.7827 570.65 97.7614 570.563 97.7612ZM558.118 101.345C558.14 101.345 558.165 101.351 558.185 101.362L559.611 102.187C559.65 102.209 559.678 102.251 559.678 102.295V103.946C559.678 103.99 559.65 104.032 559.611 104.054L558.185 104.879C558.146 104.901 558.098 104.901 558.06 104.879L556.633 104.054C556.594 104.032 556.566 103.99 556.566 103.946V102.295C556.566 102.251 556.594 102.209 556.633 102.187L558.06 101.362C558.079 101.351 558.096 101.345 558.118 101.345Z",
    fill: "#404137"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M543.013 122.741V112.536H543.568V114.141C543.633 114.07 543.694 113.994 543.749 113.915C544.212 112.955 545.189 112.35 546.255 112.362C547.519 112.324 548.546 112.792 549.15 113.915C549.534 114.612 549.745 115.392 549.766 116.188C549.787 116.983 549.617 117.773 549.271 118.49C548.708 119.748 547.319 120.374 545.832 120.144C545.369 120.105 544.923 119.951 544.536 119.695C544.148 119.44 543.83 119.091 543.612 118.682V122.741H543.013ZM543.568 116.146L543.692 117.344C543.911 118.708 544.719 119.514 545.987 119.666C546.582 119.763 547.194 119.652 547.716 119.35C548.238 119.048 548.64 118.575 548.852 118.011C549.345 116.837 549.309 115.509 548.754 114.363C548.528 113.857 548.143 113.439 547.657 113.171C547.172 112.903 546.612 112.8 546.063 112.878C545.547 112.915 545.056 113.112 544.658 113.441C544.259 113.77 543.974 114.215 543.84 114.713C543.722 115.185 543.631 115.663 543.568 116.145V116.146ZM561.087 117.533C561.003 118.251 560.66 118.915 560.123 119.4C559.585 119.885 558.89 120.159 558.165 120.171C555.84 120.288 554.749 118.746 554.576 116.967C554.455 116.001 554.612 115.021 555.029 114.141C555.318 113.537 555.793 113.041 556.384 112.724C556.975 112.408 557.652 112.287 558.316 112.381C558.947 112.434 559.546 112.685 560.027 113.097C560.508 113.509 560.847 114.061 560.996 114.676C561.114 115.236 561.201 115.802 561.256 116.372H555.15C555.037 117.985 555.905 119.282 557.135 119.594C558.668 119.971 559.978 119.308 560.453 117.853C560.559 117.48 560.751 117.427 561.091 117.533H561.087ZM555.146 115.856H560.607C560.573 114.137 559.502 112.889 558.048 112.874C556.407 112.848 555.217 114.047 555.146 115.856ZM562.216 117.57H562.751C562.771 117.964 562.899 118.345 563.121 118.671C563.344 118.997 563.652 119.255 564.012 119.417C564.464 119.62 564.955 119.719 565.451 119.706C565.946 119.693 566.432 119.568 566.873 119.342C567.113 119.234 567.314 119.055 567.449 118.829C567.584 118.603 567.647 118.342 567.628 118.079C567.642 117.826 567.572 117.576 567.431 117.365C567.289 117.155 567.083 116.997 566.843 116.915C566.254 116.696 565.627 116.575 565.027 116.383C564.403 116.206 563.792 115.983 563.2 115.716C562.233 115.245 562.174 113.41 563.268 112.829C563.829 112.513 564.46 112.342 565.103 112.333C565.747 112.323 566.382 112.474 566.952 112.772C567.659 113.162 568.05 113.949 567.934 114.747H567.475C567.475 114.725 567.433 114.706 567.433 114.683C567.376 113.222 566.146 112.765 564.825 112.893C564.426 112.937 564.048 113.058 563.693 113.236C563.479 113.333 563.302 113.494 563.184 113.697C563.066 113.899 563.015 114.133 563.036 114.366C563.037 114.6 563.11 114.827 563.245 115.017C563.38 115.208 563.571 115.352 563.791 115.429C564.368 115.64 564.98 115.776 565.576 115.942L567.018 116.318C567.346 116.425 567.633 116.63 567.842 116.903C568.051 117.177 568.171 117.508 568.188 117.852C568.303 118.625 567.909 119.384 567.21 119.736C565.95 120.448 563.874 120.26 562.949 119.36C562.476 118.885 562.211 118.239 562.216 117.57ZM574.981 114.748H574.479C574.479 114.68 574.452 114.615 574.445 114.563C574.437 114.187 574.299 113.826 574.056 113.539C573.813 113.252 573.478 113.057 573.108 112.988C572.41 112.788 571.666 112.824 570.991 113.09C570.724 113.166 570.489 113.326 570.321 113.547C570.153 113.768 570.061 114.037 570.058 114.315C570.049 114.587 570.134 114.854 570.299 115.071C570.464 115.288 570.699 115.441 570.964 115.505L573.259 116.094C573.507 116.153 573.752 116.227 573.991 116.316C574.723 116.581 575.219 117.26 575.242 118.035C575.253 118.415 575.148 118.789 574.943 119.108C574.737 119.428 574.439 119.677 574.088 119.824C573.556 120.066 572.979 120.194 572.394 120.2C571.809 120.206 571.229 120.089 570.691 119.859C570.249 119.668 569.876 119.347 569.623 118.939C569.369 118.531 569.247 118.055 569.272 117.575H569.763C569.947 118.463 570.558 119.202 571.396 119.552C572.234 119.902 573.19 119.816 573.952 119.324C574.181 119.205 574.371 119.023 574.499 118.8C574.628 118.577 574.689 118.322 574.677 118.065C574.688 117.812 574.617 117.562 574.473 117.353C574.329 117.144 574.121 116.988 573.88 116.908C573.291 116.689 572.665 116.573 572.065 116.376C571.437 116.202 570.823 115.981 570.227 115.717C569.283 115.253 569.208 113.433 570.284 112.853C570.851 112.524 571.494 112.347 572.15 112.34C572.807 112.332 573.453 112.495 574.028 112.811C574.357 113.007 574.621 113.294 574.79 113.637C574.958 113.981 575.022 114.365 574.976 114.745L574.981 114.748ZM542.101 119.987C541.904 120.061 541.685 120.061 541.488 119.986C541.29 119.911 541.127 119.766 541.029 119.58L539.078 116.885L538.795 116.508L536.53 119.584C536.438 119.762 536.283 119.902 536.096 119.975C535.908 120.049 535.7 120.051 535.511 119.983L538.428 116.075L535.714 112.544C536.116 112.398 536.565 112.556 536.789 112.92L538.812 115.648L540.846 112.931C540.939 112.755 541.094 112.619 541.28 112.55C541.467 112.48 541.673 112.482 541.858 112.554L540.805 113.949L539.378 115.803C539.338 115.839 539.306 115.882 539.285 115.93C539.263 115.979 539.252 116.031 539.252 116.084C539.252 116.137 539.263 116.19 539.285 116.238C539.306 116.286 539.338 116.33 539.378 116.365L542.095 119.987H542.101ZM554.489 112.506V113.037C554.107 113.012 553.725 113.068 553.366 113.199C553.007 113.331 552.679 113.537 552.405 113.803C552.13 114.069 551.914 114.389 551.771 114.744C551.629 115.098 551.562 115.478 551.575 115.86C551.575 117.101 551.575 118.342 551.575 119.584V120.006H551.035V112.539H551.568V114.069C552.221 112.953 553.228 112.539 554.493 112.509L554.489 112.506ZM528.524 116.026L528.762 114.854C529.415 112.536 532.076 111.572 533.907 113.007C534.979 113.848 535.247 115.039 535.194 116.38H529.155C529.057 118.777 530.789 120.224 533.005 119.486C533.735 119.22 534.284 118.614 534.465 117.861C534.582 117.485 534.776 117.42 535.13 117.529C535.071 117.988 534.908 118.428 534.654 118.815C534.401 119.202 534.062 119.526 533.665 119.764C533.008 120.123 532.255 120.265 531.513 120.17C530.77 120.075 530.077 119.749 529.532 119.237C528.992 118.631 528.667 117.866 528.603 117.058C528.603 116.925 528.559 116.801 528.528 116.682C528.525 116.458 528.524 116.24 528.524 116.026ZM529.162 115.864H534.624C534.59 114.127 533.492 112.894 532.027 112.883C530.397 112.861 529.23 114.066 529.158 115.857L529.162 115.864Z",
    fill: "black"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M451.54 25H419.825C412.743 25 407 30.7269 407 37.7902V69.1408C407 76.2049 412.743 81.931 419.825 81.931H451.54C458.623 81.931 464.364 76.2049 464.364 69.1408V37.7902C464.364 30.7269 458.623 25 451.54 25Z",
    fill: "#D5F2FF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_39_780",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 419,
    y: 36,
    width: 34,
    height: 34
  }, _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M453 36H419V70H453V36Z",
    fill: "#D9D9D9"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_39_780)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M435.998 58.6806C444.683 58.6806 451.723 56.1373 451.723 53C451.723 49.8626 444.683 47.3193 435.998 47.3193C427.314 47.3193 420.273 49.8626 420.273 53C420.273 56.1373 427.314 58.6806 435.998 58.6806Z",
    stroke: "#61DAFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.798 55.8405C435.14 62.9565 440.988 67.4534 443.86 65.8848C446.732 64.3161 445.54 57.2758 441.197 50.1598C436.855 43.0439 431.007 38.5469 428.135 40.1155C425.263 41.6842 426.456 48.7245 430.798 55.8405Z",
    stroke: "#61DAFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.798 50.1597C426.456 57.2757 425.263 64.316 428.135 65.8847C431.007 67.4533 436.855 62.9563 441.197 55.8404C445.54 48.7244 446.732 41.6841 443.86 40.1154C440.988 38.5468 435.14 43.0438 430.798 50.1597Z",
    stroke: "#61DAFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.001 55.7727C437.619 55.7727 438.931 54.5314 438.931 53C438.931 51.4687 437.619 50.2273 436.001 50.2273C434.382 50.2273 433.07 51.4687 433.07 53C433.07 54.5314 434.382 55.7727 436.001 55.7727Z",
    fill: "#61DAFB"
  }))), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M410.54 146H378.825C371.743 146 366 151.727 366 158.79V190.141C366 197.205 371.743 202.931 378.825 202.931H410.54C417.623 202.931 423.364 197.205 423.364 190.141V158.79C423.364 151.727 417.623 146 410.54 146Z",
    fill: "#D5F2FF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_39_780",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 375,
    y: 154,
    width: 40,
    height: 40
  }, _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M415 154H375V194H415V154Z",
    fill: "#D9D9D9"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_39_780)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M395.026 165.618C390.369 165.618 386.594 169.394 386.594 174.05C386.594 178.707 390.369 182.482 395.026 182.482C399.682 182.482 403.458 178.707 403.458 174.05C403.432 169.394 399.657 165.618 395.026 165.618Z",
    fill: "#3880FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.109 166.374C409.236 166.374 410.96 164.65 410.96 162.523C410.96 160.396 409.236 158.672 407.109 158.672C404.982 158.672 403.258 160.396 403.258 162.523C403.258 164.65 404.982 166.374 407.109 166.374Z",
    fill: "#3880FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.839 166.373L411.688 166.021L411.436 166.323C410.807 167.028 410.001 167.582 409.12 167.909L408.869 168.009L408.969 168.261C409.75 170.099 410.127 172.062 410.127 174.05C410.127 182.382 403.356 189.178 395 189.178C386.644 189.178 379.898 182.382 379.898 174.05C379.898 165.719 386.669 158.923 395.025 158.923C397.291 158.923 399.455 159.427 401.494 160.383L401.72 160.484L401.821 160.232C402.199 159.351 402.778 158.596 403.533 157.992L403.835 157.74L403.482 157.564C400.839 156.205 397.995 155.5 395 155.5C384.806 155.5 376.5 163.806 376.5 174C376.5 184.194 384.806 192.5 395 192.5C405.194 192.5 413.5 184.194 413.5 174C413.5 171.382 412.946 168.815 411.839 166.373Z",
    fill: "#3880FF"
  }))), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M706.54 143H674.825C667.743 143 662 148.727 662 155.79V187.141C662 194.205 667.743 199.931 674.825 199.931H706.54C713.623 199.931 719.364 194.205 719.364 187.141V155.79C719.364 148.727 713.623 143 706.54 143Z",
    fill: "#D5F2FF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_39_780",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 674,
    y: 154,
    width: 34,
    height: 34
  }, _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M708 154H674V188H708V154Z",
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_39_780)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask5_39_780",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 675,
    y: 155,
    width: 32,
    height: 32
  }, _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M706.723 155.275H675.273V186.725H706.723V155.275Z",
    fill: "#D9D9D9"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_39_780)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M691.226 155.275L676.531 160.482L678.853 179.869L691.242 186.725L703.694 179.776L706.016 160.39L691.226 155.275Z",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M704.553 161.511L691.195 156.924V185.087L702.39 178.849L704.553 161.511Z",
    fill: "#A6120D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.18 161.593L680.17 178.931L691.191 185.087V156.923L678.18 161.593Z",
    fill: "#DD1B16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M694.872 171.917L691.195 173.648H687.32L685.498 178.236L682.109 178.299L691.195 157.947L694.872 171.917ZM694.517 171.045L691.22 164.472L688.515 170.932H691.195L694.517 171.045Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M691.195 157.947L691.22 164.472L694.288 170.937H691.202L691.195 173.644L695.463 173.648L697.457 178.3L700.7 178.36L691.195 157.947Z",
    fill: "#B3B3B3"
  })))), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M706.54 279H674.825C667.743 279 662 284.727 662 291.79V323.141C662 330.205 667.743 335.931 674.825 335.931H706.54C713.623 335.931 719.364 330.205 719.364 323.141V291.79C719.364 284.727 713.623 279 706.54 279Z",
    fill: "#D5F2FF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_39_780",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 674,
    y: 290,
    width: 34,
    height: 34
  }, _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M708 290H674V324H708V290Z",
    fill: "#D9D9D9"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_39_780)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M679.531 315.244L678.375 314.577L691.264 292.302L692.42 292.969L679.531 315.244Z",
    fill: "#E10098"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.109 312.797H703.889V314.13H678.109V312.797Z",
    fill: "#E10098"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M691.511 320.977L678.617 313.548L679.285 312.395L692.18 319.824L691.511 320.977ZM702.713 301.614L689.818 294.186L690.486 293.033L703.38 300.462L702.713 301.614Z",
    fill: "#E10098"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M679.293 301.609L678.625 300.456L691.531 293.025L692.199 294.178L679.293 301.609Z",
    fill: "#E10098"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M702.48 315.244L689.589 292.967L690.744 292.3L703.635 314.577L702.48 315.244ZM679.133 299.571H680.469V314.429H679.133V299.571ZM701.54 299.571H702.877V314.429H701.54V299.571Z",
    fill: "#E10098"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M691.286 320.411L690.703 319.403L701.918 312.942L702.502 313.95L691.286 320.411Z",
    fill: "#E10098"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M704.644 314.862C704.271 315.506 703.657 315.975 702.938 316.168C702.218 316.361 701.451 316.261 700.805 315.891C700.16 315.518 699.69 314.906 699.497 314.188C699.304 313.47 699.403 312.705 699.774 312.06C700.148 311.417 700.761 310.947 701.481 310.755C702.201 310.562 702.967 310.661 703.613 311.032C704.966 311.811 705.426 313.522 704.644 314.862ZM682.221 301.94C681.847 302.584 681.234 303.053 680.514 303.246C679.795 303.439 679.028 303.339 678.382 302.969C677.737 302.596 677.266 301.984 677.073 301.266C676.88 300.547 676.98 299.782 677.351 299.137C677.724 298.494 678.338 298.024 679.058 297.832C679.777 297.639 680.544 297.738 681.19 298.109C681.835 298.481 682.305 299.094 682.498 299.812C682.692 300.53 682.592 301.295 682.221 301.939M677.359 314.862C676.988 314.218 676.889 313.453 677.082 312.735C677.275 312.017 677.745 311.404 678.39 311.032C679.036 310.661 679.803 310.562 680.523 310.755C681.242 310.947 681.856 311.417 682.229 312.06C682.6 312.705 682.7 313.47 682.507 314.188C682.314 314.906 681.843 315.518 681.198 315.891C679.846 316.661 678.131 316.205 677.359 314.863M699.783 301.941C699.412 301.297 699.312 300.532 699.505 299.814C699.698 299.096 700.169 298.483 700.814 298.111C701.46 297.741 702.226 297.641 702.946 297.834C703.666 298.026 704.279 298.496 704.653 299.139C705.024 299.784 705.123 300.549 704.93 301.267C704.737 301.985 704.267 302.597 703.622 302.97C702.976 303.34 702.209 303.44 701.489 303.247C700.77 303.054 700.156 302.585 699.783 301.941ZM691.002 322.725C690.446 322.725 689.903 322.561 689.441 322.253C688.979 321.944 688.619 321.507 688.406 320.994C688.194 320.482 688.138 319.918 688.247 319.374C688.355 318.831 688.623 318.331 689.016 317.939C689.409 317.547 689.909 317.28 690.454 317.172C690.999 317.064 691.564 317.12 692.078 317.332C692.591 317.544 693.03 317.904 693.338 318.365C693.647 318.826 693.811 319.368 693.811 319.923C693.809 320.666 693.513 321.377 692.986 321.902C692.46 322.428 691.746 322.723 691.002 322.725ZM691.002 296.881C690.633 296.882 690.267 296.81 689.926 296.669C689.585 296.528 689.275 296.322 689.014 296.061C688.753 295.801 688.546 295.492 688.405 295.151C688.264 294.811 688.192 294.446 688.192 294.078C688.192 293.334 688.488 292.622 689.015 292.096C689.542 291.57 690.256 291.275 691.001 291.275C691.746 291.275 692.461 291.57 692.987 292.096C693.514 292.622 693.81 293.334 693.81 294.078C693.811 294.446 693.738 294.81 693.597 295.151C693.456 295.491 693.249 295.8 692.988 296.06C692.728 296.32 692.418 296.527 692.077 296.668C691.736 296.808 691.371 296.88 691.002 296.88",
    fill: "#E10098"
  }))), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M186.774 34.3411H155.059C147.977 34.3411 142.234 40.068 142.234 47.1312V78.4819C142.234 85.5459 147.977 91.272 155.059 91.272H186.774C193.857 91.272 199.599 85.5459 199.599 78.4819V47.1312C199.599 40.068 193.857 34.3411 186.774 34.3411Z",
    fill: "#D5F2FF"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M167.226 72.6353C167.226 72.6353 165.941 73.3909 168.141 73.6465C170.807 73.9539 172.17 73.9098 175.107 73.3479C175.107 73.3479 175.88 73.8373 176.958 74.2613C170.373 77.1139 162.054 74.0961 167.226 72.6353Z",
    fill: "#5382A1"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M166.42 68.9127C166.42 68.9127 164.978 69.9914 167.18 70.2216C170.028 70.5185 172.277 70.5428 176.168 69.7855C176.168 69.7855 176.706 70.337 177.553 70.6386C169.59 72.9918 160.722 70.8242 166.42 68.9127Z",
    fill: "#5382A1"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M173.207 62.5982C174.83 64.4864 172.781 66.1855 172.781 66.1855C172.781 66.1855 176.901 64.0358 175.009 61.3438C173.241 58.8334 171.886 57.5861 179.223 53.2855C179.223 53.2855 167.707 56.1925 173.207 62.5982Z",
    fill: "#EE2B2A"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M181.914 75.3885C181.914 75.3885 182.866 76.1807 180.867 76.7936C177.065 77.9574 165.045 78.3089 161.706 76.84C160.506 76.3122 162.757 75.5798 163.465 75.4261C164.203 75.2643 164.625 75.2944 164.625 75.2944C163.29 74.344 155.997 77.1606 160.921 77.9672C174.348 80.168 185.397 76.9762 181.914 75.3885Z",
    fill: "#5382A1"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M167.845 65.0558C167.845 65.0558 161.731 66.5235 165.679 67.0565C167.347 67.2821 170.671 67.2311 173.767 66.9689C176.297 66.7531 178.838 66.2945 178.838 66.2945C178.838 66.2945 177.946 66.6807 177.3 67.1261C171.091 68.7765 159.097 68.0087 162.55 66.3206C165.47 64.8939 167.845 65.0558 167.845 65.0558Z",
    fill: "#5382A1"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M178.814 71.252C185.126 67.9372 182.208 64.7518 180.171 65.181C179.672 65.286 179.449 65.377 179.449 65.377C179.449 65.377 179.634 65.0835 179.988 64.9565C184.018 63.5247 187.117 69.1794 178.688 71.4191C178.688 71.4191 178.785 71.3309 178.814 71.252Z",
    fill: "#5382A1"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M175.011 46.3411C175.011 46.3411 178.506 49.875 171.695 55.3093C166.234 59.6684 170.45 62.1539 171.693 64.9937C168.505 62.0867 166.166 59.5276 167.735 57.1458C170.039 53.6496 176.421 51.9546 175.011 46.3411Z",
    fill: "#EE2B2A"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M168.467 80.2342C174.525 80.6262 183.829 80.0167 184.049 77.1195C184.049 77.1195 183.625 78.2178 179.042 79.09C173.871 80.0736 167.494 79.9587 163.711 79.3284C163.711 79.3284 164.485 79.9762 168.467 80.2342Z",
    fill: "#5382A1"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M151.178 187.672L123.915 188.128C116.834 188.247 111.199 194.07 111.327 201.134L111.832 228.919C111.96 235.984 117.804 241.614 124.885 241.495L152.148 241.039C159.228 240.921 164.864 235.098 164.736 228.034L164.231 200.249C164.102 193.184 158.258 187.554 151.178 187.672Z",
    fill: "#D5F2FF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_39_780",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 122,
    y: 198,
    width: 35,
    height: 34
  }, _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M156.008 198H122.008V232H156.008V198Z",
    fill: "#D9D9D9"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_39_780)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125.278 206.656C122.495 210.808 122.84 216.208 124.967 220.632C125.017 220.738 125.071 220.842 125.123 220.946L125.221 221.145C125.241 221.184 125.262 221.221 125.283 221.259C125.319 221.331 125.357 221.396 125.394 221.465L125.598 221.826L125.714 222.024L125.95 222.407L126.05 222.568C126.161 222.739 126.274 222.911 126.391 223.078L126.458 223.172C126.56 223.316 126.663 223.459 126.769 223.6L126.887 223.755L127.174 224.123L127.284 224.259C127.415 224.42 127.55 224.579 127.684 224.734C127.698 224.749 127.704 224.754 127.708 224.76C127.842 224.911 127.977 225.059 128.115 225.205L128.246 225.342L128.57 225.672L128.703 225.805C128.849 225.948 128.998 226.088 129.149 226.225L129.636 226.654L129.804 226.792L130.141 227.066L130.321 227.209L130.699 227.49L130.876 227.62C130.997 227.707 131.12 227.789 131.244 227.872L131.403 227.982C131.593 228.107 131.785 228.229 131.979 228.347L132.138 228.449L132.571 228.7C132.649 228.744 132.73 228.786 132.81 228.828L133.118 228.994L133.19 229.03L133.318 229.093L133.808 229.327L133.911 229.375C134.1 229.461 134.29 229.543 134.482 229.621L134.62 229.678L135.159 229.886L135.228 229.91C135.427 229.981 135.627 230.049 135.827 230.114L135.973 230.159C136.17 230.223 136.382 230.302 136.593 230.341C150.058 232.888 153.968 221.945 153.968 221.945C150.684 226.384 144.853 227.556 139.316 226.252C139.107 226.203 138.903 226.135 138.7 226.072L138.546 226.024C138.347 225.961 138.149 225.894 137.953 225.823L137.871 225.793C137.696 225.728 137.521 225.661 137.348 225.592L137.2 225.531C137.01 225.453 136.822 225.371 136.635 225.286L136.522 225.235L136.045 225.004L135.907 224.936C135.783 224.875 135.661 224.806 135.538 224.732L135.293 224.599C135.143 224.518 134.998 224.43 134.85 224.342L134.701 224.255C134.507 224.137 134.315 224.015 134.125 223.89C134.073 223.855 134.022 223.819 133.97 223.783L133.561 223.5C133.516 223.47 133.463 223.435 133.429 223.405L133.042 223.114L132.87 222.979L132.52 222.696L132.365 222.566L131.931 222.185C131.915 222.171 131.898 222.157 131.881 222.145L131.424 221.713L131.296 221.585L130.97 221.248L130.842 221.115C130.704 220.969 130.571 220.823 130.449 220.673C130.442 220.665 130.435 220.658 130.429 220.65C130.29 220.492 130.153 220.33 130.02 220.167L129.922 220.034L129.627 219.657L129.528 219.517L129.188 219.048C126.102 214.71 124.999 208.713 127.451 203.796M133.922 203.159C131.908 206.165 132.017 210.198 133.587 213.368C133.851 213.903 134.148 214.418 134.478 214.911C134.78 215.36 135.115 215.893 135.515 216.253C135.66 216.42 135.812 216.58 135.967 216.74L136.085 216.862C136.235 217.014 136.389 217.163 136.546 217.307C136.553 217.312 136.558 217.319 136.566 217.324C136.745 217.488 136.926 217.631 137.11 217.792L137.232 217.891C137.416 218.038 137.604 218.181 137.796 218.318L137.813 218.33C137.897 218.392 137.984 218.448 138.07 218.507C138.112 218.534 138.151 218.564 138.192 218.59C138.33 218.682 138.469 218.77 138.61 218.856L138.669 218.891L139.039 219.095C139.082 219.121 139.137 219.142 139.171 219.167L139.429 219.306C139.442 219.313 139.456 219.318 139.469 219.324C139.646 219.416 139.826 219.502 140.008 219.584L140.126 219.635C140.272 219.7 140.42 219.762 140.568 219.821L140.757 219.892C140.892 219.943 141.027 219.992 141.163 220.038L141.347 220.099C141.541 220.16 141.74 220.242 141.934 220.276C152.331 222.063 154.731 213.747 154.731 213.747C152.568 216.981 148.379 218.521 143.907 217.317C143.709 217.263 143.513 217.205 143.318 217.141C143.259 217.122 143.2 217.102 143.141 217.082L142.728 216.935L142.531 216.863C142.382 216.804 142.235 216.742 142.088 216.678L141.968 216.627C141.786 216.544 141.605 216.457 141.426 216.366L141.153 216.223L140.996 216.139C140.88 216.074 140.765 216.007 140.652 215.938L140.569 215.89C140.428 215.805 140.289 215.716 140.152 215.625C140.11 215.597 140.069 215.567 140.026 215.538L139.756 215.353C139.565 215.216 139.379 215.073 139.195 214.926L139.068 214.824C137.101 213.22 135.559 211.029 134.822 208.546C134.049 205.97 134.215 203.078 135.554 200.732M141.191 200.545C140.005 202.366 139.887 204.608 140.711 206.61C141.579 208.735 143.359 210.401 145.437 211.201L145.694 211.303L145.808 211.339L146.179 211.441C151.92 212.592 153.476 208.385 153.891 207.766C152.528 209.803 150.235 210.292 147.423 209.584C147.201 209.528 146.957 209.444 146.743 209.365C146.467 209.264 146.198 209.148 145.934 209.017C145.434 208.768 144.96 208.468 144.517 208.121C142.001 206.141 140.437 202.352 142.08 199.275",
    fill: "#0868AC"
  }))), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M193.871 304.105C195.333 305.563 197.454 306.375 199.737 306.028C203.103 305.518 205.516 302.493 205.516 299.093V294.843H220.38V308.452H224.615C228.224 308.452 231.376 311.157 231.643 314.751C231.797 316.827 231.011 318.732 229.655 320.078C228.421 321.312 226.714 322.082 224.836 322.082H220.38V335.691H178.925C177.862 335.691 177 334.829 177 333.768V294.843H191.866V299.294C191.866 301.167 192.637 302.871 193.871 304.105Z",
    fill: "#F2BB16"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M254.364 310.458C253.134 311.696 252.367 313.391 252.367 315.267C252.367 319.005 255.43 322.065 259.183 322.065H263.763V333.766C263.763 334.831 262.901 335.691 261.843 335.691H220.383V322.08H224.837C226.717 322.08 228.422 321.308 229.654 320.078C231.012 318.729 231.795 316.829 231.644 314.748C231.376 311.159 228.226 308.447 224.616 308.447H220.383V294.844H233.683V290.594C233.683 287.187 236.09 284.168 239.463 283.655C241.745 283.309 243.862 284.121 245.323 285.579C246.57 286.809 247.328 288.522 247.328 290.39V294.844H263.763V308.462H259.183C257.31 308.462 255.605 309.227 254.364 310.458Z",
    fill: "#6ADB6A"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M178.925 254.001H220.38V267.604H224.615C228.224 267.604 231.376 270.309 231.643 273.903C231.797 275.979 231.011 277.884 229.655 279.23C228.421 280.462 226.714 281.232 224.836 281.232H220.38V294.842H205.516V299.092C205.516 302.492 203.103 305.517 199.737 306.027C197.454 306.374 195.333 305.562 193.871 304.104C192.637 302.87 191.866 301.166 191.866 299.293V294.842H177V255.923C177 254.862 177.862 254.001 178.925 254.001Z",
    fill: "#DE2828"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M268.125 267.676H263.654V256.029C263.654 254.969 262.795 254.112 261.734 254.112H220.383V267.678H224.608C228.207 267.678 231.349 270.376 231.616 273.96C231.77 276.031 230.985 277.931 229.634 279.272C228.402 280.502 226.7 281.271 224.827 281.271H220.383V294.844H233.649V290.607C233.649 287.215 236.055 284.197 239.413 283.688C241.69 283.343 243.804 284.152 245.262 285.606C246.501 286.837 247.264 288.536 247.264 290.406V294.844H263.654V281.279H268.125C271.87 281.279 274.937 278.219 274.937 274.478C274.937 270.736 271.87 267.676 268.125 267.676Z",
    fill: "#2EC6FC"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M241.291 330.257V327.924C241.291 327.577 241.262 327.234 241.207 326.894C241.152 326.554 241.049 326.251 240.9 325.987C240.751 325.721 240.54 325.506 240.26 325.347C239.981 325.185 239.619 325.106 239.175 325.106C238.729 325.106 238.367 325.185 238.089 325.347C237.81 325.506 237.597 325.721 237.448 325.987C237.299 326.251 237.198 326.554 237.141 326.894C237.086 327.234 237.059 327.577 237.059 327.924V330.257H241.291ZM235.5 332.037V327.421C235.5 326.583 235.614 325.89 235.844 325.347C236.072 324.803 236.363 324.375 236.715 324.06C237.068 323.744 237.463 323.526 237.902 323.402C238.343 323.278 238.766 323.216 239.175 323.216C239.582 323.216 240.006 323.278 240.446 323.402C240.885 323.526 241.281 323.744 241.634 324.06C241.986 324.375 242.277 324.803 242.506 325.347C242.734 325.89 242.848 326.583 242.848 327.421V330.257H248.639V332.037H235.5Z",
    fill: "white"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M235.5 321.046V319.267H240.957V312.465H235.5V310.688H248.639V312.465H242.627V319.267H248.639V321.046H235.5Z",
    fill: "white"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M241.291 305.535V303.2C241.291 302.855 241.262 302.512 241.207 302.172C241.152 301.833 241.049 301.53 240.9 301.263C240.751 300.999 240.54 300.785 240.26 300.626C239.981 300.463 239.619 300.383 239.175 300.383C238.729 300.383 238.367 300.463 238.089 300.626C237.81 300.785 237.597 300.999 237.448 301.263C237.299 301.53 237.198 301.833 237.141 302.172C237.086 302.512 237.059 302.855 237.059 303.2V305.535H241.291ZM235.5 307.315V302.7C235.5 301.859 235.614 301.168 235.844 300.626C236.072 300.08 236.363 299.653 236.715 299.337C237.068 299.022 237.463 298.803 237.902 298.679C238.343 298.557 238.766 298.495 239.175 298.495C239.582 298.495 240.006 298.557 240.446 298.679C240.885 298.803 241.281 299.022 241.634 299.337C241.986 299.653 242.277 300.08 242.506 300.626C242.734 301.168 242.848 301.859 242.848 302.7V305.535H248.639V307.315H235.5Z",
    fill: "white"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M232.977 270.481H234.402V273.667H238.145V270.481H239.572V278.479H238.145V274.954H234.402V278.479H232.977V270.481Z",
    fill: "white"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M242.987 271.768H240.531V270.481H246.867V271.768H244.412V278.479H242.987V271.768Z",
    fill: "white"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M247.875 270.481H250.046L252.185 276.084L254.346 270.481H256.496V278.479H255.138V271.837H255.116L252.683 278.479H251.687L249.255 271.837H249.231V278.479H247.875V270.481Z",
    fill: "white"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M258.32 270.481H259.747V277.192H263.152V278.479H258.32V270.481Z",
    fill: "white"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M196.715 304.105C198.176 305.563 200.297 306.375 202.579 306.028C205.947 305.518 208.358 302.493 208.358 299.093V294.843H223.224V308.452H227.459C231.068 308.452 234.218 311.157 234.487 314.751C234.641 316.827 233.853 318.732 232.498 320.078C231.263 321.312 229.558 322.082 227.68 322.082H223.224V335.691H181.768C180.705 335.691 179.844 334.829 179.844 333.768V294.843H194.708V299.294C194.708 301.167 195.479 302.871 196.715 304.105Z",
    fill: "#F9E181"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M257.208 310.458C255.976 311.696 255.21 313.391 255.21 315.267C255.21 319.005 258.274 322.065 262.025 322.065H266.607V333.766C266.607 334.831 265.745 335.691 264.687 335.691H223.227V322.08H227.679C229.56 322.08 231.265 321.308 232.498 320.078C233.856 318.729 234.637 316.829 234.488 314.748C234.219 311.159 231.068 308.447 227.46 308.447H223.227V294.844H236.525V290.594C236.525 287.187 238.934 284.168 242.305 283.655C244.589 283.309 246.705 284.121 248.166 285.579C249.414 286.809 250.172 288.522 250.172 290.39V294.844H266.607V308.462H262.025C260.154 308.462 258.449 309.227 257.208 310.458Z",
    fill: "#6ADB6A"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M181.768 254.001H223.224V267.604H227.459C231.068 267.604 234.218 270.309 234.487 273.903C234.641 275.979 233.853 277.884 232.498 279.23C231.263 280.462 229.558 281.232 227.68 281.232H223.224V294.842H208.358V299.092C208.358 302.492 205.947 305.517 202.579 306.027C200.297 306.374 198.176 305.562 196.715 304.104C195.479 302.87 194.708 301.166 194.708 299.293V294.842H179.844V255.923C179.844 254.862 180.705 254.001 181.768 254.001Z",
    fill: "#F74242"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M191.53 278.84L189.101 275.238C190.329 275.131 191.435 274.258 191.435 272.662C191.435 271.039 190.262 270 188.615 270H185V278.834H186.12V275.324H187.914L190.208 278.834L191.53 278.84ZM188.481 274.364H186.121V270.986H188.481C189.548 270.986 190.276 271.675 190.276 272.669C190.276 273.662 189.547 274.364 188.481 274.364ZM195.699 278.999C196.766 278.999 197.642 278.655 198.29 278.019L197.804 277.37C197.291 277.887 196.536 278.178 195.794 278.178C194.391 278.178 193.527 277.171 193.446 275.966H198.721V275.714C198.721 273.794 197.561 272.284 195.59 272.284C193.729 272.284 192.38 273.781 192.38 275.635C192.38 277.635 193.77 278.994 195.699 278.994V278.999ZM197.724 275.237H193.447C193.501 274.257 194.188 273.104 195.578 273.104C197.063 273.104 197.71 274.283 197.724 275.237ZM205.441 278.84V274.443C205.441 272.893 204.295 272.283 202.919 272.283C201.852 272.283 201.016 272.628 200.315 273.343L200.787 274.032C201.367 273.423 202.002 273.144 202.784 273.144C203.728 273.144 204.43 273.634 204.43 274.495V275.647C203.904 275.051 203.162 274.773 202.271 274.773C201.165 274.773 199.99 275.449 199.99 276.879C199.99 278.269 201.164 278.998 202.271 278.998C203.148 278.998 203.891 278.694 204.43 278.111V278.839L205.441 278.84ZM202.636 278.283C201.691 278.283 201.03 277.701 201.03 276.893C201.03 276.072 201.691 275.489 202.636 275.489C203.351 275.489 204.039 275.754 204.43 276.284V277.489C204.039 278.019 203.351 278.284 202.636 278.284V278.283ZM210.334 278.999C211.521 278.999 212.223 278.522 212.722 277.887L212.047 277.277C211.616 277.847 211.063 278.112 210.394 278.112C209.004 278.112 208.141 277.052 208.141 275.635C208.141 274.218 209.005 273.172 210.394 273.172C211.068 273.172 211.622 273.424 212.047 274.006L212.722 273.397C212.223 272.761 211.521 272.285 210.334 272.285C208.391 272.285 207.082 273.742 207.082 275.636C207.082 277.543 208.391 278.994 210.334 278.994V278.999ZM215.785 278.999C216.378 278.999 216.743 278.826 217 278.589L216.703 277.847C216.568 277.992 216.304 278.112 216.015 278.112C215.57 278.112 215.354 277.767 215.354 277.29V273.317H216.677V272.443H215.354V270.695H214.342V272.443H213.262V273.317H214.342V277.503C214.342 278.457 214.827 279 215.785 279V278.999Z",
    fill: "white"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M270.961 267.676H266.49V256.029C266.49 254.969 265.63 254.112 264.57 254.112H223.219V267.678H227.442C231.043 267.678 234.185 270.376 234.451 273.96C234.604 276.031 233.821 277.931 232.468 279.272C231.238 280.502 229.536 281.271 227.663 281.271H223.219V294.844H236.485V290.607C236.485 287.215 238.891 284.197 242.249 283.688C244.524 283.343 246.64 284.152 248.098 285.606C249.337 286.837 250.098 288.536 250.098 290.406V294.844H266.49V281.279H270.961C274.706 281.279 277.773 278.219 277.773 274.478C277.773 270.736 274.706 267.676 270.961 267.676Z",
    fill: "#2EC6FC"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M197.278 318.974C197.278 319.502 197.189 320.008 197.012 320.498C196.835 320.987 196.572 321.417 196.225 321.787C195.879 322.156 195.443 322.452 194.919 322.671C194.394 322.89 193.784 323 193.089 323C191.989 323 191.088 322.755 190.388 322.267C189.685 321.777 189.225 321 189 319.933L191.32 319.406C191.4 319.846 191.585 320.197 191.882 320.46C192.177 320.723 192.539 320.855 192.973 320.855C193.68 320.855 194.161 320.627 194.417 320.169C194.673 319.71 194.8 319.08 194.8 318.277V309.339H197.278V318.974Z",
    fill: "white"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M207.113 312.198C206.852 311.835 206.502 311.569 206.062 311.399C205.623 311.23 205.16 311.145 204.676 311.145C204.388 311.145 204.11 311.176 203.84 311.239C203.572 311.301 203.329 311.403 203.113 311.54C202.896 311.678 202.722 311.858 202.591 312.077C202.46 312.295 202.396 312.556 202.396 312.858C202.396 313.309 202.56 313.654 202.887 313.892C203.213 314.132 203.619 314.338 204.106 314.513C204.591 314.689 205.121 314.86 205.698 315.021C206.274 315.186 206.806 315.41 207.29 315.698C207.775 315.988 208.181 316.371 208.51 316.847C208.837 317.323 209 317.958 209 318.748C209 319.463 208.862 320.087 208.587 320.62C208.312 321.154 207.943 321.596 207.477 321.946C207.011 322.297 206.47 322.562 205.855 322.737C205.239 322.913 204.591 323 203.91 323C203.043 323 202.212 322.863 201.413 322.587C200.612 322.312 199.924 321.847 199.348 321.194L201.215 319.463C201.518 319.902 201.914 320.244 202.406 320.489C202.896 320.733 203.418 320.855 203.968 320.855C204.257 320.855 204.544 320.819 204.833 320.743C205.121 320.666 205.383 320.555 205.619 320.403C205.855 320.253 206.045 320.061 206.19 319.83C206.333 319.597 206.405 319.331 206.405 319.03C206.405 318.541 206.242 318.164 205.915 317.9C205.586 317.637 205.179 317.415 204.696 317.233C204.211 317.05 203.679 316.879 203.103 316.715C202.526 316.554 201.996 316.329 201.511 316.048C201.024 315.765 200.619 315.389 200.292 314.917C199.965 314.448 199.801 313.818 199.801 313.028C199.801 312.337 199.948 311.741 200.243 311.239C200.537 310.738 200.924 310.32 201.402 309.988C201.881 309.656 202.427 309.407 203.043 309.245C203.66 309.081 204.288 309 204.931 309C205.664 309 206.376 309.107 207.064 309.319C207.752 309.533 208.372 309.884 208.922 310.373L207.113 312.198Z",
    fill: "white"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M244.966 325.727V324.057C244.966 323.809 244.948 323.564 244.909 323.32C244.871 323.077 244.801 322.86 244.7 322.671C244.597 322.481 244.452 322.327 244.261 322.214C244.07 322.098 243.822 322.041 243.517 322.041C243.212 322.041 242.965 322.098 242.774 322.214C242.583 322.327 242.436 322.481 242.335 322.671C242.233 322.86 242.163 323.077 242.125 323.32C242.087 323.564 242.069 323.809 242.069 324.057V325.727H244.966ZM241 327V323.698C241 323.098 241.079 322.602 241.235 322.214C241.393 321.824 241.591 321.518 241.834 321.293C242.075 321.066 242.346 320.911 242.647 320.822C242.947 320.733 243.238 320.689 243.517 320.689C243.797 320.689 244.088 320.733 244.389 320.822C244.688 320.911 244.96 321.066 245.201 321.293C245.444 321.518 245.642 321.824 245.8 322.214C245.956 322.602 246.034 323.098 246.034 323.698V325.727H250V327H241Z",
    fill: "white"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M241 319.136V317.863H244.738V312.996H241V311.724H250V312.996H245.881V317.863H250V319.136H241Z",
    fill: "white"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M244.966 308.038V306.367C244.966 306.12 244.948 305.875 244.909 305.632C244.871 305.388 244.801 305.172 244.7 304.981C244.597 304.792 244.452 304.639 244.261 304.525C244.07 304.409 243.822 304.351 243.517 304.351C243.212 304.351 242.965 304.409 242.774 304.525C242.583 304.639 242.436 304.792 242.335 304.981C242.233 305.172 242.163 305.388 242.125 305.632C242.087 305.875 242.069 306.12 242.069 306.367V308.038H244.966ZM241 309.311V306.009C241 305.408 241.079 304.913 241.235 304.525C241.393 304.134 241.591 303.829 241.834 303.602C242.075 303.377 242.346 303.22 242.647 303.132C242.947 303.044 243.238 303 243.517 303C243.797 303 244.088 303.044 244.389 303.132C244.688 303.22 244.96 303.377 245.201 303.602C245.444 303.829 245.642 304.134 245.8 304.525C245.956 304.913 246.034 305.408 246.034 306.009V308.038H250V309.311H241Z",
    fill: "white"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M236 271H237.322V273.788H240.795V271H242.119V278H240.795V274.915H237.322V278H236V271Z",
    fill: "white"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M245.298 272.127H243.02V271H248.896V272.127H246.62V278H245.298V272.127Z",
    fill: "white"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M249.828 271H251.843L253.825 275.904L255.83 271H257.825V278H256.565V272.187H256.543L254.287 278H253.365L251.109 272.187H251.087V278H249.828V271Z",
    fill: "white"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M259.519 271H260.84V276.873H264V278H259.519V271Z",
    fill: "white"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M580.078 260.015L602.492 259.637L601.32 236.133L600.756 224.896L600.726 224.337L583.189 216.975L582.616 224.917L582.194 230.704L580.078 260.015Z",
    fill: "#FDAE97"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M623.919 332.76L633.342 410.669C633.639 412.64 633.631 414.688 633.23 416.753C631.334 426.485 621.902 432.835 612.156 430.946C602.414 429.053 598.687 421.541 596.937 410.373C593.577 388.93 581.844 324.594 581.844 324.594L623.919 332.76Z",
    fill: "#043561"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M562.792 328.842L597.417 331.165L597.245 369.468L593.134 375.534L589.325 412.46L554.273 409.664L562.792 328.842Z",
    fill: "#043561"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M590.992 250.186C582.771 250.367 578.768 245.858 577.906 243.874L581.478 242.911L601.626 242.27L604.069 243.053C603.035 244.967 599.398 250.001 590.992 250.186Z",
    fill: "#FDAE97"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M561.808 301.285L562.161 334.868H624.173L623.884 250.2L602.159 242.361C601.913 242.804 601.651 243.269 601.327 243.755L601.246 243.858C600.069 245.355 597.816 246.775 591.508 246.917C586.255 247.038 583.679 246.31 582.218 245.355L582.197 245.338C581.404 244.809 580.775 243.772 580.413 243.204L560.062 248.13L561.446 290.873L561.808 301.285Z",
    fill: "white"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M577.91 243.88C577.91 243.88 579.668 275.213 579.413 293.321C579.159 311.434 577.91 357.206 577.91 357.206C577.91 357.206 566.423 357.447 555.853 355.308C555.853 355.308 555.694 334.576 558.606 320.275C561.523 305.974 560.063 248.13 560.063 248.13L577.91 243.88Z",
    fill: "#FFCB83"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M643.609 318.575L643.479 318.626C637.701 320.885 631.122 318.02 628.86 312.25L610.401 265.257C608.135 259.492 611.004 252.922 616.782 250.659L616.911 250.608C622.69 248.345 629.269 251.214 631.535 256.984L649.994 303.973C652.261 309.742 649.387 316.312 643.609 318.575Z",
    fill: "#FFCB83"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M639.901 489.755L607.331 489.734L597.512 414.053C596.486 404.192 603.647 395.359 613.515 394.322C623.39 393.298 632.219 400.444 633.262 410.297C633.352 411.153 633.365 411.987 633.335 412.835L639.005 479.262L639.901 489.755Z",
    fill: "#043561"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M589.454 411.097L581.091 489.755H549.094L554.221 410.667C554.182 409.832 554.415 408.903 554.488 408.038C555.363 398.16 563.227 390.786 573.119 391.646C582.995 392.52 590.316 401.219 589.454 411.097Z",
    fill: "#043561"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M582.131 210.719C582.131 210.719 580.386 202.906 583.88 204.167C587.375 205.423 582.131 210.719 582.131 210.719Z",
    fill: "#322A28"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M604.068 243.059C604.068 243.059 595.589 286.951 595.304 308.768C595.016 330.584 595.016 330.585 595.016 330.585L595.989 357.207C595.989 357.207 619.614 360.128 627.874 356.764C627.874 356.764 628.447 325.168 626.254 313.978C624.061 302.792 623.88 250.201 623.88 250.201L604.068 243.059Z",
    fill: "#FFCB83"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M581.57 239.27L594.173 230.097L582.191 230.704L581.57 239.27Z",
    fill: "#EA9D85"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M599.711 350.758C599.711 350.758 616.907 353.602 624.917 350.758",
    stroke: "white"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M583.319 204.994C583.319 204.994 581.411 212.269 580.053 217.432L578.937 221.699C578.05 225.068 577.688 230.317 581.182 232.468C584.664 234.615 590.3 234.4 594.97 231.41C599.645 228.407 612.391 212.703 602.894 203.191C593.385 193.67 584.039 203.32 583.319 204.994Z",
    fill: "#FDAE97"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M601.052 233.426C601.052 233.426 599.009 228.285 599.617 225.764C600.224 223.247 597.764 219.9 598.872 216.058C599.983 212.216 600.444 210.598 598.38 210.456C596.321 210.315 581.438 211.188 582.166 204.334C582.895 197.481 600.931 193.682 605.899 206.305C605.899 206.305 610.484 206.834 607.524 216.243C604.559 225.652 602.271 226.964 601.052 233.426Z",
    fill: "#322A28"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M607.691 247.351C607.691 247.351 604.464 274.18 602.49 287.431C600.521 300.682 600.176 333.345 599.711 345.447",
    stroke: "white"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M598.225 223.63C596.364 225.347 595.631 226.706 596.984 228.165C598.333 229.619 601.112 229.997 602.969 228.281C604.831 226.568 605.24 223.996 603.891 222.537C602.543 221.079 600.082 221.918 598.225 223.63Z",
    fill: "#FDAE97"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M590.925 217.104C590.718 217.883 590.14 218.412 589.632 218.279C589.128 218.146 588.882 217.406 589.089 216.623C589.292 215.84 589.869 215.315 590.377 215.448C590.881 215.581 591.127 216.321 590.925 217.104Z",
    fill: "#322A28"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M581.454 214.624C581.251 215.407 581.497 216.147 582.001 216.28C582.509 216.409 583.083 215.884 583.289 215.101C583.496 214.323 583.251 213.578 582.742 213.449C582.238 213.316 581.661 213.841 581.454 214.624Z",
    fill: "#322A28"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M588.111 221.88C588.163 222.663 589.468 223.209 591.024 223.106C592.579 223.003 593.799 222.284 593.743 221.501C593.691 220.722 592.39 220.172 590.834 220.275C589.274 220.382 588.059 221.097 588.111 221.88Z",
    fill: "#EA9D85"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M580.052 217.428L579.328 220.203C580.461 220.646 581.504 220.573 581.827 220.005C582.189 219.33 581.401 218.181 580.052 217.428Z",
    fill: "#EA9D85"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M601.534 226.326C600.319 225.754 599.203 225.719 599.203 225.719C600.901 223.886 602.499 224.57 602.499 224.57",
    stroke: "#EA9D85"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M586.891 216.621L583.853 221.16C583.543 221.62 583.59 222.231 583.961 222.64L584.538 223.272L585.129 223.922",
    stroke: "#332B27"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M592.492 215.812C592.492 215.812 591.247 213.717 589.148 213.738",
    stroke: "#332B27"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M581.242 211.971C581.242 211.971 582.914 211.05 584.53 212.384",
    stroke: "#332B27"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M576.473 502.044L577.331 489.752H553.357L552.422 502.044H576.473Z",
    fill: "#FDAE97"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M546.057 318.604L545.924 318.566C539.939 316.931 536.384 310.701 538.026 304.725L551.383 256.045C553.024 250.069 559.259 246.52 565.244 248.155L565.378 248.193C571.362 249.833 574.917 256.058 573.28 262.034L559.918 310.718C558.281 316.69 552.042 320.239 546.057 318.604Z",
    fill: "#FFCB83"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M552.93 495.321L577.326 489.754H553.352L552.93 495.321Z",
    fill: "#EA9D85"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M612.063 502.044L611.141 489.731L635.696 489.752L636.114 502.044H612.063Z",
    fill: "#FDAE97"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M611.653 496.597L635.696 489.752L611.141 489.73L611.653 496.597Z",
    fill: "#EA9D85"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M540.609 512.386H576.01L576.07 510.949L576.506 501.424H552.415C549.434 501.424 546.676 503.171 544.565 504.995C542.82 506.552 541.523 508.6 540.915 510.949C540.773 511.414 540.67 511.9 540.609 512.386Z",
    fill: "#322A28"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M647.74 512.386H612.339L612.279 510.949L611.844 501.424H635.934C638.916 501.424 641.673 503.171 643.785 504.995C645.53 506.552 646.827 508.6 647.434 510.949C647.576 511.414 647.68 511.9 647.74 512.386Z",
    fill: "#322A28"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M647.735 512.386H612.334L612.273 510.949H647.429C647.571 511.414 647.674 511.9 647.735 512.386Z",
    fill: "#FFF1F0"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M636.663 503.709C636.663 503.709 633.604 498.344 631.544 500.465C629.481 502.586 636.663 503.709 636.663 503.709Z",
    stroke: "#FFF1F0"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M635.578 504.779L636.655 503.712M636.655 503.712C636.655 503.712 639.715 498.347 641.774 500.468C643.838 502.589 636.655 503.712 636.655 503.712Z",
    stroke: "#FFF1F0"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M637.479 504.779L636.656 503.712",
    stroke: "#FFF1F0"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M592.34 383.25L589.522 373.85H586.82L582.516 362.212",
    stroke: "white"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M636.664 480.876H608.945",
    stroke: "white"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M580.14 480.876H552.422",
    stroke: "white"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M587.497 225.762L583.055 226.553C583.055 226.553 583.572 228.834 585.791 228.567C588.014 228.296 587.497 225.762 587.497 225.762Z",
    fill: "white"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M529.805 331.939H582.7L568.894 292.388H516L529.805 331.939Z",
    fill: "#A5BBD6"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M582.121 330.023L599.421 314.746H548.258L529.227 330.023H582.121Z",
    fill: "#89A5C7"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M530.813 331.071H583.707L569.902 291.52H517.008L530.813 331.071Z",
    fill: "#D9E5F4"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M517 291.515L516 292.388H568.894L582.7 331.939L583.699 331.066L569.894 291.515H517Z",
    fill: "#89A5C7"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M599.421 314.743L599.999 316.662L582.699 331.939L582.031 330.02L599.421 314.743Z",
    fill: "#586773"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M572.157 337.451C572.506 338.385 578.543 338.333 582.713 336.926C586.255 335.734 594.119 332.116 596.428 331.032L592.063 316.869C590.585 317.123 587.518 317.346 586.126 317.678C582.425 318.547 575.337 321.571 575.539 322.952C575.725 324.32 582.196 323.025 581.809 323.671C581.416 324.312 576.664 326.867 574.514 327.052C572.347 327.246 567.659 326.902 566.995 327.977C566.327 329.066 567.624 330.408 567.624 330.408C567.624 330.408 565.845 330.068 565.836 331.217C565.827 332.366 568.464 333.583 568.464 333.583C568.464 333.583 567.508 333.282 567.809 334.547C568.128 335.825 572.665 336.285 572.665 336.285C572.665 336.285 571.786 336.522 572.157 337.451Z",
    fill: "#FDAE97"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M591.195 314.069L635.808 296.172C641.173 294.201 647.39 297.544 649.644 303.61C651.88 309.681 649.32 316.263 643.956 318.247L597.477 334.453L591.195 314.069Z",
    fill: "#FFCB83"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M623.401 300.611L595.641 311.416L596.23 312.93L625.509 301.534L616.714 279.144L615.202 279.738L623.401 300.611Z",
    fill: "white"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M601.816 333.807L626.768 325.104L626.233 323.569L601.281 332.273L601.816 333.807Z",
    fill: "white"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M554.868 315.835C554.298 316.861 553.684 317.4 552.778 318.146L551.771 317.153C552.566 316.649 553.17 315.976 553.625 315.156C554.081 314.335 554.322 313.415 554.327 312.479C554.329 312.13 554.299 311.783 554.236 311.443L555.32 310.007C555.616 310.795 555.751 311.622 555.746 312.486C555.74 313.658 555.438 314.809 554.868 315.835ZM554.716 308.784C554.198 307.926 553.565 307.2 552.706 306.642L551.711 307.671C552.501 308.184 553.234 308.886 553.655 309.794C553.658 309.8 553.661 309.805 553.664 309.811L554.716 308.784Z",
    fill: "#4C5256"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M551.995 306.208C550.918 305.66 549.767 305.354 548.556 305.394C547.346 305.434 546.165 305.78 545.128 306.398C544.09 307.016 543.229 307.886 542.627 308.926C542.025 309.966 541.702 311.14 541.688 312.339C541.674 313.537 541.97 314.718 542.548 315.771C543.126 316.824 543.966 317.714 544.989 318.355C546.012 318.997 547.184 319.369 548.394 319.437C549.603 319.504 550.952 319.174 552.031 318.59L551.007 317.559C550.265 317.866 549.441 318.082 548.474 318.028C547.507 317.974 546.571 317.677 545.753 317.164C544.935 316.651 544.263 315.94 543.801 315.099C543.34 314.257 543.103 313.312 543.114 312.355C543.125 311.397 543.384 310.458 543.865 309.627C544.346 308.796 545.034 308.1 545.863 307.606C546.693 307.112 547.636 306.836 548.604 306.804C549.566 306.804 550.078 306.877 550.934 307.247L551.995 306.208Z",
    fill: "#21AAE9"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M544.656 309.891H545.989L548.182 315.597H546.849L544.656 309.891Z",
    fill: "#21AAE9"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M550.134 309.891H548.784L546.562 315.597H547.912L550.134 309.891Z",
    fill: "#21AAE9"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M546.444 309.891H545.977L545.953 309.903L546.214 310.587L546.249 310.575C546.164 310.316 546.336 310.15 546.433 310.1C546.65 309.97 546.531 309.907 546.444 309.891Z",
    fill: "#21AAE9"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M550.608 309.891H550.156L550.133 309.903L550.393 310.587L550.429 310.575C550.344 310.316 550.516 310.15 550.612 310.1C550.817 309.978 550.724 309.915 550.64 309.895C550.63 309.892 550.619 309.891 550.608 309.891Z",
    fill: "#21AAE9"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M547.296 313.277C547.385 313.369 547.447 313.315 547.468 313.277L547.49 313.283L547.385 313.555L547.258 313.283L547.296 313.277Z",
    fill: "#21AAE9"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M548.828 309.891H550.167L551.194 312.651L550.551 314.437L548.828 309.891Z",
    fill: "#21AAE9"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M548.118 315.066C548.075 315.242 548.14 315.325 548.178 315.345L548.16 315.408L547.992 315.234L548.052 315.037L548.118 315.066Z",
    fill: "#21AAE9"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M546.613 314.992C546.658 315.22 546.607 315.353 546.562 315.366L546.591 315.41L546.748 315.22L546.692 315.005L546.613 314.992Z",
    fill: "#21AAE9"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M549.593 311.976C549.454 311.736 549.343 311.876 549.305 311.976H549.203L549.443 311.28L549.713 311.976H549.593Z",
    fill: "#21AAE9"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M544.433 310.08C544.649 310.136 544.839 310.441 544.907 310.587H544.931L544.661 309.891H544.361C544.188 309.957 544.337 310.044 544.433 310.08Z",
    fill: "#21AAE9"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M546.433 315.407C546.649 315.351 546.839 315.046 546.907 314.9H546.931L546.661 315.596H546.378C546.367 315.596 546.355 315.594 546.345 315.589C546.198 315.524 546.34 315.441 546.433 315.407Z",
    fill: "#21AAE9"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M548.357 315.407C548.141 315.351 547.951 315.046 547.883 314.9H547.859L548.129 315.596H548.412C548.423 315.596 548.435 315.594 548.446 315.589C548.592 315.524 548.45 315.441 548.357 315.407Z",
    fill: "#21AAE9"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M550.558 315.407C550.774 315.351 550.964 315.046 551.032 314.9H551.056L550.786 315.596H550.503C550.492 315.596 550.48 315.594 550.47 315.589C550.323 315.524 550.465 315.441 550.558 315.407Z",
    fill: "#21AAE9"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M552.576 315.407C552.36 315.351 552.17 315.046 552.102 314.9H552.078L552.348 315.596H552.631C552.642 315.596 552.654 315.594 552.664 315.589C552.811 315.524 552.669 315.441 552.576 315.407Z",
    fill: "#21AAE9"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M548.308 309.891H548.759L548.783 309.903L548.522 310.587L548.487 310.575C548.572 310.316 548.4 310.15 548.303 310.1C548.099 309.978 548.191 309.915 548.275 309.895C548.286 309.892 548.297 309.891 548.308 309.891Z",
    fill: "#21AAE9"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M552.405 315.504H550.781V315.596H552.405V315.504Z",
    fill: "#21AAE9"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M550.751 315.189C550.726 315.261 550.668 315.335 550.642 315.363L550.594 315.448L550.811 315.55H552.349L552.361 315.484L552.349 315.315C552.451 312.842 555.489 309.03 556.995 307.433C553.057 310.19 551.191 313.752 550.751 315.189Z",
    fill: "#21AAE9"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M177.655 436.336C176.447 436.708 174.079 435.447 172.083 434.398C170.086 433.35 171.506 432.877 171.405 430.669C171.304 428.462 170.086 428.361 168.934 427.314C167.772 426.266 166.983 425.061 166.249 423.956C165.629 423.022 166.927 421.827 168.99 420.589C171.665 422.887 174.451 425.037 177.361 427.044C177.498 427.47 177.599 427.922 177.655 428.417C177.869 430.299 179.177 431.83 179.45 433.768C179.709 435.706 178.862 435.976 177.655 436.336Z",
    fill: "#93C3E6"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M177.363 427.044C174.452 425.038 171.666 422.888 168.992 420.59C169.376 420.363 169.771 420.138 170.2 419.914C172.93 418.449 169.241 414.731 171.407 414.879C172.93 414.98 173.088 415.768 173.878 416.918C174.667 418.078 175.503 418.708 176.134 419.969C176.766 421.22 176.393 421.806 176.449 423.528C176.494 424.813 177.013 425.839 177.363 427.044Z",
    fill: "#70CCF5"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M22 509.48V380.933H197.985V509.48H22Z",
    fill: "#00C99C"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M196.352 382.561V507.847H23.6328V382.561H196.352Z",
    fill: "white"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M196.352 382.564V394.373H23.6328V382.564H196.352Z",
    fill: "#FFCB83"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M185.438 391.864L192.24 385.071",
    stroke: "white"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M192.24 391.864L185.438 385.071",
    stroke: "white"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M109.991 426.719V427.88H108.828",
    stroke: "#70CCF5"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M106.48 427.88H32.4297",
    stroke: "#70CCF5"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2565 427.88H30.0938V426.719",
    stroke: "#70CCF5"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0938 424.147V420.291",
    stroke: "#70CCF5"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0938 419.008V417.847H31.2565",
    stroke: "#70CCF5"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6016 417.846H107.653",
    stroke: "#70CCF5"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M108.828 417.847H109.991V419.008",
    stroke: "#70CCF5"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M109.992 421.579V425.433",
    stroke: "#70CCF5"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9682 403.121H30.0938V400.281H48.9682V403.121Z",
    fill: "#E5F0F8"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M74.1479 403.121H55.2734V400.281H74.1479V403.121Z",
    fill: "#E5F0F8"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M99.3277 403.121H80.4531V400.281H99.3277V403.121Z",
    fill: "#E5F0F8"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M124.507 403.121H105.633V400.281H124.507V403.121Z",
    fill: "#E5F0F8"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M149.679 403.121H130.805V400.281H149.679V403.121Z",
    fill: "#E5F0F8"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M189.889 405.34H172.375V398.067H189.889V405.34Z",
    fill: "#70CCF5"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1828 488.378V507.847H30.0938V488.378H62.1828Z",
    fill: "#E5F0F8"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9619 489.665V507.847H31.3125V489.665H60.9619Z",
    fill: "white"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6966 502.46L44.0564 507.847H35.25L39.6966 502.46Z",
    fill: "#E5F0F8"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9619 507.847H46.7031L53.8904 495.739L58.9619 507.847Z",
    fill: "#E5F0F8"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M47.634 495.191C47.634 496.017 46.9622 496.688 46.1334 496.688C45.3046 496.688 44.6328 496.017 44.6328 495.191C44.6328 494.364 45.3046 493.692 46.1334 493.692C46.9622 493.692 47.634 494.364 47.634 495.191Z",
    fill: "#E5F0F8"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M189.886 488.378V507.847H157.797V488.378H189.886Z",
    fill: "#E5F0F8"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M188.665 489.665V507.847H159.016V489.665H188.665Z",
    fill: "white"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M167.401 502.46L171.76 507.847H162.953L167.401 502.46Z",
    fill: "#E5F0F8"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M186.664 507.847H174.406L181.593 495.739L186.664 507.847Z",
    fill: "#E5F0F8"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M175.344 495.191C175.344 496.017 174.672 496.688 173.843 496.688C173.016 496.688 172.344 496.017 172.344 495.191C172.344 494.364 173.016 493.692 173.843 493.692C174.672 493.692 175.344 494.364 175.344 495.191Z",
    fill: "#E5F0F8"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M147.313 488.378V507.847H115.227V488.378H147.313Z",
    fill: "#E5F0F8"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M146.099 489.665V507.847H116.445V489.665H146.099Z",
    fill: "white"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M124.829 502.46L129.189 507.847H120.383L124.829 502.46Z",
    fill: "#E5F0F8"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M144.102 507.847H131.844L139.031 495.739L144.102 507.847Z",
    fill: "#E5F0F8"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M132.775 495.191C132.775 496.017 132.103 496.688 131.274 496.688C130.445 496.688 129.773 496.017 129.773 495.191C129.773 494.364 130.445 493.692 131.274 493.692C132.103 493.692 132.775 494.364 132.775 495.191Z",
    fill: "#E5F0F8"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M104.745 488.378V507.847H72.6562V488.378H104.745Z",
    fill: "#E5F0F8"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M103.532 489.665V507.847H73.8828V489.665H103.532Z",
    fill: "white"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M82.2591 502.46L86.6189 507.847H77.8125L82.2591 502.46Z",
    fill: "#E5F0F8"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M101.532 507.847H89.2734L96.4607 495.739L101.532 507.847Z",
    fill: "#E5F0F8"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M90.2045 495.191C90.2045 496.017 89.5327 496.688 88.7039 496.688C87.8751 496.688 87.2031 496.017 87.2031 495.191C87.2031 494.364 87.8751 493.692 88.7039 493.692C89.5327 493.692 90.2045 494.364 90.2045 495.191Z",
    fill: "#E5F0F8"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M67.8523 441.681H30.0938V437.017H67.8523V441.681Z",
    fill: "#E5F0F8"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M88.459 441.681H71.0781V437.017H88.459V441.681Z",
    fill: "#E5F0F8"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5197 449.872H30.0938V445.208H54.5197V449.872Z",
    fill: "#E5F0F8"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M97.599 449.872H57.75V445.208H97.599V449.872Z",
    fill: "#E5F0F8"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6384 456.671H30.0938V454.61H36.6384V456.671Z",
    fill: "#E5F0F8"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M63.4069 456.671H37.5547V454.61H63.4069V456.671Z",
    fill: "#E5F0F8"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M86.8285 456.671H64.4375V454.61H86.8285V456.671Z",
    fill: "#E5F0F8"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M110.997 456.671H87.7422V454.61H110.997V456.671Z",
    fill: "#E5F0F8"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6693 460.601H30.0938V458.543H43.6693V460.601Z",
    fill: "#E5F0F8"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9759 460.601H44.7188V458.543H68.9759V460.601Z",
    fill: "#E5F0F8"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M110.999 460.601H70.0312V458.543H110.999V460.601Z",
    fill: "#E5F0F8"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9156 464.535H30.0938V462.475H50.9156V464.535Z",
    fill: "#E5F0F8"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M81.2493 464.535H51.7734V462.475H81.2493V464.535Z",
    fill: "#E5F0F8"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M111 464.535H82.3906V462.475H111V464.535Z",
    fill: "#E5F0F8"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6035 468.466H30.0938V466.408H55.6035V468.466Z",
    fill: "#E5F0F8"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M185.163 484.925H162.523V482.859H185.163V484.925Z",
    fill: "#E5F0F8"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M142.594 484.925H119.953V482.859H142.594V484.925Z",
    fill: "#E5F0F8"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M100.023 484.925H77.3828V482.859H100.023V484.925Z",
    fill: "#E5F0F8"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4533 484.925H34.8125V482.859H57.4533V484.925Z",
    fill: "#E5F0F8"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M114.098 421.908H34.1953V411.874H114.098V421.908Z",
    fill: "white"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M114.098 421.908H34.1953V411.874H114.098V421.908Z",
    stroke: "#70CCF5"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M94.0625 421.908H114.097V411.874H94.0625V421.908Z",
    fill: "#70CCF5"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M94.0625 421.908H114.097V411.874H94.0625V421.908Z",
    stroke: "#70CCF5"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M103.512 413.762C104.76 414.456 105.21 416.047 104.513 417.292C103.812 418.546 102.224 418.989 100.976 418.292C99.7206 417.592 99.2732 416.014 99.9745 414.76C100.672 413.515 102.257 413.06 103.512 413.762ZM100.619 418.929C102.062 419.734 103.84 419.338 104.836 418.085L110.191 421.072L110.709 420.146L105.355 417.159C105.906 415.656 105.309 413.936 103.864 413.13C102.262 412.236 100.232 412.804 99.3364 414.404C98.4408 416.005 99.0166 418.035 100.619 418.929Z",
    fill: "white"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M189.884 476.429H116.25V417.847H189.884V476.429Z",
    stroke: "#70CCF5"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M130.305 467.199V408.617H203.937V467.199H130.305Z",
    fill: "#70CCF5"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M201.137 464.242H133.102V411.569H201.137V464.242Z",
    fill: "white"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M133.102 464.242L152.336 440.93L165.848 457.635L184.913 425.511L201.137 464.242H133.102Z",
    fill: "#70CCF5"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M170.565 424.246C170.565 426.144 169.025 427.684 167.122 427.684C165.22 427.684 163.68 426.144 163.68 424.246C163.68 422.347 165.22 420.807 167.122 420.807C169.025 420.807 170.565 422.347 170.565 424.246Z",
    fill: "#70CCF5"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M97.0651 332.587C97.0626 332.938 96.7748 333.221 96.4223 333.219C96.07 333.217 95.7864 332.929 95.7891 332.577C95.7916 332.226 96.0794 331.943 96.4319 331.945C96.7844 331.947 97.0678 332.235 97.0651 332.587Z",
    stroke: "white"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M99.479 310.905C99.479 310.905 94.3133 304.331 102.004 301.134C105.883 299.522 106.982 297.429 105.894 294.501C104.807 291.569 106.021 288.391 109.098 286.693C112.175 284.998 113.5 279.952 119.923 282.912C119.923 282.912 128.021 286.084 127.695 291.026C127.367 295.965 127.433 295.545 129.161 298.906C130.889 302.267 127.288 306.288 127.154 308.304C127.022 310.274 127.888 310.905 127.888 310.905H99.479Z",
    fill: "#322A28"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M149.688 355.452C146.125 357.635 141.419 356.512 139.231 352.952L122.789 326.206C120.601 322.646 121.727 317.95 125.291 315.763C128.855 313.579 133.56 314.706 135.748 318.263L152.19 345.009C154.378 348.569 153.252 353.268 149.688 355.452Z",
    fill: "#00C99C"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M169.554 408.043C165.445 413.764 157.394 415.087 151.664 410.984L111.64 382.322C105.91 378.217 104.584 370.179 108.694 364.457C112.804 358.735 120.854 357.413 126.585 361.516L166.608 390.177C172.338 394.28 173.664 402.321 169.554 408.043Z",
    fill: "#0F4A8B"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M158.031 411.622C153.921 417.344 145.87 418.669 140.14 414.563L100.117 385.902C94.3867 381.799 93.0611 373.761 97.1706 368.04C101.28 362.318 109.331 360.993 115.061 365.098L155.084 393.76C160.815 397.863 162.14 405.901 158.031 411.622Z",
    fill: "#0F4A8B"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M110.274 311.538L96.9689 317.796C96.9689 317.796 99.9272 351.756 100.233 355.496C100.539 359.236 99.3918 364.888 99.3918 364.888H131.277C131.277 364.888 130.895 346.565 133.036 341.449C134.486 337.984 135.482 335.876 134.641 331.906C133.8 327.936 130.971 321.981 131.965 315.107L123.784 311.825L110.274 311.538Z",
    fill: "#00C99C"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M168.317 470.75L165.867 462.125L179.187 460.206L180.265 468.903L168.317 470.75Z",
    fill: "#FF8B7B"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M123.778 296.38V311.828C123.778 311.828 123.778 312.018 123.74 312.318C123.581 313.58 122.764 316.818 118.56 316.774C114.719 316.729 112.035 313.911 110.893 312.431C110.477 311.904 110.266 311.541 110.266 311.541L112.201 296.38H123.778Z",
    fill: "#FF8B7B"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M123.305 469.253L135.171 471.542L137.688 464.024L124.511 462.064L123.305 469.253Z",
    fill: "#FF8B7B"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M123.784 311.829L116.906 303.059L123.784 301.737V311.829Z",
    fill: "#824C3A"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M124.099 305.747C121.36 306.64 117.563 305.551 114.877 302.736C112.19 299.918 106.154 289.371 114.21 284.458C122.276 279.547 127.039 287.68 127.248 288.936C127.248 288.936 127.328 293.373 127.376 296.5C127.395 297.296 127.407 298.003 127.415 298.536C127.412 298.621 127.421 298.7 127.421 298.776C127.459 301.225 126.836 304.867 124.099 305.747Z",
    fill: "#FF8B7B"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M83.6804 359.669C79.9075 357.87 78.2953 353.317 80.0981 349.548L93.648 321.231C95.4509 317.463 100.013 315.853 103.785 317.652C107.558 319.454 109.171 324.008 107.368 327.776L93.8181 356.094C92.0153 359.862 87.4535 361.471 83.6804 359.669Z",
    fill: "#00C99C"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M155.713 390.557C149.323 392.845 146.003 399.873 148.296 406.254L164.373 464.022L184.183 460.948L172.136 401.391L172.131 401.394C172.064 400.248 171.841 399.093 171.434 397.96C169.14 391.579 162.102 388.266 155.713 390.557Z",
    fill: "#0F4A8B"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M121.242 478.317L126.86 479.305L127.859 475.748L130.279 479.908L143.532 482.243L135.172 471.545L123.305 469.257L121.242 478.317Z",
    fill: "#322A28"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M150.358 391.36C143.673 390.182 137.298 394.642 136.119 401.316L120.906 462.944L139.881 466.602L159.233 408.906L159.228 408.903C159.738 407.877 160.119 406.763 160.329 405.58C161.507 398.902 157.044 392.537 150.358 391.36Z",
    fill: "#0F4A8B"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M131.422 473.242L136.723 474.157",
    stroke: "white"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M119.927 282.915C119.927 282.915 127.273 283.151 128.216 290.179L124.486 290.359C124.486 290.359 124.545 287.948 122.67 286.894C122.67 286.894 123.991 288.734 123.539 290.536L119.219 290.965C119.219 290.965 119.029 288.346 119.261 287.314C119.261 287.314 118.217 289.703 118.184 291.132L115.143 291.966C115.143 291.966 115.164 294.408 114.062 295.286C112.962 296.166 111.491 300.086 111.491 300.086C111.491 300.086 108.336 291.445 109.731 288.693C111.125 285.938 113.621 281.52 119.927 282.915Z",
    fill: "#322A28"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M132.383 475.29L137.684 476.205",
    stroke: "white"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M169.324 479.863L174.956 478.96L174.732 475.271L178.384 478.408L191.67 476.274L180.261 468.906L168.312 470.752L169.324 479.863Z",
    fill: "#322A28"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M177.289 471.741L182.598 470.873",
    stroke: "white"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M178.867 473.36L184.176 472.492",
    stroke: "white"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M125.062 372.265C125.062 372.265 146.129 387.095 150.199 389.922C154.269 392.75 160.284 395.947 160.518 402.742C160.751 409.536 153.869 424.643 153.869 424.643",
    stroke: "#E5F0F8"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M113.575 297.338C114.051 298.781 114.039 299.708 112.904 300.081C111.768 300.453 110.196 299.844 109.72 298.399C109.245 296.957 109.78 295.483 110.915 295.11C112.05 294.738 113.099 295.893 113.575 297.338Z",
    fill: "#FF8B7B"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M110.703 296.565C110.703 296.565 112.523 296.48 112.682 298.017C112.682 298.017 112.085 297.471 111.176 297.632",
    stroke: "#724638"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M120.305 295.254C120.301 295.841 120.607 296.318 120.987 296.321C121.367 296.321 121.679 295.848 121.682 295.261C121.686 294.674 121.38 294.197 121 294.194C120.62 294.191 120.308 294.664 120.305 295.254Z",
    fill: "#322A28"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M125.336 294.83C125.332 295.417 125.638 295.894 126.018 295.897C126.399 295.9 126.71 295.423 126.714 294.837C126.717 294.25 126.412 293.773 126.031 293.77C125.651 293.767 125.339 294.243 125.336 294.83Z",
    fill: "#322A28"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M122.168 302.066C122.861 302.305 123.619 301.939 123.859 301.245L121.347 300.377C121.106 301.068 121.474 301.826 122.168 302.066Z",
    fill: "white"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M118.969 294.063C118.969 294.063 120.158 292.608 121.531 293.145",
    stroke: "#2C3447"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M125.445 292.906C125.445 292.906 126.304 292.751 127.211 293.685",
    stroke: "#2C3447"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M123.555 294.903C123.555 294.903 123.605 297.813 125.312 298.179C125.312 298.179 124.766 298.671 124.083 298.87",
    stroke: "#2C3447"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M121.237 298.458C121.094 299.017 120.136 299.257 119.099 298.992C118.061 298.727 117.336 298.058 117.479 297.499C117.622 296.94 118.58 296.701 119.617 296.966C120.655 297.231 121.38 297.9 121.237 298.458Z",
    fill: "#A14C53"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M127.412 298.536C126.788 298.558 126.287 298.363 126.162 297.984C125.999 297.488 126.525 296.873 127.373 296.501C127.391 297.296 127.403 298.003 127.412 298.536Z",
    fill: "#A14C53"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M138.548 350.987C136.724 346.79 138.267 342.04 141.977 340.434L175.806 330.831C176.863 330.263 178.05 329.568 178.962 328.871C181.083 327.255 187.363 323.544 187.892 324.453C188.421 325.358 184.634 328.773 185.169 328.972C185.704 329.171 189.067 327.315 190.438 326.409C191.808 325.504 194.434 323.089 195.338 323.418C196.239 323.749 196.113 325.157 196.113 325.157C196.113 325.157 197.004 324.112 197.548 324.79C198.094 325.472 197.102 327.432 197.102 327.432C197.102 327.432 197.538 326.801 197.952 327.7C198.366 328.6 195.891 331.011 195.891 331.011C195.891 331.011 196.53 330.739 196.751 331.462C196.972 332.188 193.366 334.997 190.229 336.129C187.427 337.136 180.504 338.796 179.049 339.14L148.612 355.696C144.902 357.305 140.373 355.185 138.548 350.987Z",
    fill: "#FF8B7B"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M99.6094 344.001L104.122 334.568",
    stroke: "#2C3447"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M155.915 382.797H119.453L128.969 355.534H165.431L155.915 382.797Z",
    fill: "#D9E5F4"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M119.853 381.474L107.93 370.943H143.197L156.315 381.474H119.853Z",
    fill: "#89A5C7"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M155.228 382.189H118.766L128.282 354.929H164.744L155.228 382.189Z",
    fill: "#D9E5F4"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M164.744 354.931L165.432 355.534H128.97L119.454 382.797L118.766 382.191L128.282 354.931H164.744Z",
    fill: "#89A5C7"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M107.929 370.941L107.531 372.266L119.454 382.797L119.916 381.472L107.929 370.941Z",
    fill: "#E6F4FF"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M80.0801 348.765C82.2309 344.722 86.9127 342.967 90.4843 344.864L119.086 365.298C120.189 365.772 121.474 366.264 122.586 366.545C125.174 367.195 131.994 369.786 131.613 370.764C131.232 371.743 126.199 370.913 126.376 371.452C126.553 371.995 130.103 373.466 131.667 373.971C133.23 374.479 136.756 375.025 137.062 375.934C137.366 376.846 136.185 377.622 136.185 377.622C136.185 377.622 137.556 377.666 137.364 378.515C137.171 379.364 135.017 379.815 135.017 379.815C135.017 379.815 135.783 379.762 135.337 380.645C134.892 381.529 131.458 381.097 131.458 381.097C131.458 381.097 132.07 381.425 131.64 382.05C131.211 382.675 126.764 381.611 123.922 379.863C121.387 378.304 115.773 373.933 114.596 373.011L82.6636 359.555C79.0921 357.661 77.9296 352.804 80.0801 348.765Z",
    fill: "#FF8B7B"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M132.921 341.748C132.921 341.748 135.318 336.714 134.928 334.098C134.539 331.485 132.407 324.422 132.125 322.251",
    stroke: "#2C3447"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M200.734 407.889C200.734 407.889 201.448 419.346 201.7 424.414C201.953 429.485 200.734 447.327 200.734 447.327",
    stroke: "white"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M186.844 516.572H201.65L201.675 515.971H186.972C186.912 516.165 186.869 516.368 186.844 516.572Z",
    fill: "#FFF1F0"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M191.484 512.806C191.484 512.806 192.764 510.564 193.627 511.451C194.488 512.337 191.484 512.806 191.484 512.806Z",
    stroke: "#FFF1F0"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M191.934 513.254L191.484 512.806M191.484 512.806C191.484 512.806 190.204 510.564 189.343 511.451C188.481 512.336 191.484 512.806 191.484 512.806Z",
    stroke: "#FFF1F0"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M191.133 513.254L191.477 512.806",
    stroke: "#FFF1F0"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M193.828 448.306C193.828 448.306 197.281 449.454 200.734 448.542",
    stroke: "white"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M200.74 428.603C200.74 428.957 200.451 429.245 200.096 429.245C199.741 429.245 199.453 428.957 199.453 428.603C199.453 428.249 199.741 427.962 200.096 427.962C200.451 427.962 200.74 428.249 200.74 428.603Z",
    fill: "white"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M200.74 434.504C200.74 434.86 200.451 435.146 200.096 435.146C199.741 435.146 199.453 434.86 199.453 434.504C199.453 434.15 199.741 433.863 200.096 433.863C200.451 433.863 200.74 434.15 200.74 434.504Z",
    fill: "white"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M199.927 444.614C199.927 444.969 199.639 445.257 199.284 445.257C198.929 445.257 198.641 444.969 198.641 444.614C198.641 444.26 198.929 443.972 199.284 443.972C199.639 443.972 199.927 444.26 199.927 444.614Z",
    fill: "white"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M148.469 372.294C148.016 373.109 147.528 373.537 146.809 374.13L146.009 373.341C146.64 372.941 147.12 372.406 147.482 371.754C147.844 371.103 148.035 370.372 148.039 369.628C148.041 369.351 148.016 369.076 147.967 368.805L148.827 367.664C149.062 368.291 149.17 368.947 149.166 369.634C149.161 370.565 148.921 371.479 148.469 372.294ZM148.348 366.694C147.937 366.012 147.434 365.435 146.752 364.992L145.961 365.809C146.588 366.217 147.171 366.775 147.505 367.496C147.507 367.5 147.51 367.505 147.512 367.509L148.348 366.694Z",
    fill: "#4C5256"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M146.188 364.649C145.332 364.214 144.418 363.971 143.456 364.003C142.494 364.035 141.557 364.309 140.733 364.8C139.908 365.291 139.225 365.982 138.746 366.808C138.268 367.634 138.011 368.567 138 369.519C137.989 370.471 138.224 371.409 138.683 372.246C139.142 373.082 139.81 373.789 140.623 374.298C141.435 374.808 142.366 375.104 143.327 375.157C144.288 375.211 145.359 374.949 146.216 374.484L145.402 373.666C144.814 373.91 144.159 374.081 143.391 374.038C142.623 373.996 141.879 373.759 141.229 373.352C140.58 372.945 140.046 372.38 139.679 371.711C139.312 371.043 139.124 370.292 139.133 369.532C139.142 368.771 139.347 368.025 139.729 367.365C140.112 366.705 140.658 366.152 141.317 365.76C141.976 365.367 142.725 365.148 143.494 365.123C144.258 365.123 144.665 365.181 145.345 365.474L146.188 364.649Z",
    fill: "#21AAE9"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M140.359 367.573H141.418L143.16 372.105H142.101L140.359 367.573Z",
    fill: "#21AAE9"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M144.704 367.573H143.632L141.867 372.105H142.939L144.704 367.573Z",
    fill: "#21AAE9"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M141.781 367.573H141.409L141.391 367.582L141.598 368.126L141.626 368.117C141.558 367.91 141.695 367.779 141.772 367.739C141.945 367.636 141.85 367.586 141.781 367.573Z",
    fill: "#21AAE9"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M145.088 367.573H144.73L144.711 367.582L144.918 368.126L144.946 368.117C144.878 367.91 145.015 367.779 145.092 367.739C145.254 367.642 145.181 367.592 145.114 367.576C145.106 367.574 145.097 367.573 145.088 367.573Z",
    fill: "#21AAE9"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M142.453 370.263C142.523 370.336 142.572 370.293 142.589 370.263L142.606 370.267L142.523 370.484L142.422 370.267L142.453 370.263Z",
    fill: "#21AAE9"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M143.672 367.573H144.735L145.551 369.766L145.041 371.184L143.672 367.573Z",
    fill: "#21AAE9"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M143.108 371.688C143.073 371.828 143.125 371.894 143.155 371.909L143.141 371.96L143.008 371.821L143.055 371.665L143.108 371.688Z",
    fill: "#21AAE9"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M141.907 371.625C141.943 371.806 141.903 371.912 141.867 371.922L141.89 371.957L142.015 371.806L141.97 371.635L141.907 371.625Z",
    fill: "#21AAE9"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M144.279 369.232C144.168 369.041 144.08 369.152 144.05 369.232H143.969L144.159 368.679L144.374 369.232H144.279Z",
    fill: "#21AAE9"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M140.175 367.723C140.347 367.768 140.497 368.01 140.551 368.126H140.571L140.356 367.573H140.118C139.981 367.626 140.099 367.695 140.175 367.723Z",
    fill: "#21AAE9"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M141.769 371.954C141.94 371.909 142.091 371.667 142.145 371.551H142.164L141.95 372.104H141.725C141.716 372.104 141.707 372.102 141.699 372.099C141.582 372.047 141.695 371.981 141.769 371.954Z",
    fill: "#21AAE9"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M143.294 371.954C143.122 371.909 142.972 371.667 142.918 371.551H142.898L143.113 372.104H143.337C143.346 372.104 143.356 372.102 143.364 372.099C143.481 372.047 143.368 371.981 143.294 371.954Z",
    fill: "#21AAE9"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M145.05 371.954C145.222 371.909 145.372 371.667 145.426 371.551H145.446L145.231 372.104H145.007C144.998 372.104 144.988 372.102 144.98 372.099C144.863 372.047 144.976 371.981 145.05 371.954Z",
    fill: "#21AAE9"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M146.646 371.954C146.474 371.909 146.323 371.667 146.269 371.551H146.25L146.464 372.104H146.689C146.698 372.104 146.707 372.102 146.716 372.099C146.832 372.047 146.719 371.981 146.646 371.954Z",
    fill: "#21AAE9"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M143.258 367.573H143.616L143.635 367.582L143.428 368.126L143.4 368.117C143.468 367.91 143.331 367.779 143.254 367.739C143.092 367.642 143.165 367.592 143.232 367.576C143.241 367.574 143.249 367.573 143.258 367.573Z",
    fill: "#21AAE9"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M146.516 372.035H145.227V372.109H146.516V372.035Z",
    fill: "#21AAE9"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M145.195 371.784C145.176 371.842 145.129 371.901 145.109 371.923L145.07 371.99L145.243 372.072H146.465L146.474 372.019L146.465 371.885C146.545 369.92 148.958 366.892 150.155 365.624C147.027 367.814 145.545 370.644 145.195 371.784Z",
    fill: "#21AAE9"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M523 397C526.314 397 529 394.314 529 391C529 387.686 526.314 385 523 385C519.686 385 517 387.686 517 391C517 394.314 519.686 397 523 397Z",
    fill: "#A4DBF4"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M629 174C632.866 174 636 170.866 636 167C636 163.134 632.866 160 629 160C625.134 160 622 163.134 622 167C622 170.866 625.134 174 629 174Z",
    stroke: "#21AAE9",
    strokeOpacity: 0.65
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_39_780",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 721,
    y: 215,
    width: 43,
    height: 43
  }, _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M764 215H721V258H764V215Z",
    fill: "#D9D9D9"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_39_780)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M722.609 244.891H723.92V239.748L725.948 244.233C726.188 244.774 726.515 244.968 727.158 244.968C727.8 244.968 728.115 244.776 728.355 244.233L730.384 239.748V244.893H731.694V239.756C731.694 239.255 731.492 239.013 731.077 238.887C730.081 238.578 729.414 238.846 729.111 239.514L727.121 243.941L725.192 239.512C724.903 238.844 724.222 238.576 723.227 238.885C722.811 239.011 722.609 239.253 722.609 239.754V244.891ZM732.784 240.703H734.094V243.538C734.081 243.692 734.143 244.054 734.861 244.065C735.227 244.071 737.688 244.065 737.711 244.065V240.689H739.023C739.029 240.689 739.022 245.292 739.022 245.312C739.03 246.447 737.606 246.693 736.95 246.713H732.812V245.836H736.957C737.8 245.747 737.701 245.33 737.701 245.19V244.848H734.916C733.62 244.836 732.795 244.274 732.785 243.627C732.784 243.569 732.813 240.731 732.784 240.703Z",
    fill: "#00618A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M740.031 244.891H743.799C744.24 244.891 744.668 244.799 745.009 244.641C745.576 244.382 745.853 244.031 745.853 243.571V242.619C745.853 242.243 745.538 241.893 744.921 241.659C744.593 241.533 744.19 241.466 743.799 241.466H742.212C741.683 241.466 741.43 241.308 741.367 240.957C741.355 240.915 741.355 240.88 741.355 240.84V240.247C741.355 240.214 741.355 240.18 741.367 240.138C741.43 239.871 741.569 239.796 742.035 239.752C742.073 239.752 742.123 239.744 742.161 239.744H745.904V238.875H742.224C741.695 238.875 741.418 238.909 741.166 238.984C740.384 239.226 740.044 239.612 740.044 240.281V241.041C740.044 241.625 740.712 242.127 741.833 242.243C741.959 242.252 742.085 242.26 742.211 242.26H743.572C743.622 242.26 743.673 242.26 743.71 242.269C744.126 242.302 744.303 242.377 744.428 242.527C744.506 242.605 744.529 242.678 744.529 242.759V243.519C744.529 243.611 744.467 243.728 744.34 243.828C744.227 243.929 744.038 243.995 743.786 244.012C743.736 244.012 743.698 244.02 743.648 244.02H740.031V244.889V244.891ZM754.027 243.379C754.027 244.273 754.695 244.774 756.043 244.875C756.169 244.884 756.295 244.89 756.421 244.891H759.836V244.022H756.396C755.627 244.022 755.337 243.83 755.337 243.371V238.877H754.027V243.379ZM746.689 243.425V240.328C746.689 239.541 747.244 239.064 748.343 238.913C748.46 238.897 748.578 238.888 748.696 238.888H751.184C751.306 238.888 751.429 238.897 751.55 238.913C752.648 239.064 753.204 239.541 753.204 240.328V243.425C753.204 244.063 752.968 244.404 752.424 244.627L753.715 245.786H752.193L751.149 244.848L750.098 244.915H748.696C748.457 244.915 748.204 244.881 747.926 244.806C747.091 244.58 746.689 244.145 746.689 243.425ZM748.103 243.347C748.103 243.389 748.116 243.431 748.128 243.481C748.206 243.841 748.545 244.042 749.061 244.042H750.251L749.158 243.061H750.679L751.631 243.917C751.807 243.824 751.922 243.681 751.961 243.498C751.974 243.456 751.974 243.415 751.974 243.373V240.403C751.974 240.37 751.974 240.326 751.961 240.286C751.883 239.951 751.544 239.759 751.039 239.759H749.063C748.48 239.759 748.104 240.01 748.104 240.403V243.35L748.103 243.347Z",
    fill: "#E48E00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M760.989 237.436C760.183 237.414 759.568 237.489 759.042 237.709C758.893 237.772 758.654 237.774 758.63 237.96C758.712 238.045 758.725 238.173 758.79 238.279C758.916 238.481 759.128 238.752 759.317 238.893C759.524 239.049 759.736 239.215 759.958 239.349C760.353 239.588 760.793 239.725 761.172 239.964C761.396 240.105 761.618 240.283 761.836 240.442C761.944 240.521 762.017 240.644 762.157 240.693V240.67C762.083 240.577 762.064 240.449 761.997 240.351L761.699 240.055C761.408 239.669 761.038 239.334 760.645 239.053C760.332 238.829 759.631 238.527 759.5 238.165L759.477 238.142C759.699 238.117 759.959 238.037 760.165 237.983C760.509 237.891 760.817 237.914 761.173 237.823L761.654 237.686V237.595C761.474 237.412 761.346 237.169 761.15 237.003C760.637 236.569 760.077 236.135 759.501 235.773C759.181 235.572 758.786 235.442 758.447 235.272C758.333 235.215 758.133 235.185 758.058 235.089C757.88 234.864 757.783 234.578 757.646 234.317C757.358 233.767 757.076 233.165 756.821 232.586C756.647 232.191 756.534 231.802 756.317 231.447C755.277 229.747 754.158 228.721 752.424 227.712C752.055 227.498 751.61 227.413 751.141 227.302L750.385 227.257C750.231 227.193 750.071 227.005 749.927 226.915C749.352 226.554 747.879 225.769 747.453 226.799C747.184 227.45 747.855 228.086 748.094 228.416C748.263 228.648 748.478 228.907 748.598 229.168C748.677 229.339 748.691 229.51 748.759 229.692C748.925 230.136 749.07 230.623 749.285 231.035C749.394 231.244 749.514 231.464 749.652 231.65C749.736 231.765 749.881 231.815 749.904 231.992C749.762 232.189 749.754 232.494 749.675 232.744C749.317 233.866 749.452 235.261 749.972 236.092C750.132 236.347 750.508 236.894 751.026 236.684C751.478 236.501 751.375 235.933 751.507 235.431C751.536 235.318 751.518 235.235 751.576 235.158V235.181L751.988 236.001C752.293 236.489 752.835 237 753.294 237.345C753.531 237.524 753.721 237.833 754.026 237.937V237.914H754.004C753.944 237.822 753.851 237.784 753.774 237.71C753.595 237.535 753.396 237.318 753.247 237.117C752.83 236.554 752.461 235.937 752.125 235.295C751.965 234.989 751.825 234.651 751.69 234.339C751.638 234.219 751.639 234.037 751.53 233.974C751.382 234.203 751.164 234.388 751.049 234.658C750.866 235.089 750.842 235.615 750.774 236.161C750.734 236.175 750.752 236.165 750.728 236.184C750.409 236.107 750.297 235.781 750.179 235.5C749.879 234.792 749.823 233.651 750.087 232.836C750.155 232.625 750.464 231.96 750.339 231.765C750.279 231.571 750.083 231.456 749.972 231.309C749.837 231.126 749.7 230.884 749.606 230.672C749.361 230.119 749.246 229.5 748.988 228.941C748.864 228.674 748.655 228.404 748.484 228.168C748.294 227.906 748.081 227.712 747.934 227.396C747.882 227.283 747.811 227.102 747.888 226.986C747.896 226.952 747.913 226.922 747.937 226.897C747.961 226.873 747.992 226.856 748.026 226.849C748.159 226.747 748.529 226.883 748.667 226.94C749.034 227.092 749.341 227.236 749.652 227.441C749.802 227.538 749.953 227.73 750.133 227.783H750.339C750.661 227.857 751.023 227.806 751.324 227.897C751.856 228.058 752.333 228.308 752.767 228.58C754.087 229.409 755.166 230.589 755.905 231.999C756.023 232.225 756.075 232.442 756.179 232.682C756.39 233.165 756.656 233.666 756.867 234.139C757.076 234.613 757.28 235.09 757.577 235.483C757.732 235.69 758.334 235.801 758.607 235.916C758.799 235.996 759.113 236.08 759.294 236.189C759.641 236.397 759.977 236.645 760.302 236.873C760.465 236.987 760.965 237.236 760.99 237.442L760.989 237.436Z",
    fill: "#00618A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M750.756 228.759C750.588 228.755 750.469 228.777 750.344 228.804V228.827H750.367C750.447 228.991 750.588 229.096 750.687 229.237L750.916 229.715L750.939 229.692C751.081 229.593 751.146 229.434 751.145 229.191C751.088 229.132 751.08 229.057 751.031 228.986C750.965 228.891 750.836 228.838 750.756 228.758V228.759Z",
    fill: "#00618A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M760.453 243.998C760.453 244.572 760.909 244.958 761.419 244.958C761.929 244.958 762.384 244.572 762.384 243.998C762.384 243.425 761.929 243.038 761.419 243.038C760.909 243.038 760.453 243.425 760.453 243.998ZM762.168 243.998C762.168 244.433 761.833 244.759 761.418 244.759C760.999 244.759 760.669 244.433 760.669 243.998C760.669 243.563 760.998 243.238 761.418 243.238C761.833 243.238 762.168 243.563 762.168 243.998ZM761.679 244.546H761.895L761.578 244.065C761.748 244.047 761.877 243.965 761.877 243.765C761.877 243.542 761.735 243.45 761.462 243.45H761.032V244.546H761.218V244.073H761.39L761.678 244.546H761.679ZM761.218 243.919V243.604H761.431C761.542 243.604 761.676 243.624 761.676 243.752C761.676 243.906 761.555 243.919 761.416 243.919H761.218Z",
    fill: "#E48E00"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_39_780",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 699,
    y: 63,
    width: 30,
    height: 30
  }, _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M729 63H699V93H729V63Z",
    fill: "#D9D9D9"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_39_780)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M725.362 65.5924C724.974 66.5245 724.477 67.4073 723.881 68.2223C722.581 66.9151 721.034 65.8797 719.33 65.1763C717.626 64.473 715.8 64.1157 713.957 64.1252C712.114 64.1347 710.292 64.5109 708.595 65.2318C706.899 65.9528 705.363 67.0041 704.076 68.3247C702.789 69.6453 701.778 71.2089 701.1 72.9244C700.422 74.6399 700.091 76.4732 700.128 78.3177C700.164 80.1622 700.566 81.9811 701.311 83.6686C702.055 85.3561 703.128 86.8786 704.466 88.1475L704.979 88.6016C706.94 90.2555 709.32 91.3342 711.855 91.7183C714.39 92.1024 716.982 91.777 719.343 90.7781C721.705 89.7791 723.745 88.1456 725.237 86.0582C726.729 83.9707 727.615 81.5109 727.797 78.9506C728.176 75.4073 727.137 70.9229 725.363 65.5928L725.362 65.5924ZM706.443 88.2282C706.295 88.4112 706.096 88.5462 705.872 88.616C705.647 88.6858 705.407 88.6874 705.181 88.6206C704.956 88.5537 704.755 88.4214 704.605 88.2403C704.455 88.0593 704.361 87.8376 704.337 87.6035C704.312 87.3693 704.358 87.1332 704.467 86.9249C704.577 86.7166 704.746 86.5455 704.953 86.4333C705.159 86.3211 705.395 86.2728 705.629 86.2945C705.863 86.3163 706.086 86.4071 706.268 86.5554C706.513 86.7541 706.669 87.0419 706.701 87.3555C706.734 87.6692 706.641 87.9831 706.443 88.2282ZM725.305 84.0604C721.874 88.6359 714.548 87.0919 709.851 87.3139C709.851 87.3139 709.018 87.363 708.18 87.5004C708.18 87.5004 708.496 87.366 708.9 87.2129C712.199 86.0636 713.758 85.8424 715.762 84.8102C719.534 82.8903 723.266 78.6856 724.042 74.3148C722.606 78.5195 718.248 82.1352 714.281 83.6037C711.562 84.6068 706.65 85.584 706.65 85.584L706.452 85.4777C703.11 83.8513 703.007 76.6056 709.085 74.2689C711.746 73.2427 714.292 73.8061 717.166 73.1196C720.235 72.3897 723.786 70.0881 725.231 67.0843C726.847 71.8896 728.794 79.4107 725.303 84.0634L725.305 84.0604Z",
    fill: "#68BD45"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_39_780",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 288,
    y: 16,
    width: 30,
    height: 30
  }, _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M318 16H288V46H318V16Z",
    fill: "#D9D9D9"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_39_780)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M294.675 17.125L300.225 26.3692L294.672 35.6264L289.125 26.3692L294.675 17.125Z",
    fill: "#59666C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.779 17.1254H294.68L300.23 26.3696H311.333L305.779 17.1254Z",
    fill: "#BCAE79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.324 44.8749L305.773 35.6307L311.327 26.3735L316.874 35.6307L311.324 44.8749Z",
    fill: "#59666C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.226 44.8742H311.327L305.781 35.63H294.672L300.226 44.8742Z",
    fill: "#BCAE79"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_39_780",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 38,
    y: 50,
    width: 30,
    height: 30
  }, _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M68 50H38V80H68V50Z",
    fill: "#D9D9D9"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_39_780)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.3684 63.7039C64.3684 70.2279 59.0537 75.5158 52.4967 75.5158C45.9396 75.5158 40.625 70.2279 40.625 63.7039C40.625 57.1799 45.9396 51.892 52.4967 51.892C59.0537 51.8861 64.3684 57.1799 64.3684 63.7039Z",
    fill: "#008DC2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.8904 59.8296C45.8904 60.3504 45.4647 60.7739 44.9413 60.7739C44.4179 60.7739 43.9922 60.3504 43.9922 59.8296C43.9922 59.3088 44.4179 58.8853 44.9413 58.8853C45.066 58.885 45.1896 58.9091 45.3049 58.9565C45.4202 59.0038 45.525 59.0734 45.6132 59.1611C45.7014 59.2489 45.7713 59.3531 45.8188 59.4678C45.8664 59.5826 45.8907 59.7055 45.8904 59.8296Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.0467 62.4217C46.0467 62.9425 45.621 63.366 45.0975 63.366C44.5741 63.366 44.1484 62.9425 44.1484 62.4217C44.1484 61.9009 44.5741 61.4774 45.0975 61.4774C45.2223 61.4771 45.3459 61.5013 45.4612 61.5486C45.5764 61.596 45.6812 61.6655 45.7694 61.7532C45.8576 61.841 45.9275 61.9452 45.9751 62.0599C46.0226 62.1747 46.047 62.2976 46.0467 62.4217Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.6326 65.1686C46.6326 65.6894 46.207 66.1129 45.6835 66.1129C45.16 66.1129 44.7344 65.6894 44.7344 65.1686C44.7344 64.6478 45.16 64.2242 45.6835 64.2242C46.2071 64.2186 46.6326 64.6421 46.6326 65.1686ZM47.9326 67.6294C47.9326 68.1503 47.507 68.5737 46.9835 68.5737C46.4601 68.5737 46.0344 68.1503 46.0344 67.6294C46.0344 67.1086 46.4601 66.6851 46.9835 66.6851C47.507 66.6794 47.9326 67.103 47.9326 67.6294Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.0935 71.0689C58.0935 71.5897 57.6679 72.0132 57.1444 72.0132C56.621 72.0132 56.1953 71.5897 56.1953 71.0689C56.1953 70.5481 56.621 70.1246 57.1444 70.1246C57.6679 70.1246 58.0935 70.5481 58.0935 71.0689Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8201 69.0373C59.8201 69.5582 59.3945 69.9817 58.871 69.9817C58.3475 69.9817 57.9219 69.5582 57.9219 69.0373C57.9219 68.5165 58.3475 68.093 58.871 68.093C59.3945 68.093 59.8201 68.5167 59.8201 69.0373Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.8123 54.6729C54.8123 55.1937 54.3866 55.6172 53.8631 55.6172C53.3397 55.6172 52.9141 55.1937 52.9141 54.6729C52.9141 54.1521 53.3397 53.7286 53.8631 53.7286C54.3866 53.7286 54.8123 54.1521 54.8123 54.6729Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.3202 53.8017C52.3202 54.3225 51.8946 54.746 51.3711 54.746C50.8477 54.746 50.4219 54.324 50.4219 53.8017C50.4219 53.2794 50.8475 52.8574 51.371 52.8574C51.8945 52.8574 52.3202 53.281 52.3202 53.8017Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0457 67.1832C62.54 67.1832 65.3727 64.3648 65.3727 60.8881C65.3727 57.4114 62.54 54.593 59.0457 54.593C55.5514 54.593 52.7188 57.4114 52.7188 60.8881C52.7188 64.3648 55.5514 67.1832 59.0457 67.1832Z",
    fill: "#68B346",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3797 78.8748C53.2387 78.8748 55.5563 76.5689 55.5563 73.7243C55.5563 70.8798 53.2387 68.5739 50.3797 68.5739C47.5208 68.5739 45.2031 70.8798 45.2031 73.7243C45.2031 76.5689 47.5208 78.8748 50.3797 78.8748Z",
    fill: "#68B346",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1151 57.9923C48.021 57.9923 49.5662 56.455 49.5662 54.5586C49.5662 52.6623 48.021 51.125 46.1151 51.125C44.2091 51.125 42.6641 52.6623 42.6641 54.5586C42.6641 56.455 44.2091 57.9923 46.1151 57.9923Z",
    fill: "#68B346",
    stroke: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_39_780",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 47,
    y: 260,
    width: 30,
    height: 30
  }, _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M77 260H47V290H77V260Z",
    fill: "#D9D9D9"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_39_780)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.7863 281.506C73.3054 282.286 65.6346 285.468 64.0014 286.327C62.3682 287.186 61.4612 287.178 60.1708 286.556C58.8804 285.934 50.7175 282.606 49.2462 281.897C48.5105 281.542 48.125 281.243 48.125 280.961V278.131C48.125 278.131 58.7532 275.796 60.4695 275.175C62.1858 274.553 62.7795 274.531 64.2405 275.071C65.7015 275.61 74.4317 277.2 75.8743 277.734V280.525C75.8743 280.805 75.5418 281.119 74.7877 281.508L74.7863 281.506Z",
    fill: "#A41E11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.787 278.675C73.3061 279.455 65.6353 282.637 64.0021 283.496C62.3689 284.355 61.4618 284.347 60.1715 283.725C58.8811 283.103 50.7182 279.775 49.2469 279.066C47.7755 278.356 47.7461 277.868 49.1902 277.297L60.4694 272.891C62.185 272.27 62.7794 272.247 64.2405 272.787C65.7015 273.326 73.3259 276.389 74.7678 276.931C76.2097 277.472 76.2664 277.903 74.7855 278.683L74.787 278.675Z",
    fill: "#D82C20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.7863 276.89C73.3054 277.67 65.6346 280.852 64.0014 281.711C62.3682 282.57 61.4612 282.562 60.1708 281.94C58.8804 281.318 50.7175 277.991 49.2462 277.281C48.5105 276.926 48.125 276.628 48.125 276.346V273.515C48.125 273.515 58.7532 271.18 60.4695 270.559C62.1858 269.938 62.7795 269.915 64.2405 270.455C65.7015 270.995 74.4317 272.584 75.8743 273.118V275.909C75.8743 276.189 75.5418 276.503 74.7877 276.892L74.7863 276.89Z",
    fill: "#A41E11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.7869 274.06C73.3061 274.839 65.6353 278.022 64.0021 278.881C62.3689 279.74 61.4618 279.731 60.1715 279.109C58.8811 278.487 50.7182 275.16 49.2469 274.45C47.7755 273.741 47.7461 273.253 49.1902 272.682L60.4694 268.276C62.185 267.655 62.7794 267.632 64.2404 268.172C65.7015 268.712 73.3259 271.775 74.7693 272.307C76.2127 272.839 76.2679 273.28 74.7869 274.059V274.06Z",
    fill: "#D82C20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.7863 272.104C73.3054 272.883 65.6346 276.066 64.0014 276.925C62.3682 277.785 61.4612 277.776 60.1708 277.154C58.8804 276.532 50.7175 273.205 49.2462 272.495C48.5105 272.14 48.125 271.842 48.125 271.56V268.727C48.125 268.727 58.7532 266.393 60.4695 265.771C62.1858 265.15 62.7795 265.128 64.2405 265.667C65.7015 266.207 74.4317 267.797 75.8743 268.33V271.122C75.8743 271.401 75.5418 271.715 74.7877 272.104H74.7863Z",
    fill: "#A41E11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.7869 269.272C73.3061 270.052 65.6353 273.234 64.0021 274.093C62.3689 274.952 61.4618 274.944 60.1715 274.322C58.8811 273.7 50.7182 270.373 49.2469 269.663C47.7755 268.953 47.7461 268.465 49.1902 267.895L60.4694 263.489C62.185 262.867 62.7794 262.845 64.2404 263.385C65.7015 263.924 73.3259 266.987 74.7693 267.52C76.2127 268.052 76.2679 268.492 74.7869 269.272Z",
    fill: "#D82C20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.6942 268.105L61.8247 266.647L59.0483 266.394L61.1199 265.64L60.4983 264.482L62.4375 265.246L64.2664 264.642L63.772 265.839L65.6362 266.544L63.232 266.797L62.6942 268.105ZM58.0625 271.009L64.4922 270.013L62.55 272.888L58.0625 271.009Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.3276 269.962C58.2259 269.962 59.7647 269.36 59.7647 268.618C59.7647 267.875 58.2259 267.273 56.3276 267.273C54.4294 267.273 52.8906 267.875 52.8906 268.618C52.8906 269.36 54.4294 269.962 56.3276 269.962Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.2829 268.422L68.4795 269.937L68.4766 266.903L72.2829 268.422Z",
    fill: "#7A0C00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.478 269.938L68.0661 270.101L64.2656 268.585L68.4759 266.904L68.478 269.938Z",
    fill: "#AD2115"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_39_780",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 119,
    y: 124,
    width: 30,
    height: 30
  }, _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M149 124H119V154H149V124Z",
    fill: "#D9D9D9"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_39_780)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.148 136.054C138.651 129.452 135.532 127.695 134.737 126.453C134.409 125.905 134.118 125.337 133.867 124.75C133.825 125.336 133.748 125.706 133.249 126.151C132.248 127.043 127.997 130.507 127.64 138.008C127.306 145.002 132.781 149.314 133.504 149.76C134.06 150.033 134.738 149.766 135.068 149.514C137.707 147.703 141.313 142.875 140.151 136.054",
    fill: "#10AA50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.094 146.036C133.956 147.767 133.858 148.772 133.508 149.762C133.508 149.762 133.737 151.41 133.899 153.155H134.47C134.606 151.926 134.814 150.706 135.092 149.501C134.353 149.137 134.123 147.555 134.094 146.036Z",
    fill: "#B8C4C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.094 149.502C134.347 149.157 134.131 147.541 134.098 146.036C134.282 143.553 134.336 141.062 134.259 138.573C134.22 137.267 134.278 126.478 133.938 124.898C134.17 125.433 134.438 125.952 134.74 126.452C135.536 127.695 138.656 129.452 140.151 136.054C141.316 142.863 137.73 147.679 135.094 149.502Z",
    fill: "#12924F"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask14_39_780",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 546,
    y: 16,
    width: 30,
    height: 30
  }, _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M576 16H546V46H576V16Z",
    fill: "#D9D9D9"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_39_780)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M549.75 17.125V32.132L561 38.5005V34.1712L553.475 29.9114V23.2215L561 27.4813V23.4847L549.75 17.125Z",
    fill: "#002A41",
    stroke: "#848484"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.25 17.125V32.132L561 38.5005V34.1712L568.525 29.9114V23.2215L561 27.4813V23.4847L572.25 17.125Z",
    fill: "#0071B5",
    stroke: "#848484"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.75 44.8751V29.8671L561 23.4996V27.828L553.475 32.0878V38.4302L561 34.1799V38.5084L549.75 44.8751Z",
    fill: "#0071B5",
    stroke: "#848484"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.25 44.875V29.867L561 23.4995V27.8279L568.525 32.0877V38.4301L561 34.1798V38.5083L572.25 44.875Z",
    fill: "#002A41",
    stroke: "#848484"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 144,
    cy: 369,
    r: 7,
    fill: "#D9E5F4"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_39_780)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask15_39_780",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 147,
    y: 366,
    width: 1,
    height: 2
  }, _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M147.192 366.929H148V367.839H147.192V366.929Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_39_780)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask16_39_780",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 147,
    y: 366,
    width: 1,
    height: 2
  }, _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M147.692 366.974C147.651 366.963 147.609 366.96 147.566 366.963C147.524 366.966 147.482 366.977 147.443 366.994C147.404 367.012 147.368 367.035 147.335 367.065C147.303 367.094 147.276 367.129 147.254 367.167C147.248 367.182 147.24 367.195 147.234 367.209C147.223 367.231 147.215 367.255 147.211 367.281C147.204 367.307 147.201 367.335 147.199 367.362C147.198 367.39 147.199 367.418 147.203 367.445C147.207 367.473 147.213 367.499 147.222 367.525C147.231 367.551 147.242 367.577 147.255 367.6C147.268 367.624 147.284 367.646 147.301 367.667C147.319 367.687 147.338 367.706 147.359 367.723C147.38 367.739 147.402 367.753 147.426 367.765C147.449 367.777 147.474 367.786 147.499 367.793C147.54 367.804 147.581 367.807 147.623 367.804C147.665 367.801 147.705 367.791 147.744 367.774C147.783 367.758 147.818 367.735 147.851 367.707C147.883 367.678 147.91 367.645 147.933 367.608L147.962 367.546H147.964C147.971 367.526 147.978 367.506 147.982 367.485C147.988 367.458 147.992 367.431 147.993 367.403C147.994 367.376 147.993 367.348 147.989 367.321C147.985 367.293 147.978 367.267 147.97 367.241C147.961 367.215 147.95 367.19 147.936 367.167C147.923 367.143 147.907 367.121 147.89 367.1C147.872 367.08 147.853 367.061 147.832 367.045C147.811 367.028 147.789 367.014 147.765 367.002C147.742 366.99 147.717 366.981 147.692 366.974Z",
    fill: "white"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_39_780)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M147.231 366.792L147.039 367.772L147.962 367.975L148.153 366.994L147.231 366.792Z",
    fill: "url(#paint7_linear_39_780)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask17_39_780",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 147,
    y: 371,
    width: 1,
    height: 2
  }, _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M147.114 371.23H147.977V372.14H147.114V371.23Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_39_780)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask18_39_780",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 147,
    y: 371,
    width: 1,
    height: 2
  }, _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M147.664 371.28C147.623 371.269 147.581 371.266 147.538 371.269C147.495 371.273 147.454 371.283 147.415 371.3C147.376 371.318 147.34 371.341 147.307 371.371C147.275 371.4 147.248 371.435 147.226 371.473L147.204 371.515C147.195 371.538 147.187 371.562 147.181 371.587C147.169 371.635 147.166 371.685 147.171 371.735C147.176 371.785 147.189 371.833 147.21 371.878C147.231 371.923 147.259 371.963 147.294 371.998C147.328 372.033 147.367 372.06 147.411 372.079C147.455 372.099 147.5 372.11 147.548 372.113C147.595 372.115 147.641 372.109 147.687 372.094C147.732 372.078 147.773 372.055 147.811 372.025C147.848 371.994 147.88 371.957 147.905 371.914C147.916 371.895 147.925 371.873 147.934 371.853H147.936C147.943 371.834 147.948 371.814 147.954 371.793C147.961 371.766 147.964 371.739 147.965 371.711C147.967 371.683 147.965 371.656 147.961 371.628C147.957 371.601 147.951 371.574 147.942 371.548C147.934 371.522 147.922 371.497 147.909 371.473C147.895 371.449 147.88 371.427 147.862 371.407C147.845 371.386 147.825 371.368 147.805 371.351C147.783 371.335 147.761 371.32 147.737 371.308C147.714 371.296 147.689 371.287 147.664 371.28Z",
    fill: "white"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask18_39_780)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M147.199 371.097L147.007 372.08L147.934 372.284L148.126 371.301L147.199 371.097Z",
    fill: "#2771E0"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask19_39_780",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 140,
    y: 365,
    width: 7,
    height: 9
  }, _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M140 365H146.879V373.934H140V365Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask19_39_780)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask20_39_780",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 140,
    y: 364,
    width: 7,
    height: 10
  }, _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M146.504 372.339C146.448 372.326 146.393 372.327 146.338 372.34C146.282 372.352 146.232 372.377 146.186 372.412C146.031 372.529 145.868 372.632 145.697 372.719C145.526 372.807 145.35 372.879 145.167 372.936C144.985 372.992 144.799 373.032 144.61 373.055C144.422 373.078 144.232 373.085 144.042 373.074L143.988 373.071C143.833 373.059 143.678 373.037 143.525 373.004C141.684 372.599 140.502 370.687 140.883 368.735C141.264 366.782 143.066 365.526 144.905 365.931C145.356 366.029 145.77 366.217 146.149 366.494H146.15C146.173 366.516 146.198 366.536 146.225 366.551C146.261 366.572 146.299 366.587 146.339 366.596C146.383 366.605 146.428 366.606 146.473 366.6C146.518 366.593 146.561 366.579 146.601 366.557C146.642 366.535 146.678 366.507 146.709 366.472C146.741 366.437 146.766 366.398 146.785 366.354C146.804 366.31 146.816 366.264 146.82 366.216C146.824 366.168 146.821 366.121 146.811 366.074C146.8 366.027 146.782 365.983 146.758 365.943C146.733 365.902 146.703 365.867 146.668 365.837H146.666L146.64 365.818L146.634 365.813C146.159 365.458 145.637 365.218 145.069 365.093C142.794 364.594 140.567 366.145 140.095 368.561C139.623 370.977 141.085 373.339 143.362 373.84C143.644 373.903 143.929 373.934 144.217 373.934C144.506 373.934 144.791 373.902 145.073 373.84C145.356 373.778 145.629 373.685 145.893 373.563C146.158 373.441 146.407 373.292 146.643 373.115L146.65 373.11L146.668 373.095L146.675 373.09C146.749 373.026 146.797 372.944 146.817 372.845C146.823 372.817 146.825 372.789 146.825 372.761C146.826 372.733 146.823 372.705 146.818 372.677C146.813 372.65 146.806 372.623 146.796 372.597C146.786 372.571 146.774 372.546 146.759 372.523C146.744 372.499 146.728 372.477 146.709 372.457C146.691 372.437 146.671 372.42 146.649 372.404C146.627 372.388 146.604 372.375 146.579 372.364C146.555 372.352 146.53 372.344 146.504 372.339Z",
    fill: "white"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask20_39_780)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.281 363.562L138.329 373.566L146.545 375.372L148.497 365.367L140.281 363.562Z",
    fill: "url(#paint8_linear_39_780)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask21_39_780",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 141,
    y: 366,
    width: 6,
    height: 7
  }, _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M146.212 366.681H141.584V372.14H146.212V366.681Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask21_39_780)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask22_39_780",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 141,
    y: 366,
    width: 6,
    height: 7
  }, _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M144.872 372.016C144.661 372.078 144.446 372.111 144.228 372.115C144.009 372.118 143.794 372.091 143.581 372.035L143.492 372.009H143.49C143.444 371.995 143.397 371.979 143.351 371.962C143.305 371.945 143.26 371.926 143.215 371.906C143.17 371.887 143.125 371.865 143.081 371.843C143.037 371.82 142.994 371.796 142.952 371.771C142.909 371.746 142.867 371.719 142.826 371.691C142.785 371.663 142.745 371.635 142.705 371.604C142.665 371.574 142.627 371.543 142.589 371.51C142.551 371.477 142.514 371.444 142.478 371.409C142.442 371.374 142.407 371.338 142.373 371.301C142.339 371.264 142.306 371.226 142.274 371.187C142.242 371.148 142.211 371.108 142.181 371.067C142.151 371.026 142.122 370.984 142.095 370.942C142.067 370.899 142.041 370.856 142.015 370.811C141.99 370.767 141.966 370.722 141.943 370.676C141.921 370.63 141.899 370.584 141.879 370.537C141.858 370.49 141.839 370.442 141.822 370.394C141.804 370.346 141.787 370.297 141.772 370.248C141.757 370.199 141.744 370.149 141.731 370.099C141.719 370.049 141.708 369.999 141.698 369.948C141.688 369.897 141.68 369.846 141.673 369.795C141.666 369.744 141.66 369.692 141.657 369.641C141.652 369.589 141.649 369.538 141.648 369.486C141.647 369.434 141.647 369.382 141.649 369.331C141.65 369.279 141.653 369.227 141.657 369.176C141.661 369.124 141.667 369.073 141.674 369.022C141.681 368.97 141.689 368.919 141.699 368.869C141.709 368.818 141.72 368.768 141.732 368.717C141.745 368.668 141.759 368.618 141.774 368.569C141.789 368.52 141.806 368.471 141.824 368.423C141.842 368.375 141.861 368.327 141.881 368.28C141.902 368.233 141.923 368.187 141.946 368.141C141.969 368.095 141.993 368.051 142.019 368.006C142.044 367.962 142.07 367.919 142.098 367.876C142.126 367.833 142.155 367.792 142.185 367.751C142.214 367.71 142.246 367.67 142.278 367.631C142.31 367.592 142.343 367.554 142.377 367.517C142.411 367.481 142.446 367.445 142.482 367.41C142.519 367.375 142.556 367.341 142.594 367.309C142.632 367.276 142.67 367.245 142.71 367.215C142.75 367.185 142.79 367.156 142.831 367.128C142.872 367.101 142.914 367.074 142.957 367.049C143 367.024 143.043 367 143.087 366.977C143.131 366.955 143.175 366.934 143.22 366.914C143.265 366.894 143.311 366.876 143.357 366.859C143.403 366.842 143.449 366.826 143.496 366.812C143.543 366.798 143.59 366.785 143.638 366.774C143.686 366.763 143.733 366.753 143.781 366.744C143.83 366.736 143.878 366.729 143.926 366.724C143.975 366.718 144.024 366.714 144.072 366.712C144.121 366.709 144.17 366.708 144.218 366.709C144.267 366.709 144.316 366.711 144.365 366.715C144.413 366.718 144.462 366.723 144.51 366.73C144.558 366.736 144.607 366.744 144.655 366.754C144.702 366.763 144.75 366.774 144.797 366.786C144.845 366.798 144.892 366.812 144.939 366.827C144.985 366.842 145.031 366.859 145.077 366.877C145.123 366.894 145.168 366.914 145.213 366.934C145.257 366.955 145.301 366.977 145.345 367.001C145.388 367.024 145.431 367.049 145.474 367.075C145.516 367.101 145.557 367.128 145.598 367.157C145.638 367.185 145.678 367.215 145.717 367.246C145.756 367.277 145.795 367.309 145.832 367.342C145.869 367.376 145.906 367.41 145.941 367.446C145.977 367.481 146.011 367.518 146.045 367.555L146.111 367.634C146.12 367.646 146.127 367.658 146.134 367.672C146.16 367.719 146.177 367.77 146.186 367.825C146.194 367.879 146.193 367.933 146.183 367.987C146.174 368.041 146.155 368.092 146.128 368.138C146.101 368.185 146.067 368.226 146.027 368.26C145.986 368.294 145.941 368.319 145.892 368.336C145.842 368.353 145.792 368.36 145.74 368.358C145.688 368.356 145.639 368.344 145.591 368.322C145.543 368.301 145.501 368.271 145.463 368.233L145.423 368.186C145.353 368.108 145.278 368.037 145.197 367.973C145.116 367.909 145.03 367.853 144.939 367.806C144.848 367.758 144.755 367.719 144.657 367.69C144.56 367.66 144.461 367.64 144.361 367.63C144.26 367.619 144.159 367.618 144.058 367.626C143.957 367.635 143.858 367.653 143.76 367.681C143.663 367.708 143.568 367.745 143.476 367.79C143.385 367.836 143.298 367.89 143.215 367.952C143.133 368.014 143.056 368.084 142.986 368.16C142.915 368.237 142.851 368.32 142.795 368.409C142.738 368.498 142.69 368.591 142.649 368.689C142.608 368.788 142.576 368.889 142.552 368.993C142.529 369.098 142.514 369.203 142.509 369.311C142.503 369.418 142.506 369.525 142.519 369.631C142.531 369.738 142.552 369.842 142.582 369.945C142.613 370.047 142.651 370.146 142.698 370.241C142.745 370.336 142.8 370.426 142.861 370.511C142.924 370.595 142.992 370.674 143.068 370.745C143.143 370.817 143.224 370.881 143.31 370.937C143.396 370.993 143.486 371.04 143.581 371.08C143.675 371.118 143.772 371.148 143.871 371.169C143.97 371.189 144.07 371.2 144.172 371.201C144.273 371.203 144.373 371.194 144.473 371.176C144.573 371.159 144.67 371.132 144.765 371.095C144.976 371.015 145.164 370.895 145.328 370.735C145.33 370.735 145.33 370.735 145.33 370.733L145.365 370.699C145.385 370.681 145.405 370.665 145.427 370.651C145.472 370.624 145.519 370.605 145.57 370.595C145.62 370.586 145.671 370.586 145.722 370.595C145.773 370.605 145.82 370.624 145.864 370.652C145.909 370.68 145.947 370.714 145.979 370.757C146.012 370.799 146.036 370.846 146.053 370.898C146.069 370.95 146.077 371.003 146.076 371.058C146.074 371.112 146.064 371.165 146.045 371.216C146.026 371.266 145.999 371.312 145.964 371.352C145.95 371.371 145.933 371.388 145.915 371.403H145.913C145.613 371.696 145.266 371.901 144.872 372.016Z",
    fill: "white"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask22_39_780)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M139.544 367.885L145.205 364.717L148.296 370.941L142.636 374.109L139.544 367.885Z",
    fill: "url(#paint9_linear_39_780)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask23_39_780",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 143,
    y: 368,
    width: 4,
    height: 3
  }, _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M146.526 368.583H143.153V370.238H146.526V368.583Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask23_39_780)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask24_39_780",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 143,
    y: 368,
    width: 4,
    height: 3
  }, _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M143.197 369.301C143.202 369.257 143.212 369.213 143.224 369.17C143.237 369.127 143.253 369.086 143.272 369.046C143.291 369.006 143.313 368.968 143.338 368.932C143.364 368.896 143.391 368.863 143.422 368.832C143.453 368.8 143.485 368.772 143.52 368.747C143.555 368.722 143.592 368.7 143.631 368.682C143.669 368.663 143.709 368.648 143.75 368.636C143.791 368.625 143.832 368.617 143.874 368.613C143.917 368.609 143.959 368.609 144.001 368.612C144.043 368.616 144.084 368.623 144.126 368.634C144.167 368.645 144.206 368.66 144.245 368.678C144.284 368.696 144.321 368.717 144.356 368.742C144.391 368.767 144.425 368.795 144.455 368.825C144.486 368.856 144.514 368.889 144.54 368.925C144.566 368.961 144.588 368.999 144.608 369.038C144.627 369.078 144.644 369.119 144.657 369.162C144.805 369.251 145.008 369.305 145.235 369.305C145.43 369.305 145.609 369.264 145.749 369.197C145.785 369.131 145.834 369.081 145.896 369.044C145.926 369.025 145.959 369.011 145.993 369.002C146.013 368.997 146.034 368.993 146.055 368.992C146.112 368.986 146.168 368.993 146.223 369.013C146.277 369.033 146.325 369.064 146.367 369.106H146.368L146.398 369.141C146.413 369.159 146.427 369.18 146.438 369.201C146.451 369.226 146.461 369.251 146.469 369.277C146.478 369.304 146.483 369.33 146.487 369.358C146.49 369.386 146.491 369.413 146.489 369.441C146.487 369.469 146.482 369.496 146.475 369.523C146.468 369.549 146.459 369.575 146.447 369.6C146.436 369.625 146.422 369.648 146.406 369.67C146.39 369.692 146.372 369.712 146.352 369.73C146.332 369.749 146.311 369.764 146.288 369.778C146.216 369.822 146.138 369.839 146.055 369.831C146.034 369.828 146.013 369.824 145.993 369.819C145.929 369.802 145.872 369.77 145.823 369.722L145.779 369.672C145.779 369.671 145.778 369.67 145.777 369.67L145.749 369.626C145.609 369.557 145.43 369.516 145.235 369.516C145.008 369.516 144.805 369.57 144.657 369.66C144.642 369.707 144.623 369.751 144.6 369.794C144.578 369.837 144.552 369.877 144.522 369.915C144.492 369.953 144.459 369.988 144.424 370.019C144.388 370.05 144.35 370.078 144.31 370.102C144.269 370.126 144.227 370.145 144.183 370.161C144.139 370.177 144.094 370.188 144.048 370.195C144.002 370.202 143.956 370.204 143.91 370.202C143.864 370.2 143.818 370.193 143.773 370.182C143.728 370.171 143.684 370.155 143.642 370.136C143.599 370.116 143.559 370.092 143.52 370.065C143.482 370.037 143.447 370.006 143.413 369.971C143.381 369.937 143.351 369.899 143.325 369.859C143.298 369.818 143.276 369.776 143.257 369.731C143.238 369.686 143.223 369.64 143.212 369.592C143.201 369.544 143.194 369.496 143.192 369.446C143.189 369.397 143.191 369.349 143.197 369.3V369.301Z",
    fill: "white"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask24_39_780)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M146.355 367.913L146.789 370.138L143.325 370.9L142.891 368.675L146.355 367.913Z",
    fill: "url(#paint10_linear_39_780)"
  }))))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 549.5,
    cy: 311,
    rx: 8.5,
    ry: 9,
    fill: "#D9E5F4"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_39_780)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask25_39_780",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 552,
    y: 307,
    width: 2,
    height: 2
  }, _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M552.99 307.411H554V308.549H552.99V307.411Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask25_39_780)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask26_39_780",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 552,
    y: 307,
    width: 2,
    height: 2
  }, _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "M553.615 307.468C553.563 307.454 553.511 307.45 553.458 307.454C553.404 307.458 553.353 307.471 553.304 307.493C553.255 307.515 553.21 307.544 553.169 307.581C553.129 307.618 553.095 307.661 553.067 307.709C553.06 307.728 553.05 307.744 553.042 307.761C553.029 307.789 553.019 307.819 553.013 307.851C553.005 307.884 553.001 307.918 552.999 307.953C552.997 307.988 552.999 308.022 553.004 308.056C553.008 308.091 553.016 308.124 553.027 308.157C553.038 308.189 553.052 308.221 553.069 308.25C553.085 308.28 553.105 308.308 553.127 308.333C553.149 308.359 553.173 308.382 553.199 308.403C553.225 308.424 553.253 308.442 553.282 308.457C553.312 308.471 553.342 308.483 553.374 308.491C553.425 308.505 553.476 308.509 553.529 308.505C553.581 308.501 553.632 308.489 553.68 308.468C553.728 308.447 553.773 308.419 553.813 308.383C553.854 308.348 553.888 308.307 553.916 308.26L553.953 308.182H553.955C553.964 308.158 553.972 308.133 553.978 308.106C553.985 308.073 553.99 308.039 553.992 308.004C553.993 307.97 553.991 307.936 553.986 307.901C553.981 307.867 553.973 307.834 553.962 307.801C553.951 307.769 553.937 307.738 553.92 307.708C553.903 307.678 553.884 307.651 553.862 307.625C553.84 307.6 553.816 307.576 553.79 307.556C553.764 307.535 553.736 307.518 553.707 307.503C553.677 307.488 553.647 307.476 553.615 307.468Z",
    fill: "white"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask26_39_780)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M553.038 307.239L552.799 308.465L553.952 308.718L554.191 307.493L553.038 307.239Z",
    fill: "url(#paint11_linear_39_780)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask27_39_780",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 552,
    y: 312,
    width: 2,
    height: 2
  }, _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "M552.892 312.788H553.971V313.925H552.892V312.788Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask27_39_780)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask28_39_780",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 552,
    y: 312,
    width: 2,
    height: 2
  }, _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "M553.58 312.85C553.528 312.837 553.476 312.832 553.423 312.837C553.369 312.841 553.318 312.854 553.269 312.875C553.22 312.897 553.175 312.927 553.134 312.963C553.094 313.001 553.06 313.043 553.032 313.092L553.006 313.143C552.994 313.172 552.984 313.203 552.977 313.233C552.962 313.294 552.958 313.356 552.964 313.419C552.97 313.482 552.986 313.541 553.013 313.598C553.039 313.654 553.074 313.704 553.117 313.747C553.16 313.791 553.209 313.825 553.264 313.849C553.319 313.874 553.375 313.888 553.435 313.891C553.494 313.894 553.552 313.886 553.608 313.867C553.665 313.848 553.717 313.819 553.764 313.781C553.811 313.742 553.85 313.696 553.881 313.643C553.895 313.618 553.906 313.592 553.918 313.567H553.92C553.929 313.542 553.935 313.518 553.943 313.491C553.951 313.457 553.955 313.424 553.957 313.389C553.958 313.354 553.957 313.32 553.952 313.285C553.947 313.251 553.939 313.218 553.928 313.185C553.917 313.152 553.903 313.121 553.886 313.091C553.869 313.062 553.85 313.034 553.828 313.008C553.806 312.982 553.782 312.959 553.756 312.939C553.729 312.918 553.702 312.9 553.672 312.885C553.643 312.871 553.612 312.859 553.58 312.85Z",
    fill: "white"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask28_39_780)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M552.999 312.621L552.759 313.851L553.918 314.105L554.157 312.876L552.999 312.621Z",
    fill: "#2771E0"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask29_39_780",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 544,
    y: 305,
    width: 9,
    height: 12
  }, _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "M544 305H552.598V316.167H544V305Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask29_39_780)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask30_39_780",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 544,
    y: 304,
    width: 9,
    height: 13
  }, _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "M552.13 314.173C552.061 314.158 551.991 314.158 551.922 314.174C551.853 314.191 551.79 314.221 551.732 314.265C551.539 314.412 551.335 314.54 551.122 314.649C550.908 314.759 550.687 314.849 550.459 314.92C550.231 314.99 549.999 315.04 549.763 315.069C549.527 315.098 549.29 315.106 549.053 315.092L548.985 315.088C548.791 315.074 548.598 315.046 548.407 315.004C546.106 314.499 544.628 312.109 545.104 309.668C545.581 307.228 547.832 305.657 550.131 306.163C550.695 306.286 551.213 306.521 551.686 306.867H551.688C551.716 306.895 551.747 306.919 551.781 306.939C551.826 306.965 551.873 306.983 551.924 306.995C551.979 307.006 552.035 307.008 552.091 307C552.148 306.991 552.201 306.974 552.252 306.946C552.302 306.919 552.347 306.883 552.387 306.84C552.426 306.796 552.458 306.747 552.482 306.692C552.505 306.638 552.52 306.581 552.525 306.52C552.531 306.46 552.527 306.401 552.513 306.342C552.5 306.284 552.478 306.229 552.447 306.178C552.417 306.128 552.379 306.084 552.334 306.047H552.333L552.3 306.022L552.292 306.016C551.698 305.572 551.047 305.273 550.336 305.117C547.492 304.492 544.709 306.432 544.118 309.452C543.528 312.472 545.357 315.424 548.202 316.051C548.555 316.129 548.912 316.167 549.272 316.167C549.633 316.167 549.989 316.128 550.342 316.05C550.695 315.972 551.036 315.857 551.367 315.704C551.697 315.551 552.009 315.365 552.303 315.144L552.313 315.137L552.334 315.119L552.344 315.113C552.437 315.032 552.496 314.93 552.521 314.806C552.528 314.771 552.532 314.737 552.532 314.702C552.532 314.666 552.529 314.632 552.523 314.597C552.516 314.563 552.507 314.529 552.495 314.496C552.482 314.464 552.467 314.433 552.449 314.403C552.431 314.374 552.41 314.347 552.387 314.322C552.364 314.297 552.338 314.275 552.311 314.255C552.284 314.235 552.254 314.218 552.224 314.205C552.194 314.191 552.162 314.18 552.13 314.173Z",
    fill: "white"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask30_39_780)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M544.351 303.202L541.911 315.708L552.181 317.966L554.621 305.459L544.351 303.202Z",
    fill: "url(#paint12_linear_39_780)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask31_39_780",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 545,
    y: 307,
    width: 7,
    height: 7
  }, _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "M551.765 307.101H545.98V313.926H551.765V307.101Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask31_39_780)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask32_39_780",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 546,
    y: 307,
    width: 6,
    height: 7
  }, _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "M550.089 313.769C549.826 313.847 549.558 313.889 549.285 313.893C549.011 313.897 548.742 313.864 548.477 313.794L548.365 313.761H548.363C548.304 313.744 548.246 313.724 548.189 313.702C548.131 313.681 548.075 313.658 548.018 313.633C547.962 313.608 547.906 313.582 547.852 313.553C547.797 313.525 547.743 313.495 547.689 313.464C547.636 313.432 547.584 313.399 547.533 313.364C547.481 313.329 547.431 313.293 547.381 313.255C547.332 313.217 547.283 313.178 547.236 313.137C547.189 313.097 547.142 313.055 547.098 313.011C547.052 312.967 547.009 312.922 546.966 312.876C546.923 312.83 546.882 312.782 546.842 312.733C546.802 312.685 546.763 312.635 546.726 312.584C546.689 312.533 546.653 312.48 546.618 312.427C546.584 312.374 546.551 312.319 546.519 312.264C546.488 312.209 546.457 312.152 546.429 312.095C546.401 312.038 546.373 311.98 546.348 311.921C546.323 311.862 546.299 311.803 546.277 311.743C546.255 311.682 546.234 311.621 546.215 311.56C546.197 311.498 546.179 311.437 546.164 311.374C546.148 311.311 546.134 311.248 546.122 311.185C546.11 311.121 546.1 311.058 546.091 310.994C546.082 310.93 546.076 310.865 546.071 310.801C546.065 310.737 546.062 310.672 546.06 310.607C546.059 310.543 546.059 310.478 546.061 310.413C546.062 310.349 546.066 310.284 546.071 310.22C546.076 310.155 546.084 310.091 546.092 310.027C546.101 309.963 546.112 309.899 546.124 309.836C546.136 309.772 546.15 309.709 546.166 309.647C546.181 309.585 546.198 309.522 546.218 309.461C546.237 309.4 546.257 309.339 546.28 309.278C546.302 309.218 546.326 309.159 546.351 309.1C546.377 309.041 546.404 308.983 546.432 308.926C546.461 308.869 546.491 308.813 546.523 308.758C546.555 308.702 546.588 308.648 546.622 308.595C546.657 308.542 546.693 308.49 546.731 308.439C546.768 308.387 546.807 308.338 546.847 308.289C546.887 308.24 546.929 308.193 546.971 308.147C547.014 308.101 547.058 308.056 547.103 308.012C547.148 307.969 547.195 307.927 547.242 307.886C547.29 307.845 547.338 307.806 547.387 307.769C547.437 307.731 547.487 307.695 547.539 307.66C547.591 307.626 547.643 307.593 547.696 307.561C547.749 307.53 547.803 307.5 547.858 307.472C547.913 307.443 547.969 307.417 548.025 307.393C548.081 307.368 548.139 307.345 548.196 307.324C548.253 307.302 548.312 307.283 548.37 307.265C548.429 307.247 548.488 307.231 548.548 307.217C548.607 307.203 548.667 307.191 548.727 307.181C548.787 307.17 548.847 307.161 548.908 307.155C548.968 307.148 549.029 307.143 549.09 307.14C549.151 307.137 549.212 307.135 549.273 307.136C549.334 307.137 549.395 307.139 549.456 307.143C549.516 307.148 549.577 307.154 549.637 307.162C549.698 307.17 549.758 307.18 549.818 307.192C549.878 307.204 549.938 307.217 549.997 307.232C550.056 307.248 550.115 307.265 550.173 307.284C550.231 307.303 550.289 307.323 550.346 307.346C550.403 307.368 550.46 307.392 550.516 307.418C550.572 307.444 550.627 307.472 550.681 307.501C550.735 307.53 550.789 307.561 550.842 307.594C550.894 307.626 550.946 307.66 550.997 307.696C551.048 307.731 551.098 307.769 551.147 307.807C551.195 307.846 551.243 307.886 551.29 307.928C551.336 307.969 551.382 308.013 551.426 308.057C551.471 308.101 551.514 308.147 551.556 308.194L551.638 308.292C551.65 308.307 551.659 308.323 551.668 308.339C551.7 308.399 551.721 308.463 551.732 308.531C551.742 308.599 551.741 308.666 551.729 308.734C551.717 308.801 551.694 308.864 551.66 308.923C551.627 308.982 551.584 309.032 551.534 309.075C551.483 309.117 551.426 309.149 551.365 309.17C551.303 309.192 551.24 309.2 551.175 309.197C551.11 309.194 551.048 309.179 550.989 309.153C550.929 309.126 550.876 309.089 550.828 309.042L550.778 308.982C550.692 308.885 550.598 308.796 550.496 308.716C550.395 308.636 550.287 308.566 550.174 308.507C550.06 308.448 549.943 308.399 549.821 308.362C549.7 308.325 549.576 308.3 549.451 308.287C549.325 308.274 549.199 308.272 549.073 308.283C548.947 308.294 548.823 308.316 548.7 308.351C548.578 308.385 548.46 308.431 548.345 308.488C548.231 308.545 548.122 308.612 548.019 308.69C547.916 308.767 547.82 308.854 547.732 308.95C547.644 309.046 547.564 309.15 547.494 309.261C547.423 309.372 547.362 309.489 547.311 309.612C547.26 309.734 547.22 309.861 547.19 309.992C547.161 310.122 547.142 310.254 547.136 310.388C547.128 310.522 547.132 310.656 547.148 310.789C547.164 310.922 547.19 311.053 547.228 311.181C547.266 311.309 547.314 311.432 547.373 311.551C547.431 311.67 547.499 311.783 547.577 311.888C547.654 311.994 547.74 312.092 547.834 312.182C547.929 312.271 548.03 312.351 548.137 312.421C548.245 312.491 548.358 312.55 548.476 312.599C548.593 312.648 548.715 312.685 548.839 312.711C548.963 312.736 549.088 312.75 549.214 312.752C549.341 312.753 549.466 312.743 549.591 312.721C549.716 312.698 549.837 312.664 549.956 312.619C550.22 312.519 550.454 312.369 550.66 312.168C550.662 312.168 550.662 312.168 550.662 312.166L550.707 312.123C550.731 312.101 550.756 312.082 550.784 312.064C550.84 312.029 550.899 312.006 550.962 311.994C551.025 311.982 551.089 311.982 551.152 311.994C551.216 312.006 551.275 312.03 551.33 312.065C551.386 312.099 551.434 312.143 551.474 312.196C551.515 312.249 551.545 312.308 551.566 312.372C551.587 312.437 551.596 312.504 551.595 312.572C551.593 312.64 551.58 312.706 551.556 312.769C551.532 312.833 551.499 312.89 551.455 312.94C551.437 312.964 551.416 312.985 551.393 313.004H551.391C551.016 313.37 550.582 313.626 550.089 313.769Z",
    fill: "white"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask32_39_780)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M543.43 308.606L550.506 304.646L554.37 312.426L547.295 316.386L543.43 308.606Z",
    fill: "url(#paint13_linear_39_780)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask33_39_780",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 547,
    y: 309,
    width: 6,
    height: 3
  }, _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M552.157 309.479H547.942V311.547H552.157V309.479Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask33_39_780)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask34_39_780",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 547,
    y: 309,
    width: 6,
    height: 3
  }, _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M547.996 310.377C548.003 310.321 548.014 310.266 548.03 310.213C548.046 310.159 548.066 310.108 548.09 310.058C548.114 310.007 548.141 309.96 548.173 309.915C548.204 309.87 548.239 309.828 548.278 309.789C548.316 309.751 548.357 309.715 548.401 309.684C548.444 309.652 548.49 309.625 548.538 309.602C548.587 309.579 548.636 309.56 548.687 309.545C548.738 309.531 548.79 309.522 548.843 309.517C548.896 309.511 548.948 309.511 549.001 309.516C549.054 309.52 549.106 309.529 549.157 309.543C549.208 309.557 549.258 309.575 549.306 309.597C549.355 309.62 549.401 309.647 549.445 309.678C549.489 309.709 549.531 309.743 549.569 309.782C549.608 309.82 549.643 309.862 549.675 309.906C549.707 309.951 549.735 309.998 549.76 310.048C549.784 310.098 549.804 310.149 549.821 310.203C550.006 310.313 550.261 310.381 550.544 310.381C550.787 310.381 551.011 310.33 551.187 310.246C551.231 310.164 551.292 310.101 551.37 310.055C551.408 310.032 551.449 310.014 551.491 310.002C551.517 309.996 551.543 309.992 551.569 309.99C551.64 309.982 551.71 309.991 551.778 310.016C551.846 310.041 551.906 310.08 551.958 310.133H551.96L551.997 310.176C552.016 310.199 552.033 310.224 552.047 310.252C552.063 310.282 552.077 310.314 552.087 310.346C552.097 310.379 552.104 310.413 552.108 310.448C552.112 310.482 552.113 310.517 552.111 310.551C552.108 310.586 552.103 310.62 552.094 310.653C552.085 310.687 552.074 310.719 552.059 310.75C552.044 310.781 552.027 310.81 552.007 310.838C551.987 310.865 551.964 310.89 551.94 310.913C551.915 310.936 551.888 310.955 551.86 310.972C551.769 311.027 551.672 311.049 551.569 311.038C551.542 311.035 551.517 311.031 551.491 311.024C551.411 311.002 551.341 310.962 551.279 310.903L551.223 310.84C551.223 310.838 551.223 310.837 551.221 310.837L551.187 310.782C551.011 310.696 550.787 310.645 550.544 310.645C550.261 310.645 550.006 310.713 549.821 310.825C549.802 310.883 549.779 310.939 549.75 310.993C549.722 311.046 549.69 311.097 549.652 311.144C549.615 311.191 549.574 311.235 549.53 311.274C549.485 311.313 549.438 311.347 549.387 311.377C549.336 311.407 549.284 311.432 549.229 311.451C549.174 311.471 549.118 311.485 549.06 311.493C549.003 311.502 548.945 311.505 548.888 311.502C548.83 311.499 548.773 311.491 548.716 311.477C548.66 311.463 548.605 311.444 548.552 311.42C548.499 311.395 548.448 311.365 548.401 311.331C548.353 311.296 548.308 311.257 548.267 311.214C548.226 311.171 548.189 311.124 548.156 311.073C548.123 311.023 548.095 310.97 548.071 310.913C548.047 310.857 548.028 310.8 548.014 310.74C548.001 310.68 547.993 310.619 547.99 310.558C547.986 310.497 547.988 310.436 547.996 310.375V310.377Z",
    fill: "white"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask34_39_780)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M551.943 308.642L552.486 311.423L548.156 312.375L547.613 309.593L551.943 308.642Z",
    fill: "url(#paint14_linear_39_780)"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_39_780",
    x1: 513.988,
    y1: 183.747,
    x2: 513.988,
    y2: 205.795,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_39_780",
    x1: 1564.7,
    y1: 350.412,
    x2: 3478.33,
    y2: 2283.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_39_780",
    x1: 173.315,
    y1: 423.027,
    x2: 1054.89,
    y2: 1237.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_39_780",
    x1: 571.411,
    y1: 727.098,
    x2: 1366.92,
    y2: 1591.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_39_780",
    x1: 1359.04,
    y1: -60.7771,
    x2: 8082.05,
    y2: 8345.48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_39_780",
    x1: 3103.46,
    y1: 282.086,
    x2: 7344.8,
    y2: 2921.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_39_780",
    x1: 2408.58,
    y1: 2550.06,
    x2: 2476.55,
    y2: 4179.47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_39_780",
    x1: 147.135,
    y1: 367.281,
    x2: 148.062,
    y2: 367.462,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2771E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0625,
    stopColor: "#2771E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09375,
    stopColor: "#2771E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.109375,
    stopColor: "#2870DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#286FDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.140625,
    stopColor: "#296EDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "#296DDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171875,
    stopColor: "#2A6DDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#2A6CDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#2B6BDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#2B6ADB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#2C6ADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#2C69DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.257812,
    stopColor: "#2D68D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265625,
    stopColor: "#2D68D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.273438,
    stopColor: "#2E67D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#2E66D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.289062,
    stopColor: "#2E66D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296875,
    stopColor: "#2F65D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304688,
    stopColor: "#2F64D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#2F64D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.320313,
    stopColor: "#3063D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    stopColor: "#3062D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.335938,
    stopColor: "#3162D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#3161D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.351562,
    stopColor: "#3160D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#3260D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367188,
    stopColor: "#325FD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#335ED3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.382813,
    stopColor: "#335ED2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#335DD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.398438,
    stopColor: "#345CD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#345CD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414062,
    stopColor: "#355BD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "#355AD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.429688,
    stopColor: "#355ACF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#3659CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445313,
    stopColor: "#3658CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#3657CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460938,
    stopColor: "#3757CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#3756CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476563,
    stopColor: "#3855CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#3855CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492188,
    stopColor: "#3854CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#3953CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507812,
    stopColor: "#3953CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#3A52CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523438,
    stopColor: "#3A51CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#3A51CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539062,
    stopColor: "#3B50C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#3B4FC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554688,
    stopColor: "#3B4FC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#3C4EC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.570312,
    stopColor: "#3C4DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#3D4CC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585938,
    stopColor: "#3D4CC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#3E4BC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601563,
    stopColor: "#3E4AC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#3F49C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617188,
    stopColor: "#3F48C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#4047C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632812,
    stopColor: "#4047C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#4146C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648438,
    stopColor: "#4145C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#4244C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664062,
    stopColor: "#4243C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#4342C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679688,
    stopColor: "#4342BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#4441BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695313,
    stopColor: "#4440BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#453FBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.710938,
    stopColor: "#453EBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#463DBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726563,
    stopColor: "#463DBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#473CBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742188,
    stopColor: "#473BBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#483ABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.757812,
    stopColor: "#4839B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "#4938B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773438,
    stopColor: "#4938B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#4A37B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789063,
    stopColor: "#4A36B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#4B35B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804688,
    stopColor: "#4B34B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#4C33B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.820313,
    stopColor: "#4C32B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopColor: "#4D32B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835938,
    stopColor: "#4D31B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "#4E30B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851562,
    stopColor: "#4E2FB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "#4F2EB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867187,
    stopColor: "#4F2DB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#502DB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882812,
    stopColor: "#502CB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.890625,
    stopColor: "#512BAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898438,
    stopColor: "#512AAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90625,
    stopColor: "#5229AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.914062,
    stopColor: "#5228AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.921875,
    stopColor: "#5328AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    stopColor: "#5327AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5327AC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_39_780",
    x1: 141.82,
    y1: 363.021,
    x2: 146.198,
    y2: 375.494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0091D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#0091D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#0091D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#0092D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#0092D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#0093D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#0094D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265625,
    stopColor: "#0094D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#0095D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296875,
    stopColor: "#0096D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#0096D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    stopColor: "#0097D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.334773,
    stopColor: "#0098D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#0098D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#0099D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#0099D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#009AD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.398438,
    stopColor: "#009BD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#009BD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414062,
    stopColor: "#009CD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "#009CD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.429688,
    stopColor: "#009DD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#009ED1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445312,
    stopColor: "#009ED1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#009FD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460938,
    stopColor: "#009FD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#00A0D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476562,
    stopColor: "#00A1D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#00A1D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492188,
    stopColor: "#00A2D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#00A2D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507812,
    stopColor: "#00A3D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#00A4D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523438,
    stopColor: "#00A4D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#00A5D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539062,
    stopColor: "#00A5CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#00A6CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554688,
    stopColor: "#00A7CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#00A7CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.570312,
    stopColor: "#00A8CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#00A8CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585938,
    stopColor: "#00A9CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#00AACE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601562,
    stopColor: "#00AACE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#00ABCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617188,
    stopColor: "#00ABCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#00ACCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632812,
    stopColor: "#00ACCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#00ADCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648438,
    stopColor: "#00AECD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#00AECD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664062,
    stopColor: "#00AFCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.665227,
    stopColor: "#00AFCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#00B0CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679688,
    stopColor: "#00B0CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#00B1CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695312,
    stopColor: "#00B1CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#00B2CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.710938,
    stopColor: "#00B2CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#00B3CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726562,
    stopColor: "#00B4CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#00B4CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742188,
    stopColor: "#00B5CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#00B6CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.757812,
    stopColor: "#00B6CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "#00B7CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773438,
    stopColor: "#00B8CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#00B8CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789062,
    stopColor: "#00B9CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#00BACA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804688,
    stopColor: "#00BACA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#00BBCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.820312,
    stopColor: "#00BCCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopColor: "#00BCCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835938,
    stopColor: "#00BDCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "#00BEC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851562,
    stopColor: "#00BEC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "#00BFC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#00BFC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00BFC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_39_780",
    x1: 141.103,
    y1: 371.307,
    x2: 147.035,
    y2: 368.063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B6F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0405615,
    stopColor: "#00B6F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#00B6F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "#00B6F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171875,
    stopColor: "#00B6F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#00B6F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#00B6F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#00B6F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#00B6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#00B6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265625,
    stopColor: "#00B6EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#00B6EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296875,
    stopColor: "#00B6EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#00B5EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    stopColor: "#00B5ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#00B5EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#00B5EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#00B5EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#00B5EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#00B5EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "#00B5E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#00B5E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#00B5E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#00B4E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#00B4E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#00B4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#00B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#00B4E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#00B4E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#00B4E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#00B3DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#00B3DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#00B3DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#00B3DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#00B3DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#00B3DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#00B2D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#00B2D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#00B2D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#00B2D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#00B2D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#00B2D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "#00B1D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#00B1D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#00B1D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804688,
    stopColor: "#00B1D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#00B1D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.820313,
    stopColor: "#00B1D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopColor: "#00B1CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835938,
    stopColor: "#00B1CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "#00B1CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851562,
    stopColor: "#00B1CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "#00B1CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867188,
    stopColor: "#00B0CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#00B0CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882812,
    stopColor: "#00B0CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.890625,
    stopColor: "#00B0CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898437,
    stopColor: "#00B0CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90625,
    stopColor: "#00B0C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    stopColor: "#00B0C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.959438,
    stopColor: "#00B0C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B0C9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_39_780",
    x1: 146.931,
    y1: 370.865,
    x2: 143.451,
    y2: 371.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2771E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#2771E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "#2771E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171875,
    stopColor: "#2770DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#2870DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#286FDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#296EDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#296DDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#2A6DDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265625,
    stopColor: "#2A6CDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#2B6BDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296875,
    stopColor: "#2B6BDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#2C6ADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    stopColor: "#2C69DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#2D68D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.351562,
    stopColor: "#2D68D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#2D67D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367188,
    stopColor: "#2E67D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#2E66D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.382812,
    stopColor: "#2E65D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#2F65D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.398437,
    stopColor: "#2F64D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#2F64D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414062,
    stopColor: "#3063D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "#3062D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.429687,
    stopColor: "#3162D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#3161D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445312,
    stopColor: "#3161D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#3260D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460937,
    stopColor: "#325FD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#325FD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476562,
    stopColor: "#335ED2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#335ED2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492188,
    stopColor: "#335DD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#345CD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507812,
    stopColor: "#345CD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#345BD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523437,
    stopColor: "#355AD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#355AD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539062,
    stopColor: "#3559CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#3659CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554688,
    stopColor: "#3658CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#3657CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.570312,
    stopColor: "#3757CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#3756CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585937,
    stopColor: "#3856CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#3855CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601562,
    stopColor: "#3854CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#3954CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617188,
    stopColor: "#3953CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#3953CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632812,
    stopColor: "#3A52CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#3A51CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648437,
    stopColor: "#3A51CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#3B50C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664062,
    stopColor: "#3B50C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#3B4FC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679687,
    stopColor: "#3C4EC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#3C4EC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695312,
    stopColor: "#3D4DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#3D4CC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.710937,
    stopColor: "#3D4BC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#3E4BC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726562,
    stopColor: "#3E4AC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#3F49C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742187,
    stopColor: "#3F48C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#4048C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.757812,
    stopColor: "#4047C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "#4146C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773437,
    stopColor: "#4145C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#4145C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789062,
    stopColor: "#4244C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#4243C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804687,
    stopColor: "#4342C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#4342BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.820312,
    stopColor: "#4441BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopColor: "#4440BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835937,
    stopColor: "#453FBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "#453FBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851562,
    stopColor: "#453EBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "#463DBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867187,
    stopColor: "#463CBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#473BBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882812,
    stopColor: "#473BBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.890625,
    stopColor: "#483ABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898437,
    stopColor: "#4839B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90625,
    stopColor: "#4938B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.914062,
    stopColor: "#4938B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.921875,
    stopColor: "#4A37B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.929687,
    stopColor: "#4A36B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    stopColor: "#4A35B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.945312,
    stopColor: "#4B35B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.953125,
    stopColor: "#4B34B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.960938,
    stopColor: "#4C33B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96875,
    stopColor: "#4C32B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.976562,
    stopColor: "#4D32B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "#4D31B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.992187,
    stopColor: "#4E30B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E2FB2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_39_780",
    x1: 552.919,
    y1: 307.852,
    x2: 554.077,
    y2: 308.078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2771E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0625,
    stopColor: "#2771E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09375,
    stopColor: "#2771E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.109375,
    stopColor: "#2870DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#286FDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.140625,
    stopColor: "#296EDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "#296DDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171875,
    stopColor: "#2A6DDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#2A6CDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#2B6BDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#2B6ADB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#2C6ADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#2C69DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.257812,
    stopColor: "#2D68D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265625,
    stopColor: "#2D68D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.273438,
    stopColor: "#2E67D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#2E66D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.289062,
    stopColor: "#2E66D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296875,
    stopColor: "#2F65D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304688,
    stopColor: "#2F64D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#2F64D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.320313,
    stopColor: "#3063D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    stopColor: "#3062D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.335938,
    stopColor: "#3162D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#3161D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.351562,
    stopColor: "#3160D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#3260D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367188,
    stopColor: "#325FD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#335ED3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.382813,
    stopColor: "#335ED2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#335DD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.398438,
    stopColor: "#345CD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#345CD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414062,
    stopColor: "#355BD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "#355AD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.429688,
    stopColor: "#355ACF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#3659CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445313,
    stopColor: "#3658CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#3657CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460938,
    stopColor: "#3757CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#3756CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476563,
    stopColor: "#3855CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#3855CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492188,
    stopColor: "#3854CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#3953CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507812,
    stopColor: "#3953CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#3A52CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523438,
    stopColor: "#3A51CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#3A51CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539062,
    stopColor: "#3B50C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#3B4FC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554688,
    stopColor: "#3B4FC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#3C4EC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.570312,
    stopColor: "#3C4DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#3D4CC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585938,
    stopColor: "#3D4CC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#3E4BC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601563,
    stopColor: "#3E4AC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#3F49C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617188,
    stopColor: "#3F48C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#4047C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632812,
    stopColor: "#4047C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#4146C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648438,
    stopColor: "#4145C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#4244C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664062,
    stopColor: "#4243C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#4342C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679688,
    stopColor: "#4342BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#4441BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695313,
    stopColor: "#4440BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#453FBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.710938,
    stopColor: "#453EBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#463DBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726563,
    stopColor: "#463DBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#473CBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742188,
    stopColor: "#473BBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#483ABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.757812,
    stopColor: "#4839B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "#4938B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773438,
    stopColor: "#4938B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#4A37B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789063,
    stopColor: "#4A36B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#4B35B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804688,
    stopColor: "#4B34B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#4C33B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.820313,
    stopColor: "#4C32B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopColor: "#4D32B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835938,
    stopColor: "#4D31B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "#4E30B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851562,
    stopColor: "#4E2FB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "#4F2EB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867187,
    stopColor: "#4F2DB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#502DB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882812,
    stopColor: "#502CB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.890625,
    stopColor: "#512BAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898438,
    stopColor: "#512AAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90625,
    stopColor: "#5229AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.914062,
    stopColor: "#5228AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.921875,
    stopColor: "#5328AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    stopColor: "#5327AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5327AC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_39_780",
    x1: 546.275,
    y1: 302.527,
    x2: 551.748,
    y2: 318.118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0091D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#0091D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#0091D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#0092D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#0092D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#0093D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#0094D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265625,
    stopColor: "#0094D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#0095D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296875,
    stopColor: "#0096D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#0096D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    stopColor: "#0097D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.334773,
    stopColor: "#0098D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#0098D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#0099D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#0099D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#009AD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.398438,
    stopColor: "#009BD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#009BD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414062,
    stopColor: "#009CD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "#009CD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.429688,
    stopColor: "#009DD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#009ED1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445312,
    stopColor: "#009ED1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#009FD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460938,
    stopColor: "#009FD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#00A0D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476562,
    stopColor: "#00A1D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#00A1D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492188,
    stopColor: "#00A2D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#00A2D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507812,
    stopColor: "#00A3D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#00A4D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523438,
    stopColor: "#00A4D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#00A5D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539062,
    stopColor: "#00A5CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#00A6CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554688,
    stopColor: "#00A7CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#00A7CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.570312,
    stopColor: "#00A8CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#00A8CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585938,
    stopColor: "#00A9CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#00AACE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601562,
    stopColor: "#00AACE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#00ABCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617188,
    stopColor: "#00ABCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#00ACCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632812,
    stopColor: "#00ACCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#00ADCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648438,
    stopColor: "#00AECD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#00AECD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664062,
    stopColor: "#00AFCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.665227,
    stopColor: "#00AFCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#00B0CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679688,
    stopColor: "#00B0CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#00B1CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695312,
    stopColor: "#00B1CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#00B2CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.710938,
    stopColor: "#00B2CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#00B3CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726562,
    stopColor: "#00B4CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#00B4CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742188,
    stopColor: "#00B5CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#00B6CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.757812,
    stopColor: "#00B6CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "#00B7CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773438,
    stopColor: "#00B8CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#00B8CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789062,
    stopColor: "#00B9CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#00BACA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804688,
    stopColor: "#00BACA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#00BBCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.820312,
    stopColor: "#00BCCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopColor: "#00BCCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835938,
    stopColor: "#00BDCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "#00BEC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851562,
    stopColor: "#00BEC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "#00BFC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#00BFC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00BFC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_39_780",
    x1: 545.379,
    y1: 312.884,
    x2: 552.793,
    y2: 308.828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B6F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0405615,
    stopColor: "#00B6F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#00B6F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "#00B6F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171875,
    stopColor: "#00B6F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#00B6F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#00B6F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#00B6F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#00B6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#00B6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265625,
    stopColor: "#00B6EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#00B6EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296875,
    stopColor: "#00B6EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#00B5EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    stopColor: "#00B5ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#00B5EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#00B5EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#00B5EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#00B5EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#00B5EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "#00B5E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#00B5E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#00B5E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#00B4E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#00B4E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#00B4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#00B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#00B4E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#00B4E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#00B4E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#00B3DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#00B3DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#00B3DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#00B3DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#00B3DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#00B3DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#00B2D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#00B2D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#00B2D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#00B2D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#00B2D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#00B2D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "#00B1D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#00B1D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#00B1D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804688,
    stopColor: "#00B1D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#00B1D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.820313,
    stopColor: "#00B1D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopColor: "#00B1CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835938,
    stopColor: "#00B1CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "#00B1CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851562,
    stopColor: "#00B1CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "#00B1CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867188,
    stopColor: "#00B0CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#00B0CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882812,
    stopColor: "#00B0CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.890625,
    stopColor: "#00B0CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898437,
    stopColor: "#00B0CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90625,
    stopColor: "#00B0C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    stopColor: "#00B0C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.959438,
    stopColor: "#00B0C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B0C9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_39_780",
    x1: 552.663,
    y1: 312.332,
    x2: 548.313,
    y2: 313.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2771E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#2771E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "#2771E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171875,
    stopColor: "#2770DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#2870DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#286FDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#296EDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#296DDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#2A6DDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265625,
    stopColor: "#2A6CDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#2B6BDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296875,
    stopColor: "#2B6BDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#2C6ADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    stopColor: "#2C69DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#2D68D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.351562,
    stopColor: "#2D68D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#2D67D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367188,
    stopColor: "#2E67D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#2E66D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.382812,
    stopColor: "#2E65D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#2F65D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.398437,
    stopColor: "#2F64D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#2F64D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414062,
    stopColor: "#3063D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "#3062D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.429687,
    stopColor: "#3162D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#3161D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445312,
    stopColor: "#3161D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#3260D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460937,
    stopColor: "#325FD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#325FD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476562,
    stopColor: "#335ED2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#335ED2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492188,
    stopColor: "#335DD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#345CD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507812,
    stopColor: "#345CD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#345BD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523437,
    stopColor: "#355AD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#355AD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539062,
    stopColor: "#3559CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#3659CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554688,
    stopColor: "#3658CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#3657CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.570312,
    stopColor: "#3757CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#3756CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585937,
    stopColor: "#3856CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#3855CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601562,
    stopColor: "#3854CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#3954CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617188,
    stopColor: "#3953CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#3953CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632812,
    stopColor: "#3A52CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#3A51CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648437,
    stopColor: "#3A51CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#3B50C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664062,
    stopColor: "#3B50C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#3B4FC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679687,
    stopColor: "#3C4EC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#3C4EC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695312,
    stopColor: "#3D4DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#3D4CC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.710937,
    stopColor: "#3D4BC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#3E4BC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726562,
    stopColor: "#3E4AC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#3F49C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742187,
    stopColor: "#3F48C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#4048C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.757812,
    stopColor: "#4047C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "#4146C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773437,
    stopColor: "#4145C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#4145C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789062,
    stopColor: "#4244C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#4243C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804687,
    stopColor: "#4342C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#4342BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.820312,
    stopColor: "#4441BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopColor: "#4440BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835937,
    stopColor: "#453FBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "#453FBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851562,
    stopColor: "#453EBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "#463DBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867187,
    stopColor: "#463CBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#473BBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882812,
    stopColor: "#473BBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.890625,
    stopColor: "#483ABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898437,
    stopColor: "#4839B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90625,
    stopColor: "#4938B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.914062,
    stopColor: "#4938B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.921875,
    stopColor: "#4A37B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.929687,
    stopColor: "#4A36B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    stopColor: "#4A35B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.945312,
    stopColor: "#4B35B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.953125,
    stopColor: "#4B34B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.960938,
    stopColor: "#4C33B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96875,
    stopColor: "#4C32B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.976562,
    stopColor: "#4D32B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "#4D31B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.992187,
    stopColor: "#4E30B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E2FB2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_39_780"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 530,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_39_780"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 9,
    fill: "white",
    transform: "translate(140 365)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_39_780"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 11.25,
    fill: "white",
    transform: "translate(544 305)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroWebDevelopment);
export default __webpack_public_path__ + "static/media/hero-web-development.6c00e590de858aacb88b6343f1ea667d.svg";
export { ForwardRef as ReactComponent };